export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

/** Input for accepting provider terms */
export type AcceptTermsInput = {
  totalVersion: Scalars['Int']['input'];
};

/** Achieved Value */
export type AchievedValue = {
  __typename?: 'AchievedValue';
  metBetObjective: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Active and upcoming tournaments */
export type ActiveTournaments = {
  __typename?: 'ActiveTournaments';
  /** Currently active tournaments (active/locked status) */
  active?: Maybe<Array<Tournament>>;
  /** Recently completed tournaments */
  completed?: Maybe<Array<Tournament>>;
  /** Upcoming tournaments (open/forming status) */
  upcoming?: Maybe<Array<Tournament>>;
};

/** Result of the standalone advisory address verification. */
export type AddressValidationResult = {
  __typename?: 'AddressValidationResult';
  normalizedAddress?: Maybe<PredictionNormalizedAddress>;
  status: AddressValidationStatus;
};

/**
 * Verdict from the standalone address verification read. UNAVAILABLE means
 * the validator had no opinion (outage, unrecognised provider status, or a
 * source with no validation facility) — advisory callers must not block on it.
 */
export enum AddressValidationStatus {
  CORRECTED = 'CORRECTED',
  MISSING_SECONDARY = 'MISSING_SECONDARY',
  NOT_FOUND = 'NOT_FOUND',
  UNAVAILABLE = 'UNAVAILABLE',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  VERIFIED = 'VERIFIED'
}

export type AdminUpdateUserPasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type AdyenAchDetails = {
  __typename?: 'AdyenAchDetails';
  bankAccountType?: Maybe<Scalars['String']['output']>;
  bankSummary?: Maybe<Scalars['String']['output']>;
};

export type AdyenApp = {
  __typename?: 'AdyenApp';
  /** The unique identifier of this app, to submit in requests to /payments */
  id: Scalars['String']['output'];
  /** A localized name of the app */
  name: Scalars['String']['output'];
};

export type AdyenApplePayDetails = {
  __typename?: 'AdyenApplePayDetails';
  brand?: Maybe<Scalars['String']['output']>;
  cardSummary?: Maybe<Scalars['String']['output']>;
  fundingSource?: Maybe<Scalars['String']['output']>;
  tokenTxVariant?: Maybe<Scalars['String']['output']>;
};

export type AdyenCardDetails = {
  __typename?: 'AdyenCardDetails';
  brand?: Maybe<Scalars['String']['output']>;
  cardBin?: Maybe<Scalars['String']['output']>;
  cardSummary?: Maybe<Scalars['String']['output']>;
  fundingSource?: Maybe<Scalars['String']['output']>;
};

export type AdyenCashappDetails = {
  __typename?: 'AdyenCashappDetails';
  cashtag?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
};

export type AdyenDetails = {
  /** Payment method data from Adyen components, converted into a string */
  paymentMethod: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export type AdyenGroup = {
  __typename?: 'AdyenGroup';
  /** The name of the group */
  name: Scalars['String']['output'];
  /** Echo data to be used if the payment method is displayed as part of this group */
  paymentMethodData?: Maybe<Scalars['String']['output']>;
  /** The unique code of the group */
  type: Scalars['String']['output'];
};

export type AdyenIssuer = {
  __typename?: 'AdyenIssuer';
  /** A boolean value indicating whether this issuer is unavailable. Can be true whenever the issuer is offline */
  disabled: Scalars['Boolean']['output'];
  /** The unique identifier of this issuer, to submit in requests to /payments */
  id: Scalars['String']['output'];
  /** A localized name of the issuer */
  name: Scalars['String']['output'];
};

export type AdyenPaymentMethodConfiguration = {
  __typename?: 'AdyenPaymentMethodConfiguration';
  clientId?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  scopeId?: Maybe<Scalars['String']['output']>;
};

export type AdyenPaypalDetails = {
  __typename?: 'AdyenPaypalDetails';
  payerId?: Maybe<Scalars['String']['output']>;
  paypalEmail?: Maybe<Scalars['String']['output']>;
};

export type AdyenProviderDetails = {
  __typename?: 'AdyenProviderDetails';
  achDetails?: Maybe<AdyenAchDetails>;
  applePayDetails?: Maybe<AdyenApplePayDetails>;
  cardDetails?: Maybe<AdyenCardDetails>;
  cashappDetails?: Maybe<AdyenCashappDetails>;
  paymentMethodType: Scalars['String']['output'];
  paypalDetails?: Maybe<AdyenPaypalDetails>;
  storedPaymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type Apex = {
  __typename?: 'Apex';
  gameSlug: Scalars['String']['output'];
  lastSessionStartDate?: Maybe<Scalars['String']['output']>;
  legendUsed?: Maybe<Scalars['String']['output']>;
  map: Scalars['String']['output'];
  matchEndDate?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  platformSlug: Scalars['String']['output'];
  playerArenaRankScoreChange?: Maybe<Scalars['String']['output']>;
  playerDamage?: Maybe<Scalars['String']['output']>;
  playerHeadshots?: Maybe<Scalars['String']['output']>;
  playerKills?: Maybe<Scalars['String']['output']>;
  playerLevel?: Maybe<Scalars['String']['output']>;
  playerRankScoreChange?: Maybe<Scalars['String']['output']>;
  playerTimesPlacedTopThree?: Maybe<Scalars['String']['output']>;
  userIdentifier: Scalars['String']['output'];
};

export type ArcRaiders = {
  __typename?: 'ArcRaiders';
  gameSlug: Scalars['String']['output'];
};

/** Represents base is_admin response */
export type AuthIsAdminResult = {
  __typename?: 'AuthIsAdminResult';
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  verificationCode?: Maybe<Scalars['String']['output']>;
};

export type AuthenticateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticationMutationOutput = Node & {
  __typename?: 'AuthenticationMutationOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  result?: Maybe<AuthenticationResult>;
};

/** Represents a cod authentication result. */
export type AuthenticationResult = Node & {
  __typename?: 'AuthenticationResult';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  user: User;
};

/** An available instant tournament slot */
export type AvailableTournament = {
  __typename?: 'AvailableTournament';
  /** Current player count */
  currentPlayers: Scalars['Int']['output'];
  /** Entry fee amount */
  entryFee: Scalars['String']['output'];
  /** Time allowed until tournament has to fill */
  fillDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  /** Maximum players in tournament */
  maxPlayers: Scalars['Int']['output'];
  /** Number of places that receive prizes */
  placesPaid: Scalars['Int']['output'];
  /** Prize distribution by rank */
  prizeDistribution?: Maybe<Array<PrizeDistributionEntry>>;
  /** Projected prize pool */
  prizePool: Scalars['Float']['output'];
  /** Skill tier for this slot */
  skillTier: Scalars['String']['output'];
  /** Available spots */
  spotsRemaining: Scalars['Int']['output'];
  /** ID of existing FILLING tournament, null if projected */
  tournamentId?: Maybe<Scalars['ID']['output']>;
};

/** Available balance types for players */
export enum BalanceType {
  /** The player's bet credits balance */
  BET_CREDITS = 'BET_CREDITS',
  /** The player's main PL balance */
  PL_BALANCE = 'PL_BALANCE',
  /** The player's prediction market balance */
  PREDICTION_BALANCE = 'PREDICTION_BALANCE',
  /** The player's prediction market promotional credits */
  PREDICTION_BET_CREDITS = 'PREDICTION_BET_CREDITS'
}

export type Battlefield6 = {
  __typename?: 'Battlefield6';
  gameSlug: Scalars['String']['output'];
};

export enum BetDisplayOptions {
  /** a numeric representation with 2 significant figures i.e. 2.12 */
  DECIMAL_2SF = 'DECIMAL_2SF',
  /** a numeric representation i.e. 1000 */
  NUMBER = 'NUMBER',
  /** an ordinal representation i.e. 1st */
  ORDINAL = 'ORDINAL',
  /** a percentage representation i.e. 35% */
  PERCENTAGE = 'PERCENTAGE',
  /** a text representation i.e. 'win the game' */
  TEXT = 'TEXT'
}

/** Paginated response for bet history */
export type BetHistoryResponse = {
  __typename?: 'BetHistoryResponse';
  /** Array of Bet slips */
  betSlips?: Maybe<Array<Maybe<BetSlip>>>;
  /** Pagination information */
  metaData: PaginationDetails;
};

/** A Bet Item */
export type BetItem = Node & {
  __typename?: 'BetItem';
  /** Achieved Multiplier */
  achievedMultiplier?: Maybe<Scalars['String']['output']>;
  /** Result user achieved in game */
  achievedValue?: Maybe<Scalars['String']['output']>;
  /** Amount wagered for bet */
  betAmount?: Maybe<Scalars['String']['output']>;
  /** Type of bet */
  betType?: Maybe<BetTypeEnum>;
  /** Type of currency user for bet item */
  currencyType?: Maybe<Scalars['String']['output']>;
  /** Events */
  events?: Maybe<Array<Maybe<BetItemEvent>>>;
  /** the player's funding sources for this Item */
  fundingSources?: Maybe<Array<Maybe<Financials>>>;
  /** Additional game information */
  gameData?: Maybe<GameData>;
  /** Game */
  gameSlug?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** Bet Item created at */
  insertedAt?: Maybe<Scalars['String']['output']>;
  /** Bet Item level taken */
  level?: Maybe<Scalars['Int']['output']>;
  /** Value needed to win item */
  linesValue?: Maybe<Scalars['String']['output']>;
  /** Full match data from DSS for this bet item */
  matchData?: Maybe<Scalars['Json']['output']>;
  /** Id of match that item was resolved with */
  matchId?: Maybe<Scalars['String']['output']>;
  /** Typed Matches */
  matchStats?: Maybe<Array<Maybe<GameUnion>>>;
  /** Matches */
  matches?: Maybe<Scalars['Json']['output']>;
  /** metadata containing things such as parlay information */
  metadata: BetItemMetadata;
  /** Payout value */
  payout?: Maybe<Scalars['String']['output']>;
  /** Payouts List */
  payoutAmounts?: Maybe<Array<Maybe<Financials>>>;
  /** Payout Multiplier */
  payoutMultiplier?: Maybe<Scalars['String']['output']>;
  /** Percentage of bet */
  percentageOfBet?: Maybe<Scalars['String']['output']>;
  /** Currency type used for refund */
  refundCurrencyType?: Maybe<Scalars['String']['output']>;
  /** Reason why the item has been refunded */
  refundReason?: Maybe<Scalars['String']['output']>;
  /** Has the item been refunded */
  refunded?: Maybe<Scalars['Boolean']['output']>;
  /** How is the item being resolved */
  resolutionMethod?: Maybe<Scalars['String']['output']>;
  /** Has the item resolved */
  resolved?: Maybe<Scalars['Boolean']['output']>;
  /** Display title for this bet item from the lines service; falls back to type when not set */
  title?: Maybe<Scalars['String']['output']>;
  /** Type of bet that was placed */
  type?: Maybe<Scalars['String']['output']>;
  /** Last updated at */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Did the user win this bet item */
  won?: Maybe<Scalars['Boolean']['output']>;
};

/** Adjustments that have occurred to a bet item */
export type BetItemAdjustment = {
  __typename?: 'BetItemAdjustment';
  adjustedBy: Scalars['String']['output'];
  adjustmentReason: Scalars['String']['output'];
  betItemId: Scalars['ID']['output'];
  betSlipAdjustmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  newAchievedValue: Scalars['String']['output'];
  newPayouts: Array<Financials>;
  newWon: Scalars['Boolean']['output'];
  oldAchievedValue: Scalars['String']['output'];
  oldPayouts: Array<Financials>;
  oldWon: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Bounty Range */
export type BetItemBountyRange = {
  __typename?: 'BetItemBountyRange';
  linesValue: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Events */
export type BetItemEvent = {
  __typename?: 'BetItemEvent';
  event?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Bet_item_metadata */
export type BetItemMetadata = {
  __typename?: 'BetItemMetadata';
  multiGameParlay?: Maybe<MultiGameParlay>;
  singleGameBounty?: Maybe<Bounty>;
  singleGameParlay?: Maybe<Parlay>;
  specialRules?: Maybe<Array<Maybe<SpecialRules>>>;
  specialRulesApplied?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Twitch VOD information for this bet item, when present */
  vodInfo?: Maybe<VodInfo>;
};

/** Ranges */
export type BetItemRange = {
  __typename?: 'BetItemRange';
  /** Increments that a user must achieve to get a payout. I.e every 2 kills, 500 damage */
  bountyIncrement: Scalars['String']['output'];
  /** min and max range values */
  bountyRange: Array<Maybe<BetItemBountyRange>>;
  /** How many times can get paid for this range. */
  bountyTimesAchievable: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier?: Maybe<Scalars['String']['output']>;
};

/** Represents a selection of related bets */
export type BetLineItem = {
  __typename?: 'BetLineItem';
  betType: BetType;
  category: Scalars['String']['output'];
  cost: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lineType: Scalars['String']['output'];
  multiGameTeamParlayOptions: Array<MultiGameTeamParlayOption>;
  options: Array<Option>;
  required: Scalars['Boolean']['output'];
  singleGameBountyOptions: Array<SingleGameTeamBountyOption>;
  singleGameOptions: Array<BetOption>;
  singleGameTeamParlayOptions: Array<ParlayBetOption>;
  title: Scalars['String']['output'];
};

/** A single option for a bet */
export type BetOption = {
  __typename?: 'BetOption';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Bet level */
  level: Scalars['String']['output'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String']['output'];
  /** If the bet should be selected */
  selected: Scalars['Boolean']['output'];
  /** The title of the bet option */
  title: Scalars['String']['output'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
  /** The amount won on the bet */
  win: Scalars['String']['output'];
};

export type BetRestriction = {
  __typename?: 'BetRestriction';
  lockState: LockState;
  valueId: Scalars['String']['output'];
};

/** A Bet Slip */
export type BetSlip = Node & {
  __typename?: 'BetSlip';
  /** Achieved multiplier for the bet slip */
  achievedMultiplier?: Maybe<Scalars['String']['output']>;
  /** All bet slips sharing this slip's group_bet_id, returned as a single mmp_group. Includes the current slip — the FE filters it out as needed. */
  associatedMmps?: Maybe<MmpGroup>;
  /** Bet items/lines */
  betItems: Array<Maybe<BetItem>>;
  /** Adjustments that have been made to this bet slip */
  betSlipAdjustments?: Maybe<Array<BetSlipAdjustment>>;
  /** Total amount wagered */
  betTotalAmount: Scalars['String']['output'];
  /** Combo bets (parlays/accumulators) that include this bet slip */
  comboBets?: Maybe<Array<Maybe<ParlayProduct>>>;
  /** Game the bet slip is for */
  gameSlug?: Maybe<Scalars['String']['output']>;
  /** Correlation ID for the bet */
  groupBetId?: Maybe<Scalars['ID']['output']>;
  /** Does this bet slip contain a mystery bet */
  hasMysteryItem?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** When was the bet created */
  insertedAt: Scalars['String']['output'];
  /** Maximum multiplier for the bet slip */
  maximumMultiplier?: Maybe<Scalars['String']['output']>;
  /** Total the user won from bet slip */
  payout?: Maybe<Scalars['String']['output']>;
  /** Payouts List */
  payoutAmounts?: Maybe<Array<Maybe<Financials>>>;
  /** Why was this bet slip refunded */
  refundReason?: Maybe<Scalars['String']['output']>;
  /** Bet slip resolved at */
  resolvedAt?: Maybe<Scalars['String']['output']>;
  /** Service fee */
  serviceFee: Scalars['String']['output'];
  /** Staking offer for slip */
  stakeOffer?: Maybe<StakeOffer>;
  /** Status of the bet slip */
  status: Scalars['String']['output'];
  /** Reason for status */
  statusReason?: Maybe<Scalars['String']['output']>;
  /** Does this bet slip contain a sweepstake ticket */
  sweepstakeTicket?: Maybe<Scalars['String']['output']>;
  /** The team the bet was placed as part of */
  team?: Maybe<Team>;
  /** Tournaments this bet slip is part of */
  tournaments?: Maybe<Array<Maybe<Tournament>>>;
  /** Bet slip last updated at */
  updatedAt: Scalars['String']['output'];
  /** Bet slip owner */
  user: User;
  /** Bet Form By betslip game */
  userGameStatistics?: Maybe<UserGameStatistics>;
};

/** Adjustments that have occurred to a bet slip */
export type BetSlipAdjustment = {
  __typename?: 'BetSlipAdjustment';
  adjustedBy: Scalars['String']['output'];
  adjustmentReason: Scalars['String']['output'];
  betItemAdjustments: Array<BetItemAdjustment>;
  betSlipId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  metadata?: Maybe<BetSlipAdjustmentMetadata>;
  newPayout: Scalars['String']['output'];
  newPayouts: Array<Financials>;
  newStatus: Scalars['String']['output'];
  oldPayout: Scalars['String']['output'];
  oldPayouts: Array<Financials>;
  oldStatus: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Additional metadata for bet slip adjustments */
export type BetSlipAdjustmentMetadata = {
  __typename?: 'BetSlipAdjustmentMetadata';
  outstandingAmounts?: Maybe<Array<Financials>>;
};

export enum BetSlipForm {
  /** Net loss on bet slip */
  L = 'L',
  /** Bet slip voided by admin */
  V = 'V',
  /** Net win on bet slip */
  W = 'W'
}

export enum BetType {
  /** a bet covering multiple games */
  MULTI_GAME = 'MULTI_GAME',
  /** a parlay bet covering multiple games */
  MULTI_GAME_TEAM_PARLAY = 'MULTI_GAME_TEAM_PARLAY',
  /** a bet covering a single game */
  SINGLE_GAME = 'SINGLE_GAME',
  /** a bet where a user can win in a range of payouts */
  SINGLE_GAME_BOUNTY = 'SINGLE_GAME_BOUNTY',
  /** a bet covering a single game, where multiple options can be chosen */
  SINGLE_GAME_TEAM_MULTI_OPTION = 'SINGLE_GAME_TEAM_MULTI_OPTION',
  /** a single game parlay bet */
  SINGLE_GAME_TEAM_PARLAY = 'SINGLE_GAME_TEAM_PARLAY',
  /** a bet covering a single game, where a single option can be chosen */
  SINGLE_GAME_TEAM_SINGLE_OPTION = 'SINGLE_GAME_TEAM_SINGLE_OPTION',
  /** a solo bet */
  SOLO = 'SOLO'
}

export enum BetTypeEnum {
  /** Multi-game Parlay type bets */
  MULTI_GAME_PARLAY = 'MULTI_GAME_PARLAY',
  /** Bounty type bets */
  SINGLE_GAME_BOUNTY = 'SINGLE_GAME_BOUNTY',
  /** Single item type bets */
  SINGLE_GAME_ITEM = 'SINGLE_GAME_ITEM',
  /** Parlay type bets */
  SINGLE_GAME_PARLAY = 'SINGLE_GAME_PARLAY'
}

/** Bounty */
export type Bounty = {
  __typename?: 'Bounty';
  ranges: Array<Maybe<BetItemRange>>;
};

/** Bounty Range */
export type BountyRange = {
  __typename?: 'BountyRange';
  /** Increments that a user must achieve to get a payout. I.e every 2 kills, 500 damage */
  bountyIncrement: Scalars['String']['output'];
  /** min and max range values */
  bountyRange: Array<Maybe<Range>>;
  /** How many times can get paid for this range. */
  bountyTimesAchievable: Scalars['String']['output'];
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String']['output'];
};

/** Bracket entry representing a user's participation in a bracket */
export type BracketEntry = {
  __typename?: 'BracketEntry';
  /** ISO timestamp when user entered */
  entryTimestamp: Scalars['String']['output'];
  gamesPlayedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** True if user is tied with others at this rank */
  isTied: Scalars['Boolean']['output'];
  meetsMinimumRequirement: Scalars['Boolean']['output'];
  /** Calculated prize based on current rank (top 10 only) */
  projectedPrize?: Maybe<Scalars['String']['output']>;
  /** Rank within bracket */
  rankInBracket?: Maybe<Scalars['Int']['output']>;
  /** Aggregate score breakdown across included games */
  scoreBreakdown?: Maybe<EntryScoreBreakdown>;
  skillTier?: Maybe<Scalars['String']['output']>;
  /** Total score achieved */
  totalScore: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

/** Bracket leaderboard with entries */
export type BracketLeaderboard = {
  __typename?: 'BracketLeaderboard';
  bracket: TournamentBracket;
  entries?: Maybe<Array<BracketEntry>>;
  pagination: PaginationMeta;
};

/** Input for bracket leaderboard */
export type BracketLeaderboardInput = {
  bracketId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tournamentId: Scalars['ID']['input'];
};

/** Base component value within a game breakdown group */
export type BreakdownBaseValue = {
  __typename?: 'BreakdownBaseValue';
  label: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  rawValue: Scalars['Float']['output'];
};

/** Cap adjustment emitted when score clamping changes the composite total */
export type BreakdownCapAdjustment = {
  __typename?: 'BreakdownCapAdjustment';
  label: Scalars['String']['output'];
  points: Scalars['Int']['output'];
};

/** Component (base or multiplier) within a breakdown group config */
export type BreakdownComponentConfig = {
  __typename?: 'BreakdownComponentConfig';
  expression: Scalars['String']['output'];
  label: Scalars['String']['output'];
  primaryMetricField?: Maybe<Scalars['String']['output']>;
};

/** Authoring config for a score breakdown group */
export type BreakdownGroupConfig = {
  __typename?: 'BreakdownGroupConfig';
  base: BreakdownComponentConfig;
  label: Scalars['String']['output'];
  multipliers?: Maybe<Array<BreakdownComponentConfig>>;
};

/** Multiplier component value within a game breakdown group */
export type BreakdownMultiplierValue = {
  __typename?: 'BreakdownMultiplierValue';
  factor: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  rawValue: Scalars['Float']['output'];
};

export type CancelBetByGroupBetIdInput = {
  groupBetId: Scalars['String']['input'];
};

/** A catalog market (list view). Prices on outcomes may be stale; use predictionMarketDetail for live prices. */
export type CatalogMarket = {
  __typename?: 'CatalogMarket';
  categoryName?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  heroRank?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isMainLine?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  lineGroup?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<MarketType>;
  outcomes?: Maybe<Array<Maybe<CatalogOutcome>>>;
  priceHistory?: Maybe<Array<Maybe<MarketPriceSnapshot>>>;
  priceSeries?: Maybe<PriceSeries>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  promotedUntil?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  stale: Scalars['Boolean']['output'];
  status: MarketStatus;
  strike?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalFilled?: Maybe<Scalars['String']['output']>;
};

/** An outcome on a catalog market. */
export type CatalogOutcome = {
  __typename?: 'CatalogOutcome';
  /**
   * The competitor this outcome backs — which side a moneyline position took.
   * Join it against predictionEvent.competitors[].competitorId.
   *
   * Same field, same join key and same null rules as marketOutcome.competitorId;
   * this is the catalog shape, reached via catalogMarket.outcomes and
   * predictionPosition.outcome. Null for outcomes with no competitor
   * (Over/Under, the draw, non-team markets). The market's competitor links
   * cannot answer this: a two-way moneyline links both teams.
   */
  competitorId?: Maybe<Scalars['ID']['output']>;
  externalId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastPriceChange?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceTiers?: Maybe<Array<Maybe<PriceTier>>>;
  restingLiquidity?: Maybe<Scalars['String']['output']>;
  totalLiquidity?: Maybe<Scalars['String']['output']>;
};

export type Cfb25 = {
  __typename?: 'Cfb25';
  gameSlug: Scalars['String']['output'];
};

export type Chess = {
  __typename?: 'Chess';
  gameSlug: Scalars['String']['output'];
};

/** A claimed external offer */
export type ClaimedExternalOffer = {
  __typename?: 'ClaimedExternalOffer';
  /** The date when the offer was claimed */
  claimedAt: Scalars['DateTime']['output'];
  /** The offer that was claimed */
  offer: ExternalOffer;
  /** The offer code provided by the partner */
  offerCode: Scalars['String']['output'];
  /** The id of the user who claimed the offer */
  userId: Scalars['ID']['output'];
};

export type ClashRoyale = {
  __typename?: 'ClashRoyale';
  gameSlug: Scalars['String']['output'];
};

export type Codbo1 = {
  __typename?: 'Codbo1';
  gameSlug: Scalars['String']['output'];
};

export type Codbo2 = {
  __typename?: 'Codbo2';
  gameSlug: Scalars['String']['output'];
};

export type Codbo6 = {
  __typename?: 'Codbo6';
  gameSlug: Scalars['String']['output'];
};

export type Codbo7 = {
  __typename?: 'Codbo7';
  gameSlug: Scalars['String']['output'];
};

export type Codmw3 = {
  __typename?: 'Codmw3';
  gameSlug: Scalars['String']['output'];
};

export type Codmw4 = {
  __typename?: 'Codmw4';
  gameSlug: Scalars['String']['output'];
};

export type Codwz2 = {
  __typename?: 'Codwz2';
  gameSlug: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  matchDuration?: Maybe<Scalars['String']['output']>;
  matchEndDate?: Maybe<Scalars['String']['output']>;
  matchId?: Maybe<Scalars['String']['output']>;
  matchMode?: Maybe<Scalars['String']['output']>;
  matchStartDate?: Maybe<Scalars['String']['output']>;
  matchWin?: Maybe<Scalars['Boolean']['output']>;
  playerGotFinalKill?: Maybe<Scalars['Boolean']['output']>;
  playerGotFlawlessVictory?: Maybe<Scalars['Boolean']['output']>;
  playerKills?: Maybe<Scalars['String']['output']>;
  playerPlacement?: Maybe<Scalars['String']['output']>;
  userIdentifier?: Maybe<Scalars['String']['output']>;
};

export enum CommunicationMethodType {
  /** Email address */
  EMAIL = 'EMAIL',
  /** Phone number */
  PHONE = 'PHONE'
}

export type CompleteRegistrationInput = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum ConditionalOrderAction {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum ConditionalOrderDirection {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW'
}

export enum ConditionalOrderStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  EXECUTING = 'EXECUTING',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FILLED = 'FILLED',
  TRIGGERED = 'TRIGGERED'
}

export enum ConditionalOrderType {
  LIMIT = 'LIMIT',
  STOP = 'STOP'
}

/** Input for confirming a parlay */
export type ConfirmParlayInput = {
  quantity: Scalars['String']['input'];
};

export type CreateAccountInput = {
  dob: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountStepOneInput = {
  dob: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountStepThreeInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a conditional (limit/stop) order. externalMarketId uses the event-scoped format; externalOutcomeId is the provider contract id. */
export type CreateConditionalOrderInput = {
  action: ConditionalOrderAction;
  balanceType?: InputMaybe<PredictionOrderBalanceType>;
  direction: ConditionalOrderDirection;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  externalMarketId: Scalars['String']['input'];
  externalOutcomeId: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  source: MarketSource;
  triggerPrice: Scalars['String']['input'];
  type: ConditionalOrderType;
};

export type CreateGameSpecificTeamInput = {
  associatedGameModes: Array<Scalars['String']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  gameData?: InputMaybe<GameDataInput>;
  gameMode?: InputMaybe<Scalars['String']['input']>;
  legacyBetCategory?: InputMaybe<Scalars['String']['input']>;
  maximumAllowedTeamSize?: InputMaybe<Scalars['Int']['input']>;
  modeTeamSize?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Template for onfido id verification */
export enum CreateOnfidoTemplateTrigger {
  /** deposit attempted over cumulative limit */
  CUMULATIVE_DEPOSIT = 'CUMULATIVE_DEPOSIT',
  /** deposit attempted */
  DEPOSIT = 'DEPOSIT',
  /** withdrawal attempted */
  WITHDRAWAL = 'WITHDRAWAL'
}

/** Template for onfido id verification, workflow */
export enum CreateOnfidoTemplateWorkflow {
  /** full idv verification */
  IDV = 'IDV'
}

/** Input for placing an order */
export type CreateOrderInput = {
  balanceType?: InputMaybe<PredictionOrderBalanceType>;
  expectedPrice: Scalars['String']['input'];
  externalMarketId: Scalars['String']['input'];
  externalOutcomeId: Scalars['String']['input'];
  /** Client-generated key (8-128 chars, e.g. a UUID) minted once per placement intent and reused verbatim on retries of that intent; the service dedupes on it. */
  idempotencyKey: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  /** Quote id from a prior orderEstimate; lets the backend skip re-pricing. */
  quoteId?: InputMaybe<Scalars['String']['input']>;
  /** Skip backend price validation (use only with a fresh quoteId). */
  skipPriceValidation?: InputMaybe<Scalars['Boolean']['input']>;
  source: MarketSource;
  /** Client-generated uuid identifying one trade-panel session, echoed from the estimates that preceded this order so the two can be correlated. Mint a new one per panel-open and per outcome change. */
  tradeSessionId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a parlay */
export type CreateParlayInput = {
  legs: Array<CreateParlayLegInput>;
  parlayAmount: Scalars['Float']['input'];
};

/** Input for creating a parlay leg */
export type CreateParlayLegInput = {
  externalId: Scalars['String']['input'];
  legType: ParlayLegType;
};

/** Input for creating a prediction market parlay quote */
export type CreatePredictionParlayInput = {
  legs: Array<PredictionParlayLegInput>;
  quantity: Scalars['String']['input'];
  source: MarketSource;
};

/**
 * Input for creating a provider user. Identity, address, and contact details are
 * sourced server-side from the user's stored pl-connect record — callers supply
 * only the target market source.
 */
export type CreateProviderUserInput = {
  source: MarketSource;
};

/**
 * Input for registering the current user with a provider using user-supplied
 * identity and address details. Use this when the user has NOT completed Frame
 * KYC (e.g. at signup). Email, phone, and their verified-at timestamps are
 * sourced server-side from the user's verified pl-connect record and cannot be
 * supplied here — the user must already have a verified email and phone.
 */
export type CreateProviderUserWithDetailsInput = {
  /**
   * The user saw the address_corrected suggestion for THIS exact address and
   * re-attests it as typed. Send true ONLY when the address fields are
   * unchanged since the suggestion arrived; accepts a `corrected` verdict on
   * the registration gate and never bypasses the hard rejections.
   */
  addressConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  dateOfBirth: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  source: MarketSource;
  ssnLastDigits: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type CreateUserInput = {
  battlenetPlatformUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  embarkPlatformUsername?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  plCoreUserId?: InputMaybe<Scalars['String']['input']>;
  psnPlatformUsername?: InputMaybe<Scalars['String']['input']>;
  xblPlatformUsername?: InputMaybe<Scalars['String']['input']>;
};

export type Cs2 = {
  __typename?: 'Cs2';
  gameSlug: Scalars['String']['output'];
};

export type DepositProviderResponse = {
  __typename?: 'DepositProviderResponse';
  /** Flag to denote if the provider is currently enabled for the platform */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the provider */
  id: Scalars['ID']['output'];
  /** Maximum transfer type amount for the provider */
  max: Scalars['String']['output'];
  /** Minimum transfer type amount for the provider */
  min: Scalars['String']['output'];
  /** Payment methods available for the provider */
  paymentMethods: Array<PaymentMethod>;
  /** Platform of the provider */
  platform: PlatformEnum;
  /** Provider name */
  provider: ProviderEnum;
  /** Stored payment methods for the user */
  storedPaymentMethods?: Maybe<Array<StoredPaymentMethod>>;
  /** Enum of the type of transfer being made. Currently Withdrawal or Deposit. */
  transferType: Scalars['String']['output'];
};

/** Individual entry for deposit refund information */
export type DepositRefundEntry = {
  __typename?: 'DepositRefundEntry';
  /** The deposit amount in cents */
  depositAmount?: Maybe<Scalars['String']['output']>;
  /** The provider reference for the deposit */
  depositProviderReference?: Maybe<Scalars['String']['output']>;
  /** The ID of the deposit transaction */
  depositTransactionId?: Maybe<Scalars['String']['output']>;
  /** The provider of the deposit */
  provider: ProviderEnum;
  /** The reason for the refund */
  refundReason?: Maybe<Scalars['String']['output']>;
  /** Who refunded this deposit */
  refundedBy?: Maybe<Scalars['String']['output']>;
  /** The related withdrawal payment status ID */
  relatedWithdrawalPaymentStatusId?: Maybe<Scalars['String']['output']>;
  /** The time of the refund */
  timeOfRefund?: Maybe<Scalars['String']['output']>;
  /** The total amount refunded in cents */
  totalAmountRefunded?: Maybe<Scalars['String']['output']>;
};

/** Array of refund information entries related to a deposit */
export type DepositRefundInfoArrayMetadata = {
  __typename?: 'DepositRefundInfoArrayMetadata';
  /** The deposit amount in cents */
  depositAmount: Scalars['String']['output'];
  /** The provider reference for the deposit */
  depositProviderReference?: Maybe<Scalars['String']['output']>;
  /** The deposit transaction ID */
  depositTransactionId: Scalars['String']['output'];
  /** The provider of the deposit */
  provider: ProviderEnum;
  /** A list of refund entries related to this deposit */
  refundEntries?: Maybe<Array<DepositRefundEntry>>;
  /** The total amount refunded in cents */
  totalAmountRefunded: Scalars['String']['output'];
};

/** The information returned for all deposit operations */
export type DepositResponse = {
  __typename?: 'DepositResponse';
  /** The amount (in cents) of the deposit request */
  amount: Scalars['Int']['output'];
  /** Payment creation date time */
  createdAt: Scalars['String']['output'];
  /** The ID of the deposit */
  id: Scalars['ID']['output'];
  /** Metadata related to the payment status */
  metadata?: Maybe<PaymentStatusMetadata>;
  /** The latest status of the deposit request */
  mostRecentStatus: Status;
  /** The platform for this request (currently only 'adyen' is supported) */
  provider: ProviderEnum;
  /** Payment provider details */
  providerDetails: PaymentProviderDetails;
  /** The provider's reference for the deposit */
  providerReference?: Maybe<Scalars['String']['output']>;
  /** Response data from the provider as a string. Must be parsed to JSON before being provided to Adyen FE components */
  providerResponse?: Maybe<Scalars['String']['output']>;
  /** Response data from provider for if the deposit had to be reversed as a string */
  providerReversalResponse?: Maybe<Scalars['String']['output']>;
  /** Payments API user details */
  user?: Maybe<PaymentUserDetails>;
};

export type Dota2 = {
  __typename?: 'Dota2';
  gameSlug: Scalars['String']['output'];
};

export type Eafc25 = {
  __typename?: 'Eafc25';
  gameSlug: Scalars['String']['output'];
};

export type Eafc26 = {
  __typename?: 'Eafc26';
  gameSlug: Scalars['String']['output'];
};

export type Eafc27 = {
  __typename?: 'Eafc27';
  gameSlug: Scalars['String']['output'];
};

/** Input for entering instant tournaments */
export type EnterInstantTournamentInput = {
  /** Bet slip identifier */
  betSlipId: Scalars['ID']['input'];
  /** Tournament selections to enter */
  selections: Array<InstantTournamentSelectionInput>;
};

/** Aggregate group within an entry-level score breakdown */
export type EntryBreakdownGroup = {
  __typename?: 'EntryBreakdownGroup';
  combinedPoints: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** Entry-level aggregated breakdown across the games that contributed to total score */
export type EntryScoreBreakdown = {
  __typename?: 'EntryScoreBreakdown';
  aggregateGroups: Array<EntryBreakdownGroup>;
  /** Reconciliation delta when aggregate groups don't sum to total (e.g. strategy weighting, rounding) */
  capAdjustment?: Maybe<BreakdownCapAdjustment>;
  computedAt: Scalars['String']['output'];
  contributingGameResultIds: Array<Scalars['ID']['output']>;
  gamesIncluded: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Represents errors from a query or mutation */
export type Errors = Node & {
  __typename?: 'Errors';
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/** Input for estimating an order (price/availability quote). */
export type EstimateOrderInput = {
  balanceType?: InputMaybe<PredictionOrderBalanceType>;
  externalMarketId: Scalars['String']['input'];
  externalOutcomeId: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  source: MarketSource;
  /** Client-generated uuid identifying one trade-panel session, sent on every estimate in that session and on the resulting order. Mint a new one per panel-open and per outcome change. */
  tradeSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type ExpediteTierConfig = {
  __typename?: 'ExpediteTierConfig';
  /** Flag to determine if the expedite tier considers free withdrawals logic | NOT IMPLEMENTED */
  allowFreeWithdrawal: Scalars['String']['output'];
  /** Flag to denote if the expedite tier is disabled. This will likely always be true */
  enabled: Scalars['Boolean']['output'];
  /** Expedite tier enum name */
  expediteTier: ExpediteTierEnum;
  /** Fee amount for the tier */
  fee: Scalars['String']['output'];
  /** The ID of the expedite tier item */
  id: Scalars['ID']['output'];
  /** Maximum time period for the withdrawal to be processed in for the tier */
  maxTimePeriod: Scalars['Int']['output'];
  /** Minimum time period for the withdrawal to be processed in for the tier */
  minTimePeriod: Scalars['Int']['output'];
  /** Platform enum name */
  platform: PlatformEnum;
  /** Provider name */
  provider: ProviderEnum;
  /** Public facing name for the expedite tier */
  readableName: Scalars['String']['output'];
};

export enum ExpediteTierEnum {
  /** Faster withdrawal method with higher fees */
  EXPEDITE = 'EXPEDITE',
  /** Slowest withdrawal method, but has no fees */
  FREE = 'FREE',
  /** Slower than standard */
  SLOW = 'SLOW',
  /** Withdrawal method with low fees */
  STANDARD = 'STANDARD'
}

/** An external available offer */
export type ExternalOffer = {
  __typename?: 'ExternalOffer';
  /** The start date of the offer */
  activeFrom: Scalars['DateTime']['output'];
  /** The end date of the offer */
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the offer */
  id: Scalars['ID']['output'];
  /** The image URL for the offer */
  image?: Maybe<Scalars['String']['output']>;
  /** The large image URL for the offer */
  largeImage?: Maybe<Scalars['String']['output']>;
  /** The name of the offer */
  name: Scalars['String']['output'];
  /** Whether the offer is a code or a url */
  offerType: OfferType;
  /** The partner associated with the offer */
  partner: ExternalPartner;
  /** The unique key to match localization phrases */
  phraseKey: Scalars['String']['output'];
  /** Whether the user has seen this offer */
  seen?: Maybe<Scalars['Boolean']['output']>;
  /** The URL to claim the offer, when the offerType is url and the url is static */
  url?: Maybe<Scalars['String']['output']>;
};

/** External Offers response */
export type ExternalOffersResponse = {
  __typename?: 'ExternalOffersResponse';
  /** List of available external offers */
  availableOffers?: Maybe<Array<Maybe<ExternalOffer>>>;
  /** List of claimed external offers */
  claimedOffers?: Maybe<Array<Maybe<ClaimedExternalOffer>>>;
};

/** Partner information for external offers and adverts */
export type ExternalPartner = {
  __typename?: 'ExternalPartner';
  /** The unique identifier for the partner */
  id: Scalars['ID']['output'];
  /** The name of the partner */
  name: Scalars['String']['output'];
};

/** An external partner ad */
export type ExternalPartnerAd = {
  __typename?: 'ExternalPartnerAd';
  /** The start date of the ad */
  activeFrom: Scalars['DateTime']['output'];
  /** The end date of the ad */
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  /** The image URL for the ad */
  bannerImageUrl: Scalars['String']['output'];
  /** The URL to redirect when the ad is clicked */
  bannerLink: Scalars['String']['output'];
  /** The name of the ad */
  bannerName: Scalars['String']['output'];
  /** Whether the ad is active */
  enabled: Scalars['Boolean']['output'];
  /** The unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The partner associated with the ad */
  partnerName: Scalars['String']['output'];
  /** The unique key to match localization phrases */
  phraseKey: Scalars['String']['output'];
  /** The subtitle content of the ad */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title content of the ad */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the ad */
  type: Scalars['String']['output'];
};

/** Represents a cod feature flag entity. */
export type Feature = Node & {
  __typename?: 'Feature';
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Fill action enumeration for instant tournaments that don't meet minimum fill percentage */
export enum FillAction {
  /** Start tournament with reduced prize pool based on actual entries */
  MODIFIED_PAYOUT = 'MODIFIED_PAYOUT',
  /** Refund all entries and cancel tournament */
  REFUND = 'REFUND'
}

export type FilterInput = {
  id?: InputMaybe<IdInput>;
};

export enum FilterStatus {
  /** Incomplete wagers */
  PENDING = 'pending',
  /** Completed wagers, includes won, lost and refunded */
  RESOLVED = 'resolved'
}

/** Represents a wallet for a user. */
export type Financials = {
  __typename?: 'Financials';
  amount: Scalars['Decimal']['output'];
  wallet: BalanceType;
};

export type FinancialsInput = {
  amount: Scalars['Decimal']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  wallet: BalanceType;
};

/** Metric definition within a scoring formula */
export type FormulaMetricDefinition = {
  __typename?: 'FormulaMetricDefinition';
  applyPowerHourMultiplier: Scalars['Boolean']['output'];
  direction: MetricDirection;
  field: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: MetricSource;
  validation?: Maybe<FormulaMetricValidation>;
};

/** Validation rules for a formula metric */
export type FormulaMetricValidation = {
  __typename?: 'FormulaMetricValidation';
  defaultValue?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

/** Validation rules for scoring formula output */
export type FormulaValidationRules = {
  __typename?: 'FormulaValidationRules';
  clampNegative?: Maybe<Scalars['Boolean']['output']>;
  maxScore?: Maybe<Scalars['Float']['output']>;
  minScore?: Maybe<Scalars['Float']['output']>;
};

export type Fortnite = {
  __typename?: 'Fortnite';
  gameSlug: Scalars['String']['output'];
};

export type FrameAccount = {
  __typename?: 'FrameAccount';
  accountStatus: Scalars['String']['output'];
  /** Status of the FRAME age_verification capability (e.g. "active"). Used to gate deposits. */
  ageVerification?: Maybe<Scalars['String']['output']>;
  capabilities?: Maybe<Scalars['Json']['output']>;
  frameAccountId: Scalars['String']['output'];
  kycStatus: Scalars['String']['output'];
};

export type FrameDetails = {
  /** Encrypted card payload (JSON string) from the Frame web card element change event */
  cardPayload?: InputMaybe<Scalars['String']['input']>;
  /** Return URL for web redirect after payment completion */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** Sonar fraud-detection session ID from the Frame web charge flow */
  sonarSessionId?: InputMaybe<Scalars['String']['input']>;
  /** Unbound payment method ID minted by the Frame web SDK (createPaymentMethod) */
  sourcePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** Transfer ID from the Frame SDK checkout flow */
  transferId?: InputMaybe<Scalars['String']['input']>;
};

export type FrameOnboardingSession = {
  __typename?: 'FrameOnboardingSession';
  accountId: Scalars['String']['output'];
  alreadyVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Client secret used to drive the embedded FRAME onboarding element */
  clientSecret?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Int']['output']>;
  onboardingUrl?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  /** Ordered list of onboarding steps the user must complete */
  steps?: Maybe<Scalars['Json']['output']>;
};

export type FrameProviderConfig = {
  __typename?: 'FrameProviderConfig';
  frameAccountId?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type FrameProviderDetails = {
  __typename?: 'FrameProviderDetails';
  bankAccountType?: Maybe<Scalars['String']['output']>;
  bankSummary?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLastFour?: Maybe<Scalars['String']['output']>;
  chargeIntentId?: Maybe<Scalars['String']['output']>;
  framePaymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentMethodType: Scalars['String']['output'];
  transferId?: Maybe<Scalars['String']['output']>;
};

export type Game2xko = {
  __typename?: 'Game2xko';
  gameSlug: Scalars['String']['output'];
};

/** Single group within a per-game score breakdown */
export type GameBreakdownGroup = {
  __typename?: 'GameBreakdownGroup';
  base: BreakdownBaseValue;
  combinedPoints: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  multipliers: Array<BreakdownMultiplierValue>;
};

/** Game Data */
export type GameData = {
  __typename?: 'GameData';
  apexLegend?: Maybe<Scalars['String']['output']>;
  gameMode?: Maybe<Scalars['String']['output']>;
  /** I.e Clan tag, to be used for games that support it/require it for twitch streaming */
  livenessCheck?: Maybe<LivenessCheck>;
  map?: Maybe<Scalars['String']['output']>;
  squadSize?: Maybe<Scalars['Int']['output']>;
};

export type GameDataInput = {
  gameMap?: InputMaybe<Scalars['String']['input']>;
  gameMode?: InputMaybe<Scalars['String']['input']>;
};

export type GameHistoryOutput = {
  __typename?: 'GameHistoryOutput';
  gameHistory?: Maybe<Array<Maybe<GameUnion>>>;
};

export type GameModeBetRestriction = {
  __typename?: 'GameModeBetRestriction';
  betRestrictions: Array<BetRestriction>;
  gameMode: Scalars['String']['output'];
};

/** Scoring formula assignment for a specific game mode */
export type GameModeFormula = {
  __typename?: 'GameModeFormula';
  formula?: Maybe<ScoringFormula>;
  gameMode: Scalars['String']['output'];
  scoringFormulaId: Scalars['ID']['output'];
  squadSize?: Maybe<Scalars['Int']['output']>;
};

export type GamePlatformStatus = {
  __typename?: 'GamePlatformStatus';
  game: Games;
  metadata: GamePlatformStatusMetadata;
  platform: Platforms;
  status: PlatformBettingStatus;
  /** Which game identifier does this betting status belong to. This can be either the token or the gamer tag */
  userIdentifier?: Maybe<Scalars['String']['output']>;
};

/** Metadata for a game platform */
export type GamePlatformStatusMetadata = {
  __typename?: 'GamePlatformStatusMetadata';
  betsPlaced?: Maybe<Scalars['Int']['output']>;
  betsPlacedMmb?: Maybe<Scalars['Int']['output']>;
  betsRefunded?: Maybe<Scalars['Int']['output']>;
  betsRefundedMmb?: Maybe<Scalars['Int']['output']>;
  betsSettled?: Maybe<Scalars['Int']['output']>;
  betsSettledMmb?: Maybe<Scalars['Int']['output']>;
  bettingFairPlayTermsAccepted?: Maybe<Scalars['Boolean']['output']>;
  character?: Maybe<Scalars['String']['output']>;
  damageBanner?: Maybe<Scalars['Boolean']['output']>;
  fetchFailReason?: Maybe<Scalars['String']['output']>;
  gamertagUpdatedCount?: Maybe<Scalars['Int']['output']>;
  initialFetchState?: Maybe<Scalars['String']['output']>;
  killsBanner?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  lastUserFetch?: Maybe<Scalars['String']['output']>;
  retryAttempts?: Maybe<Scalars['Int']['output']>;
  settledBetCounts?: Maybe<Array<Maybe<SettledBetCounts>>>;
  settledBetDenominationCounts?: Maybe<SettledBetDenominationCounts>;
  storedMatchCount?: Maybe<Scalars['String']['output']>;
  topThreeBanner?: Maybe<Scalars['Boolean']['output']>;
  totalMatchesBanner?: Maybe<Scalars['Boolean']['output']>;
  twitchAudioMuted?: Maybe<Scalars['Boolean']['output']>;
  twitchRequired?: Maybe<Scalars['Boolean']['output']>;
  twitchVodEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Game result for a tournament entry */
export type GameResult = {
  __typename?: 'GameResult';
  betAmount: Scalars['String']['output'];
  /** Full bet slip details */
  betSlip?: Maybe<BetSlip>;
  /** Reference to bet slip */
  betSlipId: Scalars['ID']['output'];
  /** How much this game contributed to total tournament score */
  contributionToScore: Scalars['String']['output'];
  finalMultiplier: Scalars['String']['output'];
  gameMode?: Maybe<Scalars['String']['output']>;
  gameModeMultiplier: Scalars['String']['output'];
  gameTimestamp: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** True if this result is included in the tournament scoring */
  includedInScore: Scalars['Boolean']['output'];
  /** True if result was voided by bet refund/adjustment */
  isSuperseded: Scalars['Boolean']['output'];
  /** Game metrics (kills, placement, damage, etc.) */
  metrics?: Maybe<Scalars['Json']['output']>;
  powerHourMultiplier: Scalars['String']['output'];
  /** Per-game score breakdown; null when breakdown is unavailable */
  scoreBreakdown?: Maybe<GameScoreBreakdown>;
};

/** Game results with pagination */
export type GameResultList = {
  __typename?: 'GameResultList';
  pagination: PaginationMeta;
  results?: Maybe<Array<GameResult>>;
};

/** Per-game score breakdown. Total equals the game's composite score. */
export type GameScoreBreakdown = {
  __typename?: 'GameScoreBreakdown';
  capAdjustment?: Maybe<BreakdownCapAdjustment>;
  groups: Array<GameBreakdownGroup>;
  total: Scalars['Int']['output'];
};

export type GameUnion = Apex | ArcRaiders | Battlefield6 | Cfb25 | Chess | ClashRoyale | Codbo1 | Codbo2 | Codbo6 | Codbo7 | Codmw3 | Codmw4 | Codwz2 | Cs2 | Dota2 | Eafc25 | Eafc26 | Eafc27 | Fortnite | Game2xko | Gta5 | Gta6 | Gwent | Hearthstone | LeagueOfLegends | Madden25 | Madden26 | Madden27 | MarvelRivals | MarvelTokon | Nba2k25 | Nba2k26 | Nba2k27 | R6Siege | RocketLeague | TeamfightTactics | Valorant | Wardogs;

export enum Games {
  /** APEX */
  APEX = 'apex',
  /** ARC RAIDERS */
  ARC_RAIDERS = 'arc_raiders',
  /** BATTLEFIELD 6 */
  BATTLEFIELD6 = 'battlefield6',
  /** COLLEGE FOOTBALL 25 */
  CFB25 = 'cfb25',
  /** COLLEGE FOOTBALL 26 */
  CFB26 = 'cfb26',
  /** COLLEGE FOOTBALL 27 */
  CFB27 = 'cfb27',
  /** COLLEGE FOOTBALL 28 */
  CFB28 = 'cfb28',
  /** CHESS */
  CHESS = 'chess',
  /** Clash Royale */
  CLASH_ROYALE = 'clash_royale',
  /** COD BLACK OPS 1 */
  CODBO1 = 'codbo1',
  /** COD BLACK OPS 2 */
  CODBO2 = 'codbo2',
  /** COD BLACK OPS 6 */
  CODBO6 = 'codbo6',
  /** COD BLACK OPS 7 */
  CODBO7 = 'codbo7',
  /** COD MODERN WARFARE 2 */
  CODMW2 = 'codmw2',
  /** COD MODERN WARFARE 3 */
  CODMW3 = 'codmw3',
  /** COD MODERN WARFARE 4 */
  CODMW4 = 'codmw4',
  /** COD WARZONE */
  CODWZ = 'codwz',
  /** COD WARZONE 2 */
  CODWZ2 = 'codwz2',
  /** CS2 */
  CS2 = 'cs2',
  /** CSGO */
  CSGO = 'csgo',
  /** CSGO2 */
  CSGO2 = 'csgo2',
  /** DOTA 2 */
  DOTA2 = 'dota2',
  /** EAFC 25 */
  EAFC25 = 'eafc25',
  /** EAFC 26 */
  EAFC26 = 'eafc26',
  /** EAFC 27 */
  EAFC27 = 'eafc27',
  /** EAFC 28 */
  EAFC28 = 'eafc28',
  /** FORTNITE */
  FORTNITE = 'fortnite',
  /** 2XKO */
  GAME_2XKO = 'game_2xko',
  /** GTA 5 */
  GTA5 = 'gta5',
  /** GTA 6 */
  GTA6 = 'gta6',
  /** GWENT */
  GWENT = 'gwent',
  /** HALO */
  HALO = 'halo',
  /** HEARTHSTONE */
  HEARTHSTONE = 'hearthstone',
  /** LEAGUE_OF_LEGENDS */
  LEAGUE_OF_LEGENDS = 'league_of_legends',
  /** MADDEN 25 */
  MADDEN25 = 'madden25',
  /** MADDEN 26 */
  MADDEN26 = 'madden26',
  /** MADDEN 27 */
  MADDEN27 = 'madden27',
  /** MADDEN 28 */
  MADDEN28 = 'madden28',
  /** MARVEL RIVALS */
  MARVEL_RIVALS = 'marvel_rivals',
  /** MARVEL TOKON */
  MARVEL_TOKON = 'marvel_tokon',
  /** MLB THE SHOW 26 */
  MLBTHESHOW26 = 'mlbtheshow26',
  /** NBA 2K25 */
  NBA2K25 = 'nba2k25',
  /** NBA 2K26 */
  NBA2K26 = 'nba2k26',
  /** NBA 2K27 */
  NBA2K27 = 'nba2k27',
  /** NBA 2K28 */
  NBA2K28 = 'nba2k28',
  /** RAINBOW SIX SIEGE */
  R6_SIEGE = 'r6_siege',
  /** ROCKET LEAGUE */
  ROCKET_LEAGUE = 'rocket_league',
  /** TEAMFIGHT TACTICS */
  TEAMFIGHT_TACTICS = 'teamfight_tactics',
  /** VALORANT */
  VALORANT = 'valorant',
  /** WARDOGS */
  WARDOGS = 'wardogs'
}

export type GenericUserMutationOutput = Node & {
  __typename?: 'GenericUserMutationOutput';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  user: User;
};

export type GetFeatureFlagInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type Gta5 = {
  __typename?: 'Gta5';
  gameSlug: Scalars['String']['output'];
};

export type Gta6 = {
  __typename?: 'Gta6';
  gameSlug: Scalars['String']['output'];
};

export type Gwent = {
  __typename?: 'Gwent';
  gameSlug: Scalars['String']['output'];
};

export type Hearthstone = {
  __typename?: 'Hearthstone';
  gameSlug: Scalars['String']['output'];
};

export type IdInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type InsertSpecialRuleUserInput = {
  rules?: InputMaybe<Array<InputMaybe<SpecialRuleUserInput>>>;
};

/** Response for available instant tournaments */
export type InstantTournamentAvailable = {
  __typename?: 'InstantTournamentAvailable';
  /** Available tournament slots */
  availableTournaments: Array<AvailableTournament>;
  /** Deduplicated list of entry fees across all configs */
  entryFees: Array<Scalars['String']['output']>;
};

/** Response for entering instant tournaments */
export type InstantTournamentEnterResult = {
  __typename?: 'InstantTournamentEnterResult';
  /** Results for each selection */
  entries: Array<InstantTournamentEntryResult>;
};

/** Result for a single instant tournament entry attempt */
export type InstantTournamentEntryResult = {
  __typename?: 'InstantTournamentEntryResult';
  /** Entry fee amount */
  entryFee: Scalars['String']['output'];
  /** Status: charged, failed, etc. */
  entryFeeStatus: Scalars['String']['output'];
  /** Entry ID, null if entry failed */
  entryId?: Maybe<Scalars['ID']['output']>;
  /** Error message if entry failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Tournament ID, null if entry failed */
  tournamentId?: Maybe<Scalars['ID']['output']>;
  /** Wallet transaction ID */
  transactionId?: Maybe<Scalars['String']['output']>;
};

/** A single tournament selection for entry */
export type InstantTournamentSelectionInput = {
  /** Entry fee for this tournament */
  entryFee: Scalars['Float']['input'];
  /** Max players in tournament (minimum 2) */
  maxPlayers: Scalars['Int']['input'];
  /** Specific tournament to join (optional) */
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Provider KYC decision. PHOTO_VERIFICATION_PROCESSING is an in-flight state
 * (ProphetX is still adjudicating a submitted photo), not a decision — clients
 * must treat it as "no answer yet", the same as PENDING, and never as a
 * terminal outcome.
 */
export enum KycStatus {
  FAILURE = 'FAILURE',
  MORTALITY = 'MORTALITY',
  OFAC = 'OFAC',
  PENDING = 'PENDING',
  PEP = 'PEP',
  PHOTO_VERIFICATION_PROCESSING = 'PHOTO_VERIFICATION_PROCESSING',
  SUCCESS = 'SUCCESS'
}

/**
 * A short-lived, user-scoped provider token for the embedded KYC document-capture
 * flow. The token is OPAQUE — hand it to the ProphetX SDK unmodified; never decode,
 * log, or cache it. On expiry, re-run this query (the SDK's onSessionExpired hook).
 */
export type KycStepUpToken = {
  __typename?: 'KycStepUpToken';
  /** Absolute ISO-8601 expiry reported by the provider, or null if none. */
  expiresAt?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type LeagueOfLegends = {
  __typename?: 'LeagueOfLegends';
  gameSlug: Scalars['String']['output'];
};

/** Represents a cod line entity. */
export type Line = Node & {
  __typename?: 'Line';
  goal: Scalars['Int']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  payout: Scalars['Decimal']['output'];
};

export type ListUsersOutput = Node & {
  __typename?: 'ListUsersOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  results?: Maybe<User>;
};

/** liveness check */
export type LivenessCheck = {
  __typename?: 'LivenessCheck';
  colour?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  uniqueCode?: Maybe<Scalars['String']['output']>;
};

export enum LockState {
  /** Bet Denomination follows default unlock restrictions for this user */
  DEFAULT = 'DEFAULT',
  /** Bet Denomination is locked to the user */
  LOCKED = 'LOCKED',
  /** Bet Denomination is unlocked to the user, without any restrictions */
  UNLOCKED = 'UNLOCKED'
}

/** User locked status */
export type LockedStatus = {
  __typename?: 'LockedStatus';
  reason: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type Madden25 = {
  __typename?: 'Madden25';
  gameSlug: Scalars['String']['output'];
};

export type Madden26 = {
  __typename?: 'Madden26';
  gameSlug: Scalars['String']['output'];
};

export type Madden27 = {
  __typename?: 'Madden27';
  gameSlug: Scalars['String']['output'];
};

/** An outcome (side) within a market */
export type MarketOutcome = {
  __typename?: 'MarketOutcome';
  /**
   * The competitor this outcome backs — which side a moneyline order took.
   * Join it against predictionEvent.competitors[].competitorId.
   *
   * Null for outcomes with no competitor (Over/Under, the draw, non-team
   * markets), and null on every row until the upstream column that populates
   * it ships. The market's competitor links cannot answer this: a two-way
   * moneyline links both teams.
   */
  competitorId?: Maybe<Scalars['ID']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OutcomeStatus>;
};

/** A price snapshot for a market (from the sync cycle). */
export type MarketPriceSnapshot = {
  __typename?: 'MarketPriceSnapshot';
  capturedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  marketId: Scalars['ID']['output'];
  outcomePrices?: Maybe<Scalars['Json']['output']>;
};

export enum MarketSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum MarketSource {
  INTERNAL = 'INTERNAL',
  KALSHI = 'KALSHI',
  PROPHETX = 'PROPHETX'
}

export enum MarketStatus {
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  SETTLED = 'SETTLED'
}

export enum MarketType {
  MONEYLINE = 'MONEYLINE',
  OTHER = 'OTHER',
  PLAYER_PROP = 'PLAYER_PROP',
  SPREAD = 'SPREAD',
  TOTAL = 'TOTAL'
}

export type MarvelRivals = {
  __typename?: 'MarvelRivals';
  gameSlug: Scalars['String']['output'];
};

export type MarvelTokon = {
  __typename?: 'MarvelTokon';
  gameSlug: Scalars['String']['output'];
};

export type MatchDataResponse = {
  __typename?: 'MatchDataResponse';
  scheduledFetch?: Maybe<Scalars['Boolean']['output']>;
};

/** Metric direction enumeration */
export enum MetricDirection {
  HIGHER = 'higher',
  LOWER = 'lower'
}

/** Metric source enumeration */
export enum MetricSource {
  BET_DATA = 'bet_data',
  COMPUTED = 'computed',
  GAME_METRICS = 'game_metrics'
}

/** A group of bet slips that share the same group_bet_id */
export type MmpGroup = {
  __typename?: 'MmpGroup';
  /** All bet slips placed under this group_bet_id (includes the parent slip) */
  betSlips: Array<BetSlip>;
  /** The group_bet_id correlating these bet slips */
  groupBetId: Scalars['ID']['output'];
};

/** Multi-Game Parlay */
export type MultiGameParlay = {
  __typename?: 'MultiGameParlay';
  failuresAllowed: Scalars['Int']['output'];
  legs: Array<MultiGameParlayLeg>;
  payouts: Array<MultiGameTeamPayout>;
  requirements: Array<ParlayBetItem>;
  successesRequired: Scalars['Int']['output'];
};

/** Multi-Game Parlay Leg (e.g. match, round) */
export type MultiGameParlayLeg = {
  __typename?: 'MultiGameParlayLeg';
  achievedValue: Array<AchievedValue>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  matchId?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  status: MultiGameParlayStatusEnum;
  updatedAt: Scalars['String']['output'];
};

export enum MultiGameParlayStatusEnum {
  /** Multi-game parlay has been won or lost already; this leg is no longer relevant */
  CANCELLED = 'cancelled',
  /** Leg has been lost */
  LOST = 'lost',
  /** Leg has not been played yet */
  PENDING = 'pending',
  /** Leg has been won */
  WON = 'won'
}

/** A multi-game parlay bet option */
export type MultiGameTeamParlayOption = {
  __typename?: 'MultiGameTeamParlayOption';
  /** The number of failures allowed before the bet is lost */
  failuresAllowed: Scalars['Int']['output'];
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Bet level */
  level: Scalars['String']['output'];
  /** Payouts */
  payouts: Array<MultiGameTeamPayout>;
  /** Parlay requirements */
  requirements: Array<ParlayBetItem>;
  /** If the bet should be selected */
  selected: Scalars['Boolean']['output'];
  /** The number of successes required before the bet is won */
  successesRequired: Scalars['Int']['output'];
};

/** A single payout option for multi-game parlays */
export type MultiGameTeamPayout = {
  __typename?: 'MultiGameTeamPayout';
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String']['output'];
  /** The conditions in which this payout option will be selected */
  requirements: Array<MultiGameTeamPayoutRequirements>;
  /** The amount won on the bet */
  win: Scalars['String']['output'];
};

/** A single requirement for a multi-game payout */
export type MultiGameTeamPayoutRequirements = {
  __typename?: 'MultiGameTeamPayoutRequirements';
  goal: Scalars['Int']['output'];
  requirement: Scalars['String']['output'];
};

export type Nba2k25 = {
  __typename?: 'Nba2k25';
  gameSlug: Scalars['String']['output'];
};

export type Nba2k26 = {
  __typename?: 'Nba2k26';
  gameSlug: Scalars['String']['output'];
};

export type Nba2k27 = {
  __typename?: 'Nba2k27';
  gameSlug: Scalars['String']['output'];
};

export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type Note = Node & {
  __typename?: 'Note';
  authorEmail: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  edges?: Maybe<Array<Maybe<NoteEdge>>>;
  pageInfo: PageInfo;
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Note>;
};

export enum OfferType {
  /** The offer is a code */
  CODE = 'CODE',
  /** The offer is a URL */
  URL = 'URL'
}

export type OnfidoCreateTokenInput = {
  trigger?: InputMaybe<CreateOnfidoTemplateTrigger>;
  workflow?: InputMaybe<CreateOnfidoTemplateWorkflow>;
};

export type OnfidoMutationOutput = Node & {
  __typename?: 'OnfidoMutationOutput';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  workflowRunId: Scalars['String']['output'];
};

export enum OnfidoVerificationStatus {
  /** User has completed verification and verification is approved */
  APPROVED = 'APPROVED',
  /** User has not started verification */
  INACTIVE = 'INACTIVE',
  /** User has started verification and verification is pending */
  PENDING = 'PENDING',
  /** User's verification was rejected */
  REJECTED = 'REJECTED',
  /** User has started verification and needs manual review */
  REVIEW = 'REVIEW'
}

/** Represents a selection of related bets */
export type Option = MultiGameTeamParlayOption | SingleGameTeamBountyOption | SingleGameTeamOption | SingleGameTeamParlayOption;

export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  FILLED = 'FILLED',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  REJECTED = 'REJECTED',
  SETTLED_LOSS = 'SETTLED_LOSS',
  SETTLED_WIN = 'SETTLED_WIN'
}

export enum OutcomeStatus {
  ACTIVE = 'ACTIVE',
  LOST = 'LOST',
  SUSPENDED = 'SUSPENDED',
  VOID = 'VOID',
  WON = 'WON'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The standard body for pagination metadata */
export type PaginationDetails = {
  __typename?: 'PaginationDetails';
  /** Whether or not you can go forwards a page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not you can go backwards a page */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The total amount of items that can be taken */
  itemCount?: Maybe<Scalars['Int']['output']>;
  /** The current page */
  page?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages that can be fetched with the current take value */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** How many items the query took */
  take?: Maybe<Scalars['Int']['output']>;
};

/** Pagination metadata */
export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  page: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Parlay */
export type Parlay = {
  __typename?: 'Parlay';
  id: Scalars['ID']['output'];
  legTypesTaken: Array<Maybe<Scalars['String']['output']>>;
  legTypesTakenUnique: Array<Maybe<Scalars['String']['output']>>;
  numberOfLegs: Scalars['Int']['output'];
  numberOfLegsLost?: Maybe<Scalars['Int']['output']>;
  numberOfLegsWon?: Maybe<Scalars['Int']['output']>;
  won?: Maybe<Scalars['Boolean']['output']>;
};

/** A single requirement for a parlay */
export type ParlayBetItem = {
  __typename?: 'ParlayBetItem';
  /** Type of line i.e Kills */
  lineType: Scalars['String']['output'];
  /** The title of the bet option */
  title: Scalars['String']['output'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
};

/** A parlay bet option */
export type ParlayBetOption = {
  __typename?: 'ParlayBetOption';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Bet level */
  level: Scalars['String']['output'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String']['output'];
  /** Parlay requirements */
  requirements: Array<ParlayBetItem>;
  /** If the bet should be selected */
  selected: Scalars['Boolean']['output'];
  /** The amount won on the bet */
  win: Scalars['String']['output'];
};

/** An event in parlay history */
export type ParlayEvent = {
  __typename?: 'ParlayEvent';
  actor?: Maybe<Scalars['String']['output']>;
  eventType: ParlayEventType;
  id: Scalars['String']['output'];
  parlayId: Scalars['String']['output'];
  payload?: Maybe<Scalars['Json']['output']>;
  timestamp: Scalars['String']['output'];
};

/** Event type for parlay history */
export enum ParlayEventType {
  /** Parlay was cancelled */
  CANCELLED = 'CANCELLED',
  /** Parlay was created */
  CREATED = 'CREATED',
  /** Parlay item was adjusted */
  ITEM_ADJUSTED = 'ITEM_ADJUSTED',
  /** Parlay leg was adjusted */
  LEG_ADJUSTED = 'LEG_ADJUSTED',
  /** Parlay was settled */
  SETTLED = 'SETTLED',
  /** Parlay status changed */
  STATUS_CHANGED = 'STATUS_CHANGED',
  /** Parlay was updated */
  UPDATED = 'UPDATED',
  /** Parlay was voided */
  VOIDED = 'VOIDED'
}

/** A leg in a parlay (bet slip or stake offer) */
export type ParlayLeg = {
  __typename?: 'ParlayLeg';
  achievedMultiplier: Scalars['Int']['output'];
  adjustedAt?: Maybe<Scalars['String']['output']>;
  adjustedBy?: Maybe<Scalars['String']['output']>;
  adjustmentReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  legType: ParlayLegType;
  maximumMultiplier: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  parlayId: Scalars['String']['output'];
  productInfo: ParlayProductUnion;
  refunded: Scalars['Boolean']['output'];
  resolved: Scalars['Boolean']['output'];
  status: ParlayLegStatus;
  updatedAt: Scalars['String']['output'];
  won: Scalars['Boolean']['output'];
};

/** Status of a parlay leg */
export enum ParlayLegStatus {
  /** Leg is cancelled */
  CANCELLED = 'CANCELLED',
  /** Leg is completed */
  COMPLETED = 'COMPLETED',
  /** Leg is pending */
  PENDING = 'PENDING'
}

/** Type of leg in a parlay */
export enum ParlayLegType {
  /** Bet slip leg */
  BETSLIP = 'betSlip',
  /** Stake offer leg */
  STAKEOFFER = 'stakeOffer'
}

/** A parlay */
export type ParlayProduct = {
  __typename?: 'ParlayProduct';
  achievedMultiplier: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  events?: Maybe<Array<ParlayEvent>>;
  fundingSource: Array<Maybe<Financials>>;
  id: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  legs: Array<ParlayLeg>;
  maximumMultiplier: Scalars['Int']['output'];
  payouts: Array<Maybe<Financials>>;
  serviceFee: Scalars['String']['output'];
  settledAt?: Maybe<Scalars['String']['output']>;
  status: ParlayStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Parlay product type union */
export type ParlayProductUnion = BetSlip | StakeOffer;

/** Status of a parlay */
export enum ParlayStatus {
  /** Parlay is active */
  ACTIVE = 'ACTIVE',
  /** Parlay has been cancelled */
  CANCELLED = 'CANCELLED',
  /** Parlay has been completed */
  COMPLETED = 'COMPLETED',
  /** Parlay is pending */
  PENDING = 'PENDING',
  /** Parlay has been settled */
  SETTLED = 'SETTLED',
  /** Parlay has been voided */
  VOIDED = 'VOIDED'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** A list of apps for this payment method */
  apps?: Maybe<Array<AdyenApp>>;
  /** Brand for the selected gift card. For example: plaxtix, hmclub */
  brand?: Maybe<Scalars['String']['output']>;
  /** List of possible brands. For example: visa, mc */
  brands?: Maybe<Array<Scalars['String']['output']>>;
  /** The configuration of the payment method */
  configuration?: Maybe<AdyenPaymentMethodConfiguration>;
  /** The funding source of the payment method */
  fundingSource?: Maybe<Scalars['String']['output']>;
  /** The group where this payment method belongs to */
  group?: Maybe<AdyenGroup>;
  /** A list of issuers for this payment method */
  issuers?: Maybe<Array<AdyenIssuer>>;
  /** The displayable name of this payment method */
  name: Scalars['String']['output'];
  /** The unique payment method code */
  type: Scalars['String']['output'];
};

export type PaymentOptionKyc = {
  __typename?: 'PaymentOptionKyc';
  /** Whether an admin has waived verification for this user and transfer type. When true the client must not route to any verification flow, whatever the amounts above say */
  exempt: Scalars['Boolean']['output'];
  /** Whether identity verification must be completed before any transfer of this type */
  required: Scalars['Boolean']['output'];
  /** Cumulative deposit amount in dollars at which verification becomes required */
  thresholdAmount: Scalars['String']['output'];
  /** The user's cumulative deposits in dollars, null when unknown */
  totalDeposited?: Maybe<Scalars['String']['output']>;
  /** Whether the user's identity is already verified */
  verified: Scalars['Boolean']['output'];
};

export type PaymentOptionMethod = {
  __typename?: 'PaymentOptionMethod';
  /** List of expedite tiers for the provider */
  expediteTiersConfigs?: Maybe<Array<Maybe<ExpediteTierConfig>>>;
  /** Maximum transfer amount in cents */
  max: Scalars['String']['output'];
  /** Minimum transfer amount in cents */
  min: Scalars['String']['output'];
  /** Payment method name, e.g. CARD, ACH, PAYPAL */
  paymentMethod: Scalars['String']['output'];
  /** Display order, lowest first */
  priority: Scalars['Int']['output'];
  /** Provider that serves this payment method */
  provider: Scalars['String']['output'];
  /** Provider-specific data needed to start the transfer */
  providerData?: Maybe<Scalars['Json']['output']>;
  /** Enum of the type of transfer being made. Currently Withdrawal or Deposit. */
  transferType: Scalars['String']['output'];
};

export type PaymentOptions = {
  __typename?: 'PaymentOptions';
  /** Identity verification decision for this transfer type */
  kyc: PaymentOptionKyc;
  /** Payment methods offered to the user, ordered by priority */
  paymentMethods: Array<PaymentOptionMethod>;
};

/** The provider details stored against the payment */
export type PaymentProviderDetails = AdyenProviderDetails | FrameProviderDetails | PaypalProviderDetails;

/** Metadata related to the payment status */
export type PaymentStatusMetadata = {
  __typename?: 'PaymentStatusMetadata';
  /** The deposit refund information related to this payment status */
  depositRefundInfo?: Maybe<DepositRefundInfoArrayMetadata>;
  /** The withdrawal amendment information related to this payment status */
  withdrawalAmendmentInfo?: Maybe<WithdrawalAmendmentInfoMetadata>;
};

/** Payments API user details */
export type PaymentUserDetails = {
  __typename?: 'PaymentUserDetails';
  communicationEmail?: Maybe<Scalars['String']['output']>;
  lastFreeWithdrawalDate?: Maybe<Scalars['String']['output']>;
  maxDailyDeposit?: Maybe<Scalars['String']['output']>;
  maxDailyWithdrawal?: Maybe<Scalars['String']['output']>;
  maxWeeklyDeposit?: Maybe<Scalars['String']['output']>;
  maxWeeklyWithdrawal?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PlatformEnum>;
};

/** Represents a payout */
export type Payout = Node & {
  __typename?: 'Payout';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<BalanceType>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  triggerAction?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PayoutUserPtrOutput = Node & {
  __typename?: 'PayoutUserPtrOutput';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type PaypalDetails = {
  paypalEmail: Scalars['String']['input'];
};

export type PaypalProviderDetails = {
  __typename?: 'PaypalProviderDetails';
  paypalEmail?: Maybe<Scalars['String']['output']>;
};

export type PaypalTransactionProcessInput = {
  authorizationId?: InputMaybe<Scalars['String']['input']>;
  depositFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceOmniBalanceBetInput = {
  betValue: Scalars['String']['input'];
  selectedBets: Array<InputMaybe<UserOmniBalanceBetLevelResultInput>>;
};

/** Platform specific betting status */
export enum PlatformBettingStatus {
  /** Attempting to fetch match data for the user */
  PLATFORM_FETCHING_FIRST_MATCHES = 'PLATFORM_FETCHING_FIRST_MATCHES',
  /** Failed the initial fetch for match data on this platform */
  PLATFORM_FETCHING_FIRST_MATCHES_ERROR = 'PLATFORM_FETCHING_FIRST_MATCHES_ERROR',
  /** The user has attempted to relink with a different account */
  PLATFORM_ID_ALTERNATIVE_ACCOUNT = 'PLATFORM_ID_ALTERNATIVE_ACCOUNT',
  /** No ID is avaliable for the platform */
  PLATFORM_ID_NOT_ADDED = 'PLATFORM_ID_NOT_ADDED',
  /** Attempting to fetch platform data with an ID */
  PLATFORM_ID_TOKEN_FETCHING = 'PLATFORM_ID_TOKEN_FETCHING',
  /** Failed to fetch token data for ID */
  PLATFORM_ID_TOKEN_FETCH_FAILED = 'PLATFORM_ID_TOKEN_FETCH_FAILED',
  /** A duplicate token already exists in the database */
  PLATFORM_ID_TOKEN_IN_USE = 'PLATFORM_ID_TOKEN_IN_USE',
  /** The users token has been fetched */
  PLATFORM_ID_TOKEN_KNOWN = 'PLATFORM_ID_TOKEN_KNOWN',
  /** An issue with fetching the users token requires user intervention */
  PLATFORM_ID_TOKEN_USER_ISSUE = 'PLATFORM_ID_TOKEN_USER_ISSUE',
  /** Game platform is missing required metadata */
  PLATFORM_INVALID_CONFIGURATION = 'PLATFORM_INVALID_CONFIGURATION',
  /** Data is not available for this user on the platform */
  PLATFORM_MATCHES_NOT_AVAILABLE = 'PLATFORM_MATCHES_NOT_AVAILABLE',
  /** We have lost the ability to fetch matches for this user */
  PLATFORM_MATCHES_NO_LONGER_AVAILABLE = 'PLATFORM_MATCHES_NO_LONGER_AVAILABLE',
  /** User is ready to bet */
  PLATFORM_READY = 'PLATFORM_READY'
}

export enum PlatformEnum {
  /** Players' Lounge Connect */
  PLC = 'PLC'
}

/** User Platform Identifiers */
export type PlatformIdentifier = {
  __typename?: 'PlatformIdentifier';
  gamerTag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<PlatformIdentifierMetadata>;
  platform?: Maybe<Platforms>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** User Platform Identifier Metadata */
export type PlatformIdentifierMetadata = {
  __typename?: 'PlatformIdentifierMetadata';
  id?: Maybe<Scalars['String']['output']>;
  relatedFramedropUuid?: Maybe<Scalars['String']['output']>;
  streamBitrate?: Maybe<Scalars['String']['output']>;
  streamHeight?: Maybe<Scalars['Int']['output']>;
  streamQuality?: Maybe<Scalars['String']['output']>;
  streamQualityUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  twitchDisplayNameOverride?: Maybe<Scalars['String']['output']>;
  twitchOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  twitchProfile?: Maybe<TwitchProfileInfo>;
  twitchStreamInfo?: Maybe<StreamInfo>;
  twitchStreamLastEndedAt?: Maybe<Scalars['DateTime']['output']>;
  twitchStreamLink?: Maybe<Scalars['String']['output']>;
  twitchStreamLiveStatus?: Maybe<Scalars['Boolean']['output']>;
  twitchVodEnabled?: Maybe<Scalars['Boolean']['output']>;
  twitchVodLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  twitchVodLatestTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum Platforms {
  ACTIVISION = 'ACTIVISION',
  BATTLENET = 'BATTLENET',
  EA = 'EA',
  EMBARK = 'EMBARK',
  EPIC_GAMES = 'EPIC_GAMES',
  LEAGUE_OF_LEGENDS = 'LEAGUE_OF_LEGENDS',
  MLBTHESHOW = 'MLBTHESHOW',
  NETEASE_GAMES = 'NETEASE_GAMES',
  ORIGIN = 'ORIGIN',
  PLAYERS_LOUNGE = 'PLAYERS_LOUNGE',
  PLAYSTATION_NETWORK = 'PLAYSTATION_NETWORK',
  RIOT = 'RIOT',
  STEAM = 'STEAM',
  SUPERCELL = 'SUPERCELL',
  TWITCH = 'TWITCH',
  TWOK = 'TWOK',
  UBISOFT = 'UBISOFT',
  WB_GAMES = 'WB_GAMES',
  XBOX_LIVE = 'XBOX_LIVE'
}

export enum PortfolioView {
  HISTORY = 'HISTORY',
  OPEN = 'OPEN'
}

/** A category within a domain; embedded in the domain payload. parentCategoryId and depth are being removed from the upstream PM API and may be null. */
export type PredictionCategory = {
  __typename?: 'PredictionCategory';
  depth?: Maybe<Scalars['Int']['output']>;
  domainId: Scalars['ID']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parentCategoryId?: Maybe<Scalars['ID']['output']>;
  source: MarketSource;
  status: MarketStatus;
  title: Scalars['String']['output'];
};

/** A competitor (team) in the catalog directory (list view). */
export type PredictionCompetitor = {
  __typename?: 'PredictionCompetitor';
  abbreviation?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Contrast-corrected for a dark background. */
  darkModePrimary?: Maybe<Scalars['String']['output']>;
  darkModeSecondary?: Maybe<Scalars['String']['output']>;
  displayLogo?: Maybe<Scalars['Boolean']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** How the colours sit on the kit, e.g. solid, vertical_stripes, horizontal_stripes. A string, not an enum: sports-data owns the vocabulary and this gateway must forward a value it does not yet know rather than error. Null where unknown, which is not the same as solid. */
  kitPattern?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  /** Contrast-corrected for a light background. The raw pair above always equals one of the theme pairs; prefer these when the background is known. */
  lightModePrimary?: Maybe<Scalars['String']['output']>;
  lightModeSecondary?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  markets?: Maybe<Array<Maybe<CatalogMarket>>>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  sportsDataTeamId?: Maybe<Scalars['ID']['output']>;
};

/** Full competitor detail, including top-level category associations. */
export type PredictionCompetitorDetail = {
  __typename?: 'PredictionCompetitorDetail';
  abbreviation?: Maybe<Scalars['String']['output']>;
  categoryIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  country?: Maybe<Scalars['String']['output']>;
  /** Contrast-corrected for a dark background. */
  darkModePrimary?: Maybe<Scalars['String']['output']>;
  darkModeSecondary?: Maybe<Scalars['String']['output']>;
  displayLogo?: Maybe<Scalars['Boolean']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** How the colours sit on the kit, e.g. solid, vertical_stripes, horizontal_stripes. A string, not an enum: sports-data owns the vocabulary and this gateway must forward a value it does not yet know rather than error. Null where unknown, which is not the same as solid. */
  kitPattern?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  /** Contrast-corrected for a light background. The raw pair above always equals one of the theme pairs; prefer these when the background is known. */
  lightModePrimary?: Maybe<Scalars['String']['output']>;
  lightModeSecondary?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  markets?: Maybe<Array<Maybe<CatalogMarket>>>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  sportsDataTeamId?: Maybe<Scalars['ID']['output']>;
};

/** A conditional (limit/stop) order that executes when the trigger price is crossed */
export type PredictionConditionalOrder = {
  __typename?: 'PredictionConditionalOrder';
  action: ConditionalOrderAction;
  balanceType?: Maybe<BalanceType>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  direction: ConditionalOrderDirection;
  expiresAt?: Maybe<Scalars['String']['output']>;
  externalMarketId: Scalars['String']['output'];
  externalOutcomeId: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marketId?: Maybe<Scalars['String']['output']>;
  outcomeId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['String']['output'];
  resultingOrderId?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  status: ConditionalOrderStatus;
  triggerPrice: Scalars['String']['output'];
  type: ConditionalOrderType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

/** Paginated list of conditional orders */
export type PredictionConditionalOrderPaginated = {
  __typename?: 'PredictionConditionalOrderPaginated';
  data?: Maybe<Array<Maybe<PredictionConditionalOrder>>>;
  metaData?: Maybe<PaginationDetails>;
};

/** A top-level browse domain. Categories are embedded; tournaments are fetched lazily. */
export type PredictionDomain = {
  __typename?: 'PredictionDomain';
  categories?: Maybe<Array<Maybe<PredictionCategory>>>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  stale?: Maybe<Scalars['Boolean']['output']>;
  status: MarketStatus;
  title: Scalars['String']['output'];
  tournaments?: Maybe<Array<Maybe<PredictionTournament>>>;
};


/** A top-level browse domain. Categories are embedded; tournaments are fetched lazily. */
export type PredictionDomainTournamentsArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<MarketSortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Proactive trade-eligibility readout for a user on a market source */
export type PredictionEligibility = {
  __typename?: 'PredictionEligibility';
  canTrade: Scalars['Boolean']['output'];
  gates: Array<PredictionGate>;
  permissions: Array<PredictionPermission>;
};

export type PredictionEvent = {
  __typename?: 'PredictionEvent';
  /**
   * Everyone contesting this event, with their colours and logo. Read straight
   * from the event payload — no extra upstream call, and NOT gated by the
   * enrichment kill switch, so identity survives when sportsEnrichment is off.
   *
   * Ordered alphabetically by name; that is not home/away — read each
   * competitor's `side` for that, falling back to this order when it is null.
   */
  competitors?: Maybe<Array<Maybe<PredictionEventCompetitor>>>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  heroMarkets: Array<CatalogMarket>;
  id: Scalars['ID']['output'];
  inPlay?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  /** Live score from sports-data, when the event is linked and in play. Null when unlinked, nothing live, or enrichment is disabled. */
  liveScore?: Maybe<SportsLiveScore>;
  marketCount?: Maybe<Scalars['Int']['output']>;
  markets?: Maybe<Array<Maybe<CatalogMarket>>>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  promotedUntil?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  /** Fixture context from sports-data: per-side standings, recent form, head-to-head. One cached upstream call per pairing. Null when unlinked or enrichment is disabled. */
  sportsEnrichment?: Maybe<SportsEnrichment>;
  stale: Scalars['Boolean']['output'];
  startsAt?: Maybe<Scalars['String']['output']>;
  status: MarketStatus;
  title: Scalars['String']['output'];
  totalFilled?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<PredictionEventTournament>;
  tournamentId: Scalars['ID']['output'];
};


export type PredictionEventMarketsArgs = {
  includeAllLines?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Slim category (sport) context for an event breadcrumb. */
export type PredictionEventCategory = {
  __typename?: 'PredictionEventCategory';
  domain?: Maybe<PredictionEventDomain>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 * A participant in an event, embedded on the event payload.
 *
 * Carries the competitor's identity — name, colours, logo, kit — so a client
 * renders an event's teams from the event alone. Sourced from
 * prediction-market rather than sportsEnrichment on purpose: enrichment sits
 * behind a kill switch, and a team's colours must survive it being turned off.
 *
 * Distinct from `predictionCompetitor`, the catalog directory entry: this is
 * the embedded participant shape, keyed `competitorId`, with no markets list.
 *
 * Position in the list carries NO home/away meaning — it is an alphabetical
 * sort by name. Read `side` for orientation; it rides this payload and is not
 * gated by the enrichment kill switch. Where `side` is null (neutral venues,
 * much of tennis), `sportsDataTeamId` joined against `sportsEnrichment.fixture`'s
 * or `liveScore`'s homeTeamId/awayTeamId is the fallback — when enrichment is
 * on and the fixture resolved.
 */
export type PredictionEventCompetitor = {
  __typename?: 'PredictionEventCompetitor';
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** The catalog competitor uuid. Also the join key for an outcome's competitorId. */
  competitorId: Scalars['ID']['output'];
  /** Contrast-corrected for a dark background. */
  darkModePrimary?: Maybe<Scalars['String']['output']>;
  darkModeSecondary?: Maybe<Scalars['String']['output']>;
  displayLogo?: Maybe<Scalars['Boolean']['output']>;
  /** How the colours sit on the kit, e.g. solid, vertical_stripes. A string, not an enum: sports-data owns the vocabulary. Null where unknown, which is not the same as solid. */
  kitPattern?: Maybe<Scalars['String']['output']>;
  /** Contrast-corrected for a light background; the raw pair above always equals one of the theme pairs. */
  lightModePrimary?: Maybe<Scalars['String']['output']>;
  lightModeSecondary?: Maybe<Scalars['String']['output']>;
  /** Withheld (null) unless sports-data granted display rights (displayLogo == true). */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /**
   * Which side of THIS fixture the competitor is on: "home", "away", or null.
   *
   * Null is permanent and expected, not a deploy window — neutral-venue
   * fixtures and much of tennis carry no side, as do rows the backfill has not
   * reached. A client picking a primary team falls back to this list's order
   * (alphabetical by name) when side is null, and shows no competitor at all
   * when the list is empty.
   *
   * Ungated and free: it rides the event payload, unlike the fixture/liveScore
   * orientation below, which needs a sports-data link and disappears when
   * enrichment is off.
   */
  side?: Maybe<Scalars['String']['output']>;
  /** The sports-data team id: the join key to fixtures, live scores and enrichment. Null until the enrichment pass links it. */
  sportsDataTeamId?: Maybe<Scalars['ID']['output']>;
};

/** Slim domain context for an event breadcrumb. */
export type PredictionEventDomain = {
  __typename?: 'PredictionEventDomain';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** Paginated list of catalog events */
export type PredictionEventPaginated = {
  __typename?: 'PredictionEventPaginated';
  data?: Maybe<Array<Maybe<PredictionEvent>>>;
  metaData?: Maybe<PaginationDetails>;
};

/**
 * Event list ordering. Direction is fixed per value upstream: START_TIME
 * ascending (soonest first), VOLUME descending, MARKET_COUNT descending. Omit
 * for the default promoted-first ordering.
 */
export enum PredictionEventSort {
  MARKET_COUNT = 'MARKET_COUNT',
  START_TIME = 'START_TIME',
  VOLUME = 'VOLUME'
}

/**
 * Slim tournament context for an event breadcrumb, with its category and domain
 * nested. `category` is null when the tournament sits directly under its domain
 * — normal, not an error — so `domain` is exposed here too and is never lost.
 */
export type PredictionEventTournament = {
  __typename?: 'PredictionEventTournament';
  category?: Maybe<PredictionEventCategory>;
  domain?: Maybe<PredictionEventDomain>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  source?: Maybe<MarketSource>;
  status?: Maybe<MarketStatus>;
  title: Scalars['String']['output'];
};

/** A single onboarding gate and whether it is completed */
export type PredictionGate = {
  __typename?: 'PredictionGate';
  completed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

/** A prediction market (unified across all sources) */
export type PredictionMarket = {
  __typename?: 'PredictionMarket';
  category?: Maybe<Scalars['String']['output']>;
  closesAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Array<Maybe<MarketOutcome>>>;
  settledAt?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  status: MarketStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Full market detail with live prices (DB fallback flagged via priceStale). */
export type PredictionMarketDetail = {
  __typename?: 'PredictionMarketDetail';
  categoryName?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMainLine?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  lineGroup?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<MarketType>;
  outcomes?: Maybe<Array<Maybe<CatalogOutcome>>>;
  priceAsOf?: Maybe<Scalars['String']['output']>;
  priceStale: Scalars['Boolean']['output'];
  promoted?: Maybe<Scalars['Boolean']['output']>;
  promotedUntil?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  stale: Scalars['Boolean']['output'];
  status: MarketStatus;
  strike?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalFilled?: Maybe<Scalars['String']['output']>;
};

/** The provider's normalization of a submitted address. */
export type PredictionNormalizedAddress = {
  __typename?: 'PredictionNormalizedAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** An order (replaces the old position concept) */
export type PredictionOrder = {
  __typename?: 'PredictionOrder';
  cost: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fundingSources?: Maybe<Array<Maybe<PredictionOrderFundingSource>>>;
  grossPayout?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  market?: Maybe<PredictionMarket>;
  marketId: Scalars['String']['output'];
  outcome?: Maybe<MarketOutcome>;
  outcomeId: Scalars['String']['output'];
  payout?: Maybe<Scalars['String']['output']>;
  payoutBalanceType?: Maybe<BalanceType>;
  potentialPayout?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  settledAt?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  status: OrderStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export enum PredictionOrderBalanceType {
  PL_BALANCE = 'PL_BALANCE',
  PREDICTION_BET_CREDITS = 'PREDICTION_BET_CREDITS'
}

export type PredictionOrderFundingSource = {
  __typename?: 'PredictionOrderFundingSource';
  consumedAmount?: Maybe<Scalars['String']['output']>;
  reservedAmount: Scalars['String']['output'];
  unusedRefundAmount?: Maybe<Scalars['String']['output']>;
  wallet: BalanceType;
};

/** Paginated list of orders */
export type PredictionOrderPaginated = {
  __typename?: 'PredictionOrderPaginated';
  data?: Maybe<Array<Maybe<PredictionOrder>>>;
  metaData?: Maybe<PaginationDetails>;
};

/** A price/availability quote for a contract purchase decision. Returns a quoteId to confirm against on createOrder. */
export type PredictionOrderQuote = {
  __typename?: 'PredictionOrderQuote';
  availableQuantity: Scalars['String']['output'];
  expectedCashPayout?: Maybe<Scalars['String']['output']>;
  expectedCost: Scalars['String']['output'];
  expectedPayout: Scalars['String']['output'];
  expectedPrice: Scalars['String']['output'];
  /**
   * Provider service fee for this order, taken off the stake at acceptance
   * (net stake = quantity - fee). expectedPayout is the expected PROFIT on the
   * net stake, so gross "to gain" = expectedPayout + (expectedCost - fee).
   * Null when the upstream service predates the field; "0" when the provider
   * charges none.
   */
  fee?: Maybe<Scalars['String']['output']>;
  /** Authoritative max quantity bettable on this contract right now (from the provider); null if none reported. Use this for "max you can bet", NOT browse restingLiquidity. */
  maxQuantity?: Maybe<Scalars['String']['output']>;
  quoteId: Scalars['String']['output'];
};

/** A parlay (multi-leg bet) */
export type PredictionParlay = {
  __typename?: 'PredictionParlay';
  adjustedPrice?: Maybe<Scalars['Int']['output']>;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  confirmedQuantity?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failReason?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  fillStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legs?: Maybe<Array<Maybe<PredictionParlayLeg>>>;
  payout?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['String']['output'];
  quotedPrice?: Maybe<Scalars['Int']['output']>;
  settlementStatus?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

/** A leg within a prediction market parlay */
export type PredictionParlayLeg = {
  __typename?: 'PredictionParlayLeg';
  contractId: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  marketId: Scalars['Int']['output'];
  outcomeId: Scalars['Int']['output'];
  settlementStatus?: Maybe<Scalars['String']['output']>;
  strike?: Maybe<Scalars['String']['output']>;
};

/** A leg within a prediction market parlay quote request */
export type PredictionParlayLegInput = {
  contractId: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  marketId: Scalars['Int']['input'];
  outcomeId: Scalars['Int']['input'];
  strike?: InputMaybe<Scalars['String']['input']>;
};

/** A single trade permission and whether it is granted */
export type PredictionPermission = {
  __typename?: 'PredictionPermission';
  denyReason?: Maybe<Scalars['String']['output']>;
  granted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

/** Generic realized/unrealized standing: value, P&L, P&L %. All 8dp decimal strings. */
export type PredictionPortfolioStanding = {
  __typename?: 'PredictionPortfolioStanding';
  pnl: Scalars['String']['output'];
  pnlPct: Scalars['String']['output'];
  portfolioValue: Scalars['String']['output'];
};

/** Realized + unrealized portfolio summary for a user. */
export type PredictionPortfolioSummary = {
  __typename?: 'PredictionPortfolioSummary';
  realized: PredictionPortfolioStanding;
  unrealized: PredictionPortfolioStanding;
};

/**
 * A single portfolio position (open or settled). Embedded event/market/outcome
 * are null if the underlying market was pruned (rare; history over old data).
 */
export type PredictionPosition = {
  __typename?: 'PredictionPosition';
  avgPrice: Scalars['String']['output'];
  cashPayoutIfRight?: Maybe<Scalars['String']['output']>;
  cost: Scalars['String']['output'];
  event?: Maybe<PredictionEvent>;
  market?: Maybe<CatalogMarket>;
  marketValue: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  outcome?: Maybe<CatalogOutcome>;
  payoutDelta: Scalars['String']['output'];
  payoutIfRight: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  return: Scalars['String']['output'];
  returnPct: Scalars['String']['output'];
  settledAt?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
};

/** Paginated list of portfolio positions. */
export type PredictionPositionPaginated = {
  __typename?: 'PredictionPositionPaginated';
  data?: Maybe<Array<Maybe<PredictionPosition>>>;
  metaData?: Maybe<PaginationDetails>;
};

/** Derived stake headroom for order-entry validation. maxAllowedStake is the min of applicable caps ("0.00000000" when blocked, null when uncapped) and can bind directly to the stake input. */
export type PredictionProfileHeadroom = {
  __typename?: 'PredictionProfileHeadroom';
  maxAllowedStake?: Maybe<Scalars['String']['output']>;
  openExposure?: Maybe<Scalars['String']['output']>;
  remainingExposure?: Maybe<Scalars['String']['output']>;
  remainingInWindow?: Maybe<Scalars['String']['output']>;
  spentInWindow?: Maybe<Scalars['String']['output']>;
};

/** Cached KYC decision for the profile (from the last provider sync; never triggers a refresh) */
export type PredictionProfileKyc = {
  __typename?: 'PredictionProfileKyc';
  failReason?: Maybe<Scalars['String']['output']>;
  kycAttemptsRemaining?: Maybe<Scalars['Int']['output']>;
  kycRetryable?: Maybe<Scalars['Boolean']['output']>;
  source: MarketSource;
  status: KycStatus;
  supportEmail?: Maybe<Scalars['String']['output']>;
  termsVersion?: Maybe<Scalars['Int']['output']>;
};

/** Configured trading limits. maxStakePerOrder is three-state: a value with isDefaultStakeCap=true is the platform default, with false it is admin-set, and null means explicitly uncapped. */
export type PredictionProfileLimits = {
  __typename?: 'PredictionProfileLimits';
  blockReason?: Maybe<Scalars['String']['output']>;
  isBlocked: Scalars['Boolean']['output'];
  isDefaultStakeCap: Scalars['Boolean']['output'];
  maxOpenExposure?: Maybe<Scalars['String']['output']>;
  maxStakePerOrder?: Maybe<Scalars['String']['output']>;
  spendLimit?: Maybe<PredictionSpendLimit>;
};

/** Windowed spend limit */
export type PredictionSpendLimit = {
  __typename?: 'PredictionSpendLimit';
  amount: Scalars['String']['output'];
  window: SpendLimitWindow;
};

/** A catalog tournament (top of the browse tree). For INTERNAL markets these are synthetic, keyed by game slug. */
export type PredictionTournament = {
  __typename?: 'PredictionTournament';
  categoryId?: Maybe<Scalars['ID']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['ID']['output']>;
  events?: Maybe<Array<Maybe<PredictionEvent>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  featuredMarket?: Maybe<CatalogMarket>;
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  marketCount?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  promotedUntil?: Maybe<Scalars['String']['output']>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  stale: Scalars['Boolean']['output'];
  status: MarketStatus;
  title: Scalars['String']['output'];
  tradedVolume?: Maybe<Scalars['String']['output']>;
  trendingMarket?: Maybe<CatalogMarket>;
};

/** User trading profile: cached KYC (null until provider registration), limits, and stake headroom — the same snapshot order enforcement uses. */
export type PredictionUserProfile = {
  __typename?: 'PredictionUserProfile';
  headroom: PredictionProfileHeadroom;
  kyc?: Maybe<PredictionProfileKyc>;
  limits: PredictionProfileLimits;
};

/** Bucketed price series for charting: evenly spaced buckets, OLDEST FIRST (the opposite of priceHistory, which is newest-first). */
export type PriceSeries = {
  __typename?: 'PriceSeries';
  from: Scalars['String']['output'];
  /** Bucket width, e.g. '1m', '15m', '1d'. */
  interval: Scalars['String']['output'];
  points?: Maybe<Array<Maybe<PriceSeriesPoint>>>;
  to: Scalars['String']['output'];
};

/** One bucket in a price series. */
export type PriceSeriesPoint = {
  __typename?: 'PriceSeriesPoint';
  /** Outcome id (uuid) -> that bucket's CLOSING probability. Buckets with no new sample repeat the previous known price (carry-forward). An outcome absent here had no sample at or before this bucket. Opaque map: keys are provider-independent outcome uuids, so this is a Json scalar rather than a fixed shape (same reason as MarketPriceSnapshot.outcomePrices). */
  prices?: Maybe<Scalars['Json']['output']>;
  /** Bucket START timestamp (ISO-8601), aligned to interval boundaries. The newest bucket is partial and its value still moves. */
  t: Scalars['String']['output'];
};

/**
 * Time range for a bucketed price series. The upstream API's wire values are
 * "1H"/"6H"/"1D"/"1W"/"ALL"; GraphQL enum names cannot begin with a digit, so
 * each value carries its wire string via `as:`.
 */
export enum PriceSeriesRange {
  ALL = 'ALL',
  ONE_DAY = 'ONE_DAY',
  ONE_HOUR = 'ONE_HOUR',
  ONE_WEEK = 'ONE_WEEK',
  SIX_HOURS = 'SIX_HOURS'
}

/** A price level in an outcome's order book. */
export type PriceTier = {
  __typename?: 'PriceTier';
  price: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Prize distribution for a specific rank */
export type PrizeDistributionEntry = {
  __typename?: 'PrizeDistributionEntry';
  /** Percentage of prize pool (0.0 - 1.0) */
  percentage: Scalars['Float']['output'];
  /** Placement rank (1 = first place) */
  rank: Scalars['Int']['output'];
};

/** A single user contribution to a tournament's prize pool */
export type PrizePoolContribution = {
  __typename?: 'PrizePoolContribution';
  /** Bet slip that produced this contribution */
  betSlipId: Scalars['ID']['output'];
  /** Amount contributed to the prize pool (money-as-string) */
  contributionAmount: Scalars['String']['output'];
  /** ISO timestamp the contribution was recorded */
  createdAt: Scalars['String']['output'];
  status: PrizePoolContributionStatus;
};

/** Lifecycle status of a user's prize pool contribution */
export enum PrizePoolContributionStatus {
  /** Contribution voided (bet cancelled or no longer eligible at settlement) */
  CANCELLED = 'CANCELLED',
  /** Contribution promoted at bet settlement; added to the pool */
  COMPLETED = 'COMPLETED',
  /** Contribution recorded at bet placement; not yet added to the pool */
  PENDING = 'PENDING'
}

/** Represents a cod probabilities entity. */
export type Probabilities = Node & {
  __typename?: 'Probabilities';
  betCategory: Scalars['String']['output'];
  gameMode: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
};

/** Stake offer Product Type union */
export type Product = BetSlip;

export type ProviderConfigResponse = {
  __typename?: 'ProviderConfigResponse';
  /** Flag to denote if the provider is currently enabled for the platform */
  enabled: Scalars['Boolean']['output'];
  /** List of expedite tiers for the provider */
  expediteTiersConfigs: Array<Maybe<ExpediteTierConfig>>;
  /** The ID of the provider */
  id: Scalars['ID']['output'];
  /** Maximum transfer type amount for the provider */
  max: Scalars['String']['output'];
  /** Minimum transfer type amount for the provider */
  min: Scalars['String']['output'];
  /** Platform of the provider */
  platform: PlatformEnum;
  /** Provider name */
  provider: ProviderEnum;
  /** Enum of the type of transfer being made. Currently Withdrawal or Deposit. */
  transferType: Scalars['String']['output'];
};

export type ProviderDetailsInput = {
  adyen?: InputMaybe<AdyenDetails>;
  frame?: InputMaybe<FrameDetails>;
  paypal?: InputMaybe<PaypalDetails>;
};

export enum ProviderEnum {
  /** Adyen */
  ADYEN = 'ADYEN',
  /** Frame Payments */
  FRAME = 'FRAME',
  /** PayPal */
  PAYPAL = 'PAYPAL'
}

/** KYC status details */
export type ProviderKycStatus = {
  __typename?: 'ProviderKycStatus';
  failReason?: Maybe<Scalars['String']['output']>;
  kycAttemptsRemaining?: Maybe<Scalars['Int']['output']>;
  kycRetryable?: Maybe<Scalars['Boolean']['output']>;
  status: KycStatus;
  supportEmail?: Maybe<Scalars['String']['output']>;
};

/** A user registered with an external provider */
export type ProviderUser = {
  __typename?: 'ProviderUser';
  failReason?: Maybe<Scalars['String']['output']>;
  /** IDPV (document capture) attempts left before the provider's limit. */
  idpvAttemptsRemaining?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether the user may still enter the IDPV (document capture) flow. ProphetX
   * allow 3 attempts and exhaustion is TERMINAL — there is no reset — so when
   * this is false the client must show a support dead end rather than relaunching
   * the embed, which would immediately fail. Independent of kyc_retryable: the
   * data-correction retries and the document-capture attempts have separate
   * ceilings and can be exhausted independently.
   */
  idpvAvailable?: Maybe<Scalars['Boolean']['output']>;
  kycAttemptsRemaining?: Maybe<Scalars['Int']['output']>;
  kycRetryable?: Maybe<Scalars['Boolean']['output']>;
  kycStatus: KycStatus;
  plUserId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  source: MarketSource;
  supportEmail?: Maybe<Scalars['String']['output']>;
  termsVersion?: Maybe<Scalars['Int']['output']>;
};

/** Represents a play through requirement */
export type Ptr = Node & {
  __typename?: 'Ptr';
  claimed?: Maybe<Scalars['Boolean']['output']>;
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  cumulativeResolvedBetStakeAmount?: Maybe<Array<Maybe<Financials>>>;
  cumulativeResolvedBetStakeTarget?: Maybe<Array<Maybe<Financials>>>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payouts?: Maybe<Array<Maybe<Financials>>>;
  ptrSpecAtCreation?: Maybe<PtrConfig>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Represents a play through requirement config */
export type PtrConfig = Node & {
  __typename?: 'PtrConfig';
  activeForCreation?: Maybe<Scalars['Boolean']['output']>;
  amountSpentAsAPercentageOfDeposit?: Maybe<Scalars['Float']['output']>;
  depositCount?: Maybe<Scalars['Int']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  payoutAsAPercentageOfDeposit?: Maybe<Scalars['Float']['output']>;
};

export type PtrPayoutInput = {
  ptrName?: InputMaybe<Scalars['String']['input']>;
};

/** Detailed game mode specification with squad size constraints */
export type QualifyingGameModeDetail = {
  __typename?: 'QualifyingGameModeDetail';
  /** Game mode identifier */
  gameMode: Scalars['String']['output'];
  /** Map of squad size to max teams allowed for that squad size */
  maxTeamsPerSquadSize?: Maybe<Scalars['Json']['output']>;
  /** Array of allowed squad sizes */
  supportedSquadSizes?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Input for querying game results */
export type QueryGameResultsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tournamentId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for querying top game results */
export type QueryTopGameResultsInput = {
  top?: InputMaybe<Scalars['Int']['input']>;
  tournamentId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for querying tournaments */
export type QueryTournamentsInput = {
  gameSlug?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tournamentType?: InputMaybe<TournamentType>;
};

export type R6Siege = {
  __typename?: 'R6Siege';
  gameSlug: Scalars['String']['output'];
};

export type Range = {
  __typename?: 'Range';
  /** The title of the bet option */
  title: Scalars['String']['output'];
  /** The title of the bet option */
  type: Scalars['String']['output'];
};

/** Rank payout entry showing prize amount for a specific rank */
export type RankPayoutEntry = {
  __typename?: 'RankPayoutEntry';
  /** Payout amount for this rank */
  amount: Scalars['String']['output'];
  /** Placement rank (1 = first place) */
  rank: Scalars['Int']['output'];
};

/** Represents a referral code. */
export type ReferralCode = Node & {
  __typename?: 'ReferralCode';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RequestLoginCodeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Result of requesting a login OTP code */
export type RequestLoginCodeResult = {
  __typename?: 'RequestLoginCodeResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RocketLeague = {
  __typename?: 'RocketLeague';
  gameSlug: Scalars['String']['output'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept provider terms */
  acceptProviderTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Add a communication method (email or phone) and send a verification code */
  addCommunicationMethod?: Maybe<RequestLoginCodeResult>;
  /** Set users twitch display name override */
  adminOverrideTwitchDisplayName?: Maybe<Scalars['Boolean']['output']>;
  /** Admin: revoke every active session of a user. */
  adminRevokeUserSessions: SessionMutationResponse;
  /** Lock or unlock a user */
  adminSetUserLock?: Maybe<GenericUserMutationOutput>;
  /** Set user under review or remove review */
  adminSetUserUnderReview?: Maybe<GenericUserMutationOutput>;
  /** Set bypass for minimum games required for bet to be stakeable */
  adminToggleMinimumGameRequirementForStakableGame?: Maybe<Scalars['Boolean']['output']>;
  /** Set users twitch audio acknowledgement */
  adminUpdateTwitchMute?: Maybe<Scalars['Boolean']['output']>;
  /** Admin Update a User's Password */
  adminUpdateUserPassword?: Maybe<UserMutationOutput>;
  /** Authenticate a User. */
  authenticateUser?: Maybe<AuthenticationMutationOutput>;
  /** Cancel a bet by group bet id. */
  cancelBetByGroupBetId?: Maybe<Array<Maybe<BetSlip>>>;
  /** Cancel a conditional order */
  cancelConditionalOrder?: Maybe<PredictionConditionalOrder>;
  /** Cancel a pending order */
  cancelOrder?: Maybe<PredictionOrder>;
  /** Cancel a withdrawal */
  cancelWithdrawal?: Maybe<WithdrawalResponse>;
  /** Check VOD status */
  checkTwitchVodStatus?: Maybe<UserMutationOutput>;
  /** Claim an external offer */
  claimExternalOffer?: Maybe<ClaimedExternalOffer>;
  /** Verify registration OTP code and complete registration. */
  completeRegistration?: Maybe<AuthenticationMutationOutput>;
  /** Confirm a parlay quote */
  confirmParlay?: Maybe<PredictionParlay>;
  /** Create a new account and send registration OTP code. */
  createAccount?: Maybe<RequestLoginCodeResult>;
  /** Create a User. */
  createAccountStepOne?: Maybe<UserMutationOutput>;
  createAccountStepThree?: Maybe<UserMutationOutput>;
  /** Create a conditional (limit/stop) order that triggers on price */
  createConditionalOrder?: Maybe<PredictionConditionalOrder>;
  /** Create a FRAME onboarding session for KYC verification */
  createFrameOnboardingSession?: Maybe<FrameOnboardingSession>;
  /** Create a game specific Team. */
  createGameSpecificTeam?: Maybe<TeamMutationOutput>;
  /** Create note for user */
  createNoteForUser?: Maybe<Note>;
  createOnfidoToken?: Maybe<OnfidoMutationOutput>;
  /** Place an order on a market (any source) */
  createOrder?: Maybe<PredictionOrder>;
  /** Create a new parlay with multiple items */
  createParlay?: Maybe<ParlayProduct>;
  /** Create a parlay quote */
  createParlayQuote?: Maybe<PredictionParlay>;
  /** Create a users platform and game identifier */
  createPlatformAndGameIdentifier?: Maybe<UserMutationOutput>;
  /** Create a users platform and game identifier async */
  createPlatformAndGameIdentifierAsync?: Maybe<UserMutationOutput>;
  /** Register the current user with an external provider */
  createProviderUser?: Maybe<ProviderUser>;
  /** Register the current user with a provider using user-supplied identity/address (pre-Frame-KYC flow) */
  createProviderUserWithDetails?: Maybe<ProviderUser>;
  /** Create a stake order */
  createStakeOrder?: Maybe<StakeOrder>;
  /** Create a new third party session */
  createThirdPartySession?: Maybe<ThirdPartySession>;
  /** Create a new User. */
  createUser?: Maybe<UserMutationOutput>;
  /** Add email to user */
  createUserEmail?: Maybe<UserMutationOutput>;
  /** Delete user twitch event subscription */
  deleteTwitchEventSubscription?: Maybe<TwitchSubscriptionDeletionResponse>;
  /** Delete all twitch subscriptions for a user and unlink identifier */
  deleteTwitchEventSubscriptionsByUser?: Maybe<Array<Maybe<TwitchUserSubscriptionDeletionResponse>>>;
  /** Delete all twitch subscriptions for a list of users and unlink identifier */
  deleteTwitchEventSubscriptionsByUserIds?: Maybe<Array<Maybe<TwitchUserSubscriptionDeletionResponse>>>;
  disableUserTeams?: Maybe<UserMutationOutput>;
  /** Ensure a FRAME account exists for the logged-in user without requesting capabilities */
  ensureFrameAccount?: Maybe<FrameAccount>;
  /**
   * Enter one or more instant tournaments.
   * The leaderboards service resolves game/bet details from the bet slip.
   */
  enterInstantTournament: InstantTournamentEnterResult;
  /**
   * Attempt to fetch match data for a user
   * @deprecated Deprecated as codwz is no longer available
   */
  fetchUserMatchData?: Maybe<MatchDataResponse>;
  /** Send an access code to a users email for forgotten password */
  forgotPassword?: Maybe<Scalars['Boolean']['output']>;
  /** verify forgotten password code */
  forgotPasswordVerification?: Maybe<AuthenticationResult>;
  /** Mutations that are related to Special Rule Users. */
  insertSpecialRuleUser?: Maybe<SpecialRuleUserMutationOutput>;
  /**
   * Create a users platform and game identifier for a riot game
   * @deprecated No longer supported
   */
  linkRiotCredentials?: Maybe<Scalars['Boolean']['output']>;
  /** Create a users platform identifier for Steam */
  linkSteamCredentials?: Maybe<Scalars['String']['output']>;
  /** Create a users platform identifier for a twitch */
  linkTwitchCredentials?: Maybe<Scalars['Boolean']['output']>;
  /** Revoke the session used to make this request. */
  logout: SessionMutationResponse;
  /** Revoke every other session of the caller (and the current one when includeCurrent is true). */
  logoutAllSessions: SessionMutationResponse;
  /** Payout a users play through requirement. */
  payoutUserPtr?: Maybe<PayoutUserPtrOutput>;
  paypalTransactionProcess?: Maybe<UserMutationOutput>;
  /** Create multiple bets, funded from various player balances. Multi-match bets will be split into their own bet slip. */
  placeOmniBalanceBets?: Maybe<Array<Maybe<BetSlip>>>;
  /** Estimate a contract purchase: current price, cost, payout, and authoritative max quantity. Returns a quoteId to confirm against. */
  predictionOrderEstimate?: Maybe<PredictionOrderQuote>;
  /**
   * Record that the current user completed a KYC step-up (document capture) session.
   * Call when the provider SDK reports the session pending; returns the resulting
   * KYC status (PHOTO_VERIFICATION_PROCESSING once stamped), which should seed the
   * client's polling baseline. Idempotent.
   */
  recordKycIdpvSubmission?: Maybe<ProviderKycStatus>;
  /** Refresh FRAME account status after onboarding */
  refreshFrameAccountStatus?: Maybe<FrameAccount>;
  /** Request a login OTP code to be sent via email or phone. */
  requestLoginCode?: Maybe<RequestLoginCodeResult>;
  /** Resend registration OTP code for a pending registration. */
  resendRegistrationCode?: Maybe<RequestLoginCodeResult>;
  /** Reset the password */
  resetPassword?: Maybe<UserMutationOutput>;
  /** Reset user password via SMS */
  resetPasswordSms?: Maybe<User>;
  /** Revoke one of the caller's own sessions by id. */
  revokeSession: SessionMutationResponse;
  sendEmailVerificationCode?: Maybe<AuthIsAdminResult>;
  /** Request a forgot password OTP code to be sent via email or phone. */
  sendForgotPasswordCode?: Maybe<RequestLoginCodeResult>;
  sendSmsVerificationCode?: Maybe<AuthIsAdminResult>;
  /** Send user traits to analytics */
  sendUserExternalOfferTraits?: Maybe<Scalars['Boolean']['output']>;
  /** Submit a deposit */
  submitDeposit?: Maybe<DepositResponse>;
  /** Submit additional details required for a deposit */
  submitDepositAdditionalDetails?: Maybe<DepositResponse>;
  /** Submit a withdrawal */
  submitWithdrawal?: Maybe<WithdrawalResponse>;
  syncUserAndGame?: Maybe<Scalars['Boolean']['output']>;
  /**
   * unlink the users game identifier for a riot game
   * @deprecated No longer supported
   */
  unlinkRiotCredentials?: Maybe<Scalars['Boolean']['output']>;
  /** unlink a users platform identifier for Steam */
  unlinkSteamCredentials?: Maybe<Scalars['Boolean']['output']>;
  /** unlink the users platform identifier for a twitch */
  unlinkTwitchCredentials?: Maybe<Scalars['Boolean']['output']>;
  /** Update device bits with Apple */
  updateDeviceBits?: Maybe<VerifyDeviceResponse>;
  /** Set user fair play terms agreement for game */
  updateGameFairPlayTermsAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Reset password via verification code or old password */
  updatePassword?: Maybe<Scalars['Boolean']['output']>;
  /** Update a users platform and game identifier */
  updatePlatformAndGameIdentifier?: Maybe<UserMutationOutput>;
  /** Admin Manually Update a User's verification status. */
  updateReviewUserVerificationStatus?: Maybe<UserMutationOutput>;
  /** Set users twitch audio acknowledgement */
  updateTwitchMute?: Maybe<Scalars['Boolean']['output']>;
  /** Update flag for user */
  updateUserFlag?: Maybe<UserSetFlagsMutationOutput>;
  /** Update a User's Password */
  updateUserPassword?: Maybe<UserMutationOutput>;
  /** Update a User's verification status. */
  updateUserVerificationStatus?: Maybe<UserMutationOutput>;
  /** Update a users lounge username */
  updateUsername?: Maybe<User>;
  /** Request an Apple Pay merchant session (web Apple Pay, own-certificate flow) */
  validateApplePayMerchant?: Maybe<Scalars['Json']['output']>;
  /** Verify a communication method with an OTP code */
  verifyCommunicationMethod?: Maybe<UserMutationOutput>;
  /** Fetch and verify a device with Apple */
  verifyDevice?: Maybe<VerifyDeviceResponse>;
  /** Verify a login OTP code and authenticate. */
  verifyLoginCode?: Maybe<AuthenticationMutationOutput>;
};


export type RootMutationTypeAcceptProviderTermsArgs = {
  input: AcceptTermsInput;
  source: MarketSource;
};


export type RootMutationTypeAddCommunicationMethodArgs = {
  type: CommunicationMethodType;
  value: Scalars['String']['input'];
};


export type RootMutationTypeAdminOverrideTwitchDisplayNameArgs = {
  twitchDisplayName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminRevokeUserSessionsArgs = {
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSetUserLockArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  lockReason?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeAdminSetUserUnderReviewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  underReview?: InputMaybe<Scalars['Boolean']['input']>;
  underReviewReason?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeAdminToggleMinimumGameRequirementForStakableGameArgs = {
  gameSlug?: InputMaybe<Games>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeAdminUpdateTwitchMuteArgs = {
  game: Games;
  twitchMuted: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminUpdateUserPasswordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<AdminUpdateUserPasswordInput>;
};


export type RootMutationTypeAuthenticateUserArgs = {
  input?: InputMaybe<AuthenticateUserInput>;
};


export type RootMutationTypeCancelBetByGroupBetIdArgs = {
  input?: InputMaybe<CancelBetByGroupBetIdInput>;
};


export type RootMutationTypeCancelConditionalOrderArgs = {
  conditionalOrderId: Scalars['String']['input'];
};


export type RootMutationTypeCancelOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type RootMutationTypeCancelWithdrawalArgs = {
  withdrawalId: Scalars['ID']['input'];
};


export type RootMutationTypeClaimExternalOfferArgs = {
  offerId: Scalars['ID']['input'];
};


export type RootMutationTypeCompleteRegistrationArgs = {
  input?: InputMaybe<CompleteRegistrationInput>;
};


export type RootMutationTypeConfirmParlayArgs = {
  input: ConfirmParlayInput;
  parlayId: Scalars['String']['input'];
};


export type RootMutationTypeCreateAccountArgs = {
  input?: InputMaybe<CreateAccountInput>;
};


export type RootMutationTypeCreateAccountStepOneArgs = {
  input?: InputMaybe<CreateAccountStepOneInput>;
};


export type RootMutationTypeCreateAccountStepThreeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<CreateAccountStepThreeInput>;
};


export type RootMutationTypeCreateConditionalOrderArgs = {
  input: CreateConditionalOrderInput;
};


export type RootMutationTypeCreateFrameOnboardingSessionArgs = {
  capabilities: Array<Scalars['String']['input']>;
  createHostedSession?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeCreateGameSpecificTeamArgs = {
  input?: InputMaybe<CreateGameSpecificTeamInput>;
};


export type RootMutationTypeCreateNoteForUserArgs = {
  authorEmail: Scalars['String']['input'];
  text: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateOnfidoTokenArgs = {
  input?: InputMaybe<OnfidoCreateTokenInput>;
};


export type RootMutationTypeCreateOrderArgs = {
  input: CreateOrderInput;
};


export type RootMutationTypeCreateParlayArgs = {
  input: CreateParlayInput;
};


export type RootMutationTypeCreateParlayQuoteArgs = {
  input: CreatePredictionParlayInput;
};


export type RootMutationTypeCreatePlatformAndGameIdentifierArgs = {
  game?: InputMaybe<Games>;
  identifier: Scalars['String']['input'];
  platform: Platforms;
};


export type RootMutationTypeCreatePlatformAndGameIdentifierAsyncArgs = {
  game?: InputMaybe<Games>;
  identifier: Scalars['String']['input'];
  platform: Platforms;
};


export type RootMutationTypeCreateProviderUserArgs = {
  input: CreateProviderUserInput;
};


export type RootMutationTypeCreateProviderUserWithDetailsArgs = {
  input: CreateProviderUserWithDetailsInput;
};


export type RootMutationTypeCreateStakeOrderArgs = {
  fundingSources: Array<InputMaybe<FinancialsInput>>;
  offerId: Scalars['String']['input'];
};


export type RootMutationTypeCreateThirdPartySessionArgs = {
  thirdParty: Scalars['String']['input'];
};


export type RootMutationTypeCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type RootMutationTypeCreateUserEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteTwitchEventSubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTypeDeleteTwitchEventSubscriptionsByUserArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTwitchEventSubscriptionsByUserIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDisableUserTeamsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeEnterInstantTournamentArgs = {
  input: EnterInstantTournamentInput;
};


export type RootMutationTypeFetchUserMatchDataArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  searchTrigger?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeForgotPasswordVerificationArgs = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeInsertSpecialRuleUserArgs = {
  input?: InputMaybe<InsertSpecialRuleUserInput>;
};


export type RootMutationTypeLinkRiotCredentialsArgs = {
  code: Scalars['String']['input'];
  game?: InputMaybe<Games>;
};


export type RootMutationTypeLinkSteamCredentialsArgs = {
  url: Scalars['String']['input'];
};


export type RootMutationTypeLinkTwitchCredentialsArgs = {
  code: Scalars['String']['input'];
};


export type RootMutationTypeLogoutAllSessionsArgs = {
  includeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypePayoutUserPtrArgs = {
  input?: InputMaybe<PtrPayoutInput>;
};


export type RootMutationTypePaypalTransactionProcessArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<PaypalTransactionProcessInput>;
};


export type RootMutationTypePlaceOmniBalanceBetsArgs = {
  input?: InputMaybe<PlaceOmniBalanceBetInput>;
};


export type RootMutationTypePredictionOrderEstimateArgs = {
  input: EstimateOrderInput;
};


export type RootMutationTypeRecordKycIdpvSubmissionArgs = {
  source: MarketSource;
};


export type RootMutationTypeRequestLoginCodeArgs = {
  input?: InputMaybe<RequestLoginCodeInput>;
};


export type RootMutationTypeResendRegistrationCodeArgs = {
  input?: InputMaybe<RequestLoginCodeInput>;
};


export type RootMutationTypeResetPasswordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeResetPasswordSmsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeRevokeSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type RootMutationTypeSendEmailVerificationCodeArgs = {
  input?: InputMaybe<SendEmailVerificationCodeInput>;
};


export type RootMutationTypeSendForgotPasswordCodeArgs = {
  input?: InputMaybe<SendForgotPasswordCodeInput>;
};


export type RootMutationTypeSendSmsVerificationCodeArgs = {
  input?: InputMaybe<SendSmsVerificationCodeInput>;
};


export type RootMutationTypeSubmitDepositArgs = {
  amount: Scalars['Int']['input'];
  depositFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  provider: ProviderEnum;
  providerDepositDetails: ProviderDetailsInput;
  savePaymentMethod: Scalars['Boolean']['input'];
};


export type RootMutationTypeSubmitDepositAdditionalDetailsArgs = {
  provider: ProviderEnum;
  providerDepositAdditionalDetails: Scalars['String']['input'];
  providerRef?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};


export type RootMutationTypeSubmitWithdrawalArgs = {
  amount: Scalars['Int']['input'];
  expediteTier: ExpediteTierEnum;
  provider: ProviderEnum;
  providerWithdrawalDetails: ProviderDetailsInput;
};


export type RootMutationTypeSyncUserAndGameArgs = {
  game?: InputMaybe<Games>;
};


export type RootMutationTypeUnlinkRiotCredentialsArgs = {
  game?: InputMaybe<Games>;
};


export type RootMutationTypeUpdateDeviceBitsArgs = {
  bit0: Scalars['Boolean']['input'];
  bit1: Scalars['Boolean']['input'];
  deviceToken: Scalars['String']['input'];
};


export type RootMutationTypeUpdateGameFairPlayTermsAgreementArgs = {
  game: Games;
  termsAgreed: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdatePasswordArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  resetCode?: InputMaybe<Scalars['String']['input']>;
  revokeOtherSessions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeUpdatePlatformAndGameIdentifierArgs = {
  game?: InputMaybe<Games>;
  identifier: Scalars['String']['input'];
  newGamerTag?: InputMaybe<Scalars['String']['input']>;
  newPlatform?: InputMaybe<Platforms>;
  platform: Platforms;
};


export type RootMutationTypeUpdateReviewUserVerificationStatusArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<OnfidoVerificationStatus>;
  workflowRunId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateTwitchMuteArgs = {
  game: Games;
  twitchMuted: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateUserFlagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<SetUserFlagInput>;
};


export type RootMutationTypeUpdateUserPasswordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<UpdateUserPasswordInput>;
};


export type RootMutationTypeUpdateUserVerificationStatusArgs = {
  status?: InputMaybe<OnfidoVerificationStatus>;
};


export type RootMutationTypeUpdateUsernameArgs = {
  newUsername?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeValidateApplePayMerchantArgs = {
  validationUrl: Scalars['String']['input'];
};


export type RootMutationTypeVerifyCommunicationMethodArgs = {
  code: Scalars['String']['input'];
  type: CommunicationMethodType;
  value: Scalars['String']['input'];
};


export type RootMutationTypeVerifyDeviceArgs = {
  deviceToken: Scalars['String']['input'];
};


export type RootMutationTypeVerifyLoginCodeArgs = {
  input?: InputMaybe<VerifyLoginCodeInput>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Get active and upcoming tournaments grouped.
   * Optionally filter by gameSlug.
   */
  activeTournaments: ActiveTournaments;
  /** Get bracket leaderboard with ranked entries */
  bracketLeaderboard: BracketLeaderboard;
  /** Check if a user can deposit with the specified provider */
  canUserDepositWithProvider?: Maybe<Scalars['Boolean']['output']>;
  /** Get a User by their email address */
  currentUser?: Maybe<User>;
  /** Get all active providers and their expedite tiers */
  getActiveProviders?: Maybe<Array<Maybe<ProviderConfigResponse>>>;
  /** Get all available stake offers */
  getAvailableStakeOffers?: Maybe<StakeOfferPaginated>;
  /** Get a User bet history for logged in user */
  getBetHistory?: Maybe<BetHistoryResponse>;
  /** Get a User bet history for provided user id */
  getBetHistoryByUserId?: Maybe<BetHistoryResponse>;
  /** Get a Bet by ID */
  getBetSlip?: Maybe<BetSlip>;
  /** Get a single conditional order by ID */
  getConditionalOrder?: Maybe<PredictionConditionalOrder>;
  /** Get all active deposit providers and their payment methods */
  getDepositMethods?: Maybe<Array<Maybe<DepositProviderResponse>>>;
  /** Get all available ads */
  getExternalAds?: Maybe<Array<Maybe<ExternalPartnerAd>>>;
  /** Get all available and claimed external offers */
  getExternalOffers?: Maybe<ExternalOffersResponse>;
  /** Get a Feature Flag by domain */
  getFeatureFlag?: Maybe<Feature>;
  /** Get the current FRAME account for the logged-in user */
  getFrameAccount?: Maybe<FrameAccount>;
  /** Get FRAME provider config (customer ID) from the payments API */
  getFrameProviderConfig?: Maybe<FrameProviderConfig>;
  /** Get inplay stake offers */
  getInplayStakeOffers?: Maybe<StakeOfferPaginated>;
  /**
   * Mint a KYC step-up (document capture) embed token for the current user. Use
   * when KYC returned FAILURE and the data-correction retries are exhausted
   * (kycRetryable false) — pass the token to the ProphetX SDK to open the
   * document-capture modal. Eligibility is NOT enforced server-side, so gating
   * when to offer this is the client's responsibility. Null when the source has
   * no step-up flow.
   */
  getKycStepUpToken?: Maybe<KycStepUpToken>;
  /** List the current user's conditional orders with pagination */
  getMyConditionalOrders?: Maybe<PredictionConditionalOrderPaginated>;
  /** List the current user's orders with pagination */
  getMyOrders?: Maybe<PredictionOrderPaginated>;
  /** List the current user's prediction market parlays */
  getMyPredictionParlays?: Maybe<Array<Maybe<PredictionParlay>>>;
  /** The current user's trading profile: cached KYC, limits, and stake headroom for order-entry pre-validation. Reads the same snapshot order enforcement uses. */
  getMyPredictionProfile?: Maybe<PredictionUserProfile>;
  /** Get a single order by ID */
  getOrder?: Maybe<PredictionOrder>;
  /** Get a parlay by ID */
  getParlay?: Maybe<ParlayProduct>;
  /** Get the payment methods offered to the logged-in user and whether KYC is required first. transferType is DEPOSIT or WITHDRAWAL. */
  getPaymentOptions?: Maybe<PaymentOptions>;
  /** Get proactive trade-eligibility for the current user on a market source. Null when the source has no eligibility gate. */
  getPredictionEligibility?: Maybe<PredictionEligibility>;
  /** Get a single prediction market parlay by ID */
  getPredictionParlay?: Maybe<PredictionParlay>;
  /** Get KYC status for the current user on a provider */
  getProviderKycStatus?: Maybe<ProviderKycStatus>;
  /** Get terms bundle for a provider */
  getProviderTerms?: Maybe<TermsBundle>;
  /** Get the current user's provider registration status */
  getProviderUser?: Maybe<ProviderUser>;
  /** Get ptrs by user */
  getPtrs?: Maybe<Array<Maybe<Ptr>>>;
  /** Get a Referral code by code */
  getReferralCodeByCode?: Maybe<ReferralCode>;
  /** Get a Referral code by user_id */
  getReferralCodeForUserId?: Maybe<ReferralCode>;
  /** Get stake feed */
  getStakeFeed?: Maybe<StakeOfferPaginated>;
  getStakeOfferById?: Maybe<StakeOffer>;
  getStakeOffersByUser?: Maybe<StakeOfferPaginated>;
  getStakeOrdersByUser?: Maybe<StakeOrderPaginated>;
  getStakeOrdersByUserId?: Maybe<StakeOrderPaginated>;
  /** Get stake session feed */
  getStakeSessionFeed?: Maybe<StakeSessionsPaginated>;
  getStakesOrderById?: Maybe<StakeOrder>;
  /** Get Teams based on the specified filter */
  getTeams?: Maybe<Array<Maybe<Team>>>;
  /** Get a users relevanta VODs based on a timestamp */
  getThisNow?: Maybe<Array<Maybe<TwitchVod>>>;
  /** Get a User by their email address */
  getUserByEmail?: Maybe<User>;
  /** Get a User by their ID */
  getUserById: User;
  /** Get a User by their email address */
  getUserByPhone?: Maybe<User>;
  /** Get a users deposit and withdrawal limits by their id */
  getUserDepositWithdrawLimits?: Maybe<UserLimits>;
  /** Get all of a user's notes */
  getUserGameHistory?: Maybe<GameHistoryOutput>;
  /** Get a users game statistics */
  getUserGameStatistics?: Maybe<Array<Maybe<UserGameStatistics>>>;
  /** Get all of a user's notes */
  getUserNotes?: Maybe<Array<Maybe<Note>>>;
  /** Get all parlays for the authenticated user */
  getUserParlays?: Maybe<UserParlaysResponse>;
  /** Get user referrals by user */
  getUserReferrals?: Maybe<Array<Maybe<UserReferral>>>;
  /** Get user referrals by referral codes */
  getUserReferralsForUserId?: Maybe<Array<Maybe<UserReferral>>>;
  getUserStakingStats?: Maybe<StakeUserGameStats>;
  /** Get a specific transaction for a user */
  getUserTransactionById?: Maybe<WalletApiTransactionHistory>;
  /** Get a users transaction history */
  getUserTransactionHistory?: Maybe<TransactionHistoryResponse>;
  /** Get a users subscriptions */
  getUserTwitchEventSubscriptions?: Maybe<TwitchUserSubscriptionResponse>;
  /** Get a users wallet stats */
  getUserWalletStats?: Maybe<UserWalletStats>;
  /** Get payment withdrawal by id */
  getUserWithdrawalById?: Maybe<WithdrawalResponse>;
  /** Get all of a user's withdrawals */
  getUserWithdrawals?: Maybe<Array<Maybe<WithdrawalResponse>>>;
  /** Get a users relevant VODs based on a timestamp */
  getVodsByTimestamp?: Maybe<Array<Maybe<TwitchVod>>>;
  /**
   * Get available instant tournament slots for the authenticated user.
   * Returns existing FILLING tournaments and projected slots for new tournaments.
   */
  instantTournamentAvailable: InstantTournamentAvailable;
  /** Active sessions for the authenticated user, most recently seen first. */
  mySessions: Array<UserSession>;
  /**
   * Get authenticated user's entry in a tournament.
   * Returns null if user hasn't entered.
   */
  myTournamentEntry?: Maybe<TournamentEntry>;
  /** Exposes any node given its global ID. */
  node?: Maybe<Node>;
  nodes: Array<Maybe<Node>>;
  /**
   * Every event across every tournament in a category (a sport) — the "All"
   * view shown before a user drills into a specific tournament. Sortable by
   * start time, traded volume, or market count.
   */
  predictionCategoryEvents?: Maybe<PredictionEventPaginated>;
  /** Get a single competitor (team) detail, including top-level category associations. */
  predictionCompetitor?: Maybe<PredictionCompetitorDetail>;
  /** Browse the competitor (team) directory. */
  predictionCompetitors?: Maybe<Array<Maybe<PredictionCompetitor>>>;
  /** Get a single domain by internal id (embeds categories). */
  predictionDomain?: Maybe<PredictionDomain>;
  /** Browse the catalog by domain. Categories are embedded; tournaments resolve lazily. */
  predictionDomains?: Maybe<Array<Maybe<PredictionDomain>>>;
  /**
   * Get a single event by internal id. `tournament` carries the nested
   * tournament → category → domain breadcrumb and is always populated — useful
   * on deep links, where no browse context reached the client.
   */
  predictionEvent?: Maybe<PredictionEvent>;
  /** All lines of a line group (the ladder), strike-ascending. */
  predictionLineGroupMarkets?: Maybe<Array<Maybe<CatalogMarket>>>;
  /** Live events plus events starting soon: live first, then by traded volume, then soonest start. */
  predictionLiveEvents?: Maybe<Array<Maybe<PredictionEvent>>>;
  /** Get a single market with live prices (DB fallback flagged via priceStale). */
  predictionMarketDetail?: Maybe<PredictionMarketDetail>;
  /** Raw price snapshots for a market (newest first). */
  predictionMarketPriceHistory?: Maybe<Array<Maybe<MarketPriceSnapshot>>>;
  /** Bucketed price series for a market (oldest first). Defaults to ONE_DAY upstream when range is omitted. */
  predictionMarketPriceSeries?: Maybe<PriceSeries>;
  /** The current user's paginated portfolio positions (open or settled history). Pass eventId to scope to one event's positions, or orderId to retrieve a specific trade. */
  predictionPortfolioPositions?: Maybe<PredictionPositionPaginated>;
  /** The current user's realized + unrealized portfolio standing. */
  predictionPortfolioSummary?: Maybe<PredictionPortfolioSummary>;
  /** Get a single tournament by internal id. */
  predictionTournament?: Maybe<PredictionTournament>;
  /**
   * Events under one tournament, sortable and optionally paginated. Returns a
   * data + metaData envelope. The `predictionTournament { events }` field
   * remains available and unchanged for clients that want a plain list.
   */
  predictionTournamentEvents?: Maybe<PredictionEventPaginated>;
  /**
   * Tournaments under a domain, filtered to an exact (leaf) category. The
   * standalone equivalent of predictionDomain { tournaments(categoryId:) } for
   * clients that already hold both ids and don't need the domain payload.
   * Returns an empty list when no tournaments match.
   */
  predictionTournamentsByCategory?: Maybe<Array<Maybe<PredictionTournament>>>;
  /** Top N markets by trading volume, with tournament context. */
  predictionTrendingMarkets?: Maybe<Array<Maybe<TrendingMarket>>>;
  /** Gets a selection of users and platforms matching the provided string */
  searchForPlayersByGamertag: SearchResults;
  /**
   * Get single tournament by ID.
   * Optionally specify bracketId to include bracket details.
   * Automatically includes authenticated user's entry if exists.
   */
  tournament?: Maybe<Tournament>;
  /**
   * Get tournament entries for a user.
   * Supports pagination and optional tournamentId filter.
   */
  tournamentEntriesByUser: TournamentListPaginated;
  /**
   * Get game results for a tournament entry.
   * Defaults to authenticated user unless userId specified.
   * Returns newest games first.
   */
  tournamentGameResults: GameResultList;
  /**
   * Get top game results for a tournament.
   * Returns all game results for the top X highest-scoring bet slips.
   * Defaults to top 3 unless specified.
   * Supports optional userId filter for admin access.
   * No pagination - returns all qualifying game results.
   */
  tournamentTopGameResults: GameResultList;
  /** Query tournaments with filters */
  tournaments: TournamentList;
  /** Admin: sessions for a user (active only by default). */
  userSessions: Array<UserSession>;
  /**
   * Standalone advisory address verification. Returns a verdict — rejections
   * are statuses, and UNAVAILABLE means "no opinion" (outage or a source with
   * no validator) and must never block anything. Called by the details form on
   * blur so corrections surface before a submit spends a round-trip.
   */
  validateProviderUserAddress?: Maybe<AddressValidationResult>;
};


export type RootQueryTypeActiveTournamentsArgs = {
  gameSlug?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeBracketLeaderboardArgs = {
  input: BracketLeaderboardInput;
};


export type RootQueryTypeCanUserDepositWithProviderArgs = {
  provider: ProviderEnum;
};


export type RootQueryTypeCurrentUserArgs = {
  associatedGameModes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeGetAvailableStakeOffersArgs = {
  curateFeed?: InputMaybe<Scalars['Boolean']['input']>;
  gameSlug?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetBetHistoryArgs = {
  gameSlug?: InputMaybe<Games>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resolutionType?: InputMaybe<FilterStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetBetHistoryByUserIdArgs = {
  gameSlug?: InputMaybe<Games>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resolutionType?: InputMaybe<FilterStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type RootQueryTypeGetBetSlipArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGetConditionalOrderArgs = {
  conditionalOrderId: Scalars['String']['input'];
};


export type RootQueryTypeGetFeatureFlagArgs = {
  input?: InputMaybe<GetFeatureFlagInput>;
};


export type RootQueryTypeGetInplayStakeOffersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetKycStepUpTokenArgs = {
  source: MarketSource;
};


export type RootQueryTypeGetMyConditionalOrdersArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ConditionalOrderStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetMyOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<MarketSource>;
  status?: InputMaybe<OrderStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetMyPredictionParlaysArgs = {
  source?: InputMaybe<MarketSource>;
};


export type RootQueryTypeGetOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type RootQueryTypeGetParlayArgs = {
  includeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  parlayId: Scalars['String']['input'];
};


export type RootQueryTypeGetPaymentOptionsArgs = {
  transferType: Scalars['String']['input'];
};


export type RootQueryTypeGetPredictionEligibilityArgs = {
  source: MarketSource;
};


export type RootQueryTypeGetPredictionParlayArgs = {
  parlayId: Scalars['String']['input'];
};


export type RootQueryTypeGetProviderKycStatusArgs = {
  source: MarketSource;
};


export type RootQueryTypeGetProviderTermsArgs = {
  source: MarketSource;
};


export type RootQueryTypeGetProviderUserArgs = {
  source: MarketSource;
};


export type RootQueryTypeGetReferralCodeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type RootQueryTypeGetStakeFeedArgs = {
  curateFeed?: InputMaybe<Scalars['Boolean']['input']>;
  excludedOfferIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameSlug?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetStakeOfferByIdArgs = {
  offerId: Scalars['String']['input'];
};


export type RootQueryTypeGetStakeOffersByUserArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetStakeOrdersByUserArgs = {
  filter?: InputMaybe<StakeOrderFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetStakeOrdersByUserIdArgs = {
  filter?: InputMaybe<StakeOrderFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type RootQueryTypeGetStakeSessionFeedArgs = {
  excludedOfferIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetStakesOrderByIdArgs = {
  orderId: Scalars['String']['input'];
};


export type RootQueryTypeGetTeamsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type RootQueryTypeGetThisNowArgs = {
  id: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};


export type RootQueryTypeGetUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGetUserByPhoneArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetUserGameHistoryArgs = {
  game: Games;
  gameMode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetUserGameStatisticsArgs = {
  game: Games;
  userId: Scalars['String']['input'];
};


export type RootQueryTypeGetUserNotesArgs = {
  userId: Scalars['ID']['input'];
};


export type RootQueryTypeGetUserParlaysArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ParlayStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetUserReferralsForUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type RootQueryTypeGetUserTransactionByIdArgs = {
  transactionId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetUserTransactionHistoryArgs = {
  balanceType?: InputMaybe<BalanceType>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGetUserTwitchEventSubscriptionsArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypeGetUserWalletStatsArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGetUserWithdrawalByIdArgs = {
  withdrawalId?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetUserWithdrawalsArgs = {
  status?: InputMaybe<WithdrawalStatus>;
};


export type RootQueryTypeGetVodsByTimestampArgs = {
  id: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};


export type RootQueryTypeInstantTournamentAvailableArgs = {
  gameMode: Scalars['String']['input'];
  gameSlug: Scalars['String']['input'];
};


export type RootQueryTypeMyTournamentEntryArgs = {
  tournamentId: Scalars['ID']['input'];
};


export type RootQueryTypeNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type RootQueryTypePredictionCategoryEventsArgs = {
  categoryId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PredictionEventSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePredictionCompetitorArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePredictionCompetitorsArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<MarketSortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MarketSource>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePredictionDomainArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePredictionDomainsArgs = {
  order?: InputMaybe<MarketSortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<MarketSource>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePredictionEventArgs = {
  id: Scalars['ID']['input'];
  includeAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypePredictionLineGroupMarketsArgs = {
  lineGroup: Scalars['String']['input'];
  source?: InputMaybe<MarketSource>;
};


export type RootQueryTypePredictionLiveEventsArgs = {
  order?: InputMaybe<MarketSortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<MarketSource>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePredictionMarketDetailArgs = {
  marketId: Scalars['String']['input'];
};


export type RootQueryTypePredictionMarketPriceHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketId: Scalars['String']['input'];
};


export type RootQueryTypePredictionMarketPriceSeriesArgs = {
  marketId: Scalars['String']['input'];
  range?: InputMaybe<PriceSeriesRange>;
};


export type RootQueryTypePredictionPortfolioPositionsArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<MarketSortOrder>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  view?: InputMaybe<PortfolioView>;
};


export type RootQueryTypePredictionTournamentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePredictionTournamentEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PredictionEventSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tournamentId: Scalars['ID']['input'];
};


export type RootQueryTypePredictionTournamentsByCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  domainId: Scalars['ID']['input'];
  order?: InputMaybe<MarketSortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePredictionTrendingMarketsArgs = {
  source?: InputMaybe<MarketSource>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeSearchForPlayersByGamertagArgs = {
  username: Scalars['String']['input'];
};


export type RootQueryTypeTournamentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTournamentEntriesByUserArgs = {
  currentGameSlug?: InputMaybe<Games>;
  gameSlug?: InputMaybe<Games>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TournamentEntryStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeTournamentGameResultsArgs = {
  input: QueryGameResultsInput;
};


export type RootQueryTypeTournamentTopGameResultsArgs = {
  input: QueryTopGameResultsInput;
};


export type RootQueryTypeTournamentsArgs = {
  input: QueryTournamentsInput;
};


export type RootQueryTypeUserSessionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type RootQueryTypeValidateProviderUserAddressArgs = {
  input: ValidateAddressInput;
  source: MarketSource;
};

/** Scoring formula with expression and metric definitions */
export type ScoringFormula = {
  __typename?: 'ScoringFormula';
  /** Optional breakdown group config driving per-game score breakdowns */
  breakdownGroups?: Maybe<Array<BreakdownGroupConfig>>;
  /** Mathematical expression (e.g., "kills * 10 + placement * 5") */
  expression: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Metric definitions with names, sources, and directions */
  metrics: Array<FormulaMetricDefinition>;
  name: Scalars['String']['output'];
  /** Output score validation rules */
  validationRules: FormulaValidationRules;
};

/** An object containing list of users and a list of user_platform objects */
export type SearchResults = {
  __typename?: 'SearchResults';
  /** A list of objects containing matching platform usernames and the associated users id */
  results: Array<Maybe<UserPlatform>>;
  /** A list of users found by the search */
  users: Array<Maybe<User>>;
};

export type SendEmailVerificationCodeInput = {
  email: Scalars['String']['input'];
  isSignup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendForgotPasswordCodeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SendSmsVerificationCodeInput = {
  isSignup?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
};

/** Result of a session mutation (logout, revoke). */
export type SessionMutationResponse = {
  __typename?: 'SessionMutationResponse';
  /** Number of sessions actually revoked by this call. */
  revokedCount: Scalars['Int']['output'];
  /** Always true when the request was processed; check revokedCount for effect. */
  success: Scalars['Boolean']['output'];
};

export type SetUserFlagInput = {
  flag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Settled Bet Count with Weighted Score */
export type SettledBetCountWeighted = {
  __typename?: 'SettledBetCountWeighted';
  gameSlug: Scalars['String']['output'];
  settledBetCount: Scalars['Int']['output'];
  weightedScore: Scalars['Float']['output'];
};

/** Settled Bet Count */
export type SettledBetCounts = Node & {
  __typename?: 'SettledBetCounts';
  betValue?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  settledBetCount?: Maybe<Scalars['Int']['output']>;
  systemBypassed?: Maybe<Scalars['Boolean']['output']>;
  systemDisabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Settled Bet Denomination Counts */
export type SettledBetDenominationCounts = Node & {
  __typename?: 'SettledBetDenominationCounts';
  fifty?: Maybe<Scalars['Int']['output']>;
  fiftyMmb?: Maybe<Scalars['Int']['output']>;
  five?: Maybe<Scalars['Int']['output']>;
  fiveMmb?: Maybe<Scalars['Int']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  one?: Maybe<Scalars['Int']['output']>;
  oneMmb?: Maybe<Scalars['Int']['output']>;
  onehundred?: Maybe<Scalars['Int']['output']>;
  onehundredMmb?: Maybe<Scalars['Int']['output']>;
  ten?: Maybe<Scalars['Int']['output']>;
  tenMmb?: Maybe<Scalars['Int']['output']>;
  three?: Maybe<Scalars['Int']['output']>;
  threeMmb?: Maybe<Scalars['Int']['output']>;
  twentyfive?: Maybe<Scalars['Int']['output']>;
  twentyfiveMmb?: Maybe<Scalars['Int']['output']>;
};

/** A bounty bet */
export type SingleGameTeamBountyOption = {
  __typename?: 'SingleGameTeamBountyOption';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Bet level */
  level: Scalars['String']['output'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** List of ranges for the user to target */
  ranges: Array<Maybe<BountyRange>>;
  /** If the bet should be selected */
  selected: Scalars['Boolean']['output'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
  /** The amount won on the bet */
  win: Scalars['String']['output'];
};

/** A single option for a bet */
export type SingleGameTeamOption = {
  __typename?: 'SingleGameTeamOption';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Bet level */
  level: Scalars['String']['output'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String']['output'];
  /** If the bet should be selected */
  selected: Scalars['Boolean']['output'];
  /** The title of the bet option */
  title: Scalars['String']['output'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
  /** The amount won on the bet */
  win: Scalars['String']['output'];
};

/** A parlay bet option */
export type SingleGameTeamParlayOption = {
  __typename?: 'SingleGameTeamParlayOption';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Bet level */
  level: Scalars['String']['output'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String']['output'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String']['output'];
  /** Parlay requirements */
  requirements: Array<ParlayBetItem>;
  /** If the bet should be selected */
  selected: Scalars['Boolean']['output'];
  /** The amount won on the bet */
  win: Scalars['String']['output'];
};

/** Represents a special rule user object */
export type SpecialRuleUser = {
  __typename?: 'SpecialRuleUser';
  id?: Maybe<Scalars['String']['output']>;
  lastSeenTs?: Maybe<Scalars['DateTime']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleVersion?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SpecialRuleUserInput = {
  ruleId?: InputMaybe<Scalars['String']['input']>;
  ruleVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialRuleUserMutationOutput = {
  __typename?: 'SpecialRuleUserMutationOutput';
  id?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Maybe<SpecialRuleUser>>>;
};

export type SpecialRules = {
  __typename?: 'SpecialRules';
  betLineTypes: Array<Scalars['String']['output']>;
  gameModes: Array<SpecialRulesGameMode>;
  id: Scalars['ID']['output'];
  ruleDisplay: Array<Scalars['String']['output']>;
  systemId: Scalars['String']['output'];
};

export type SpecialRulesGameMode = {
  __typename?: 'SpecialRulesGameMode';
  systemId: Scalars['String']['output'];
};

export enum SpendLimitWindow {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

/** Fixture context from sports-data for an event: the anchoring fixture, head-to-head history, and per-competitor standings/form. One cached upstream call per pairing. */
export type SportsEnrichment = {
  __typename?: 'SportsEnrichment';
  /** Everyone contesting this event. A list rather than a fixed pair: not every contest is two-sided, and a competitor is not always a team. Ordered as sports-data returned them, which is not home/away — use the fixture or liveScore team ids for that. */
  competitors?: Maybe<Array<Maybe<SportsEnrichmentCompetitor>>>;
  fixture?: Maybe<SportsFixture>;
  /** True when sports-data could not uniquely resolve the fixture for this pairing/date (e.g. a doubleheader); fixture may be one of several candidates. */
  fixtureAmbiguous?: Maybe<Scalars['Boolean']['output']>;
  headToHead?: Maybe<Array<Maybe<SportsFixture>>>;
};

/** One competitor in a contest: identity, rights-gated logo, standings and recent form. A club in a league fixture, or an individual in an event whose entrants are people (golf, tennis, MMA). */
export type SportsEnrichmentCompetitor = {
  __typename?: 'SportsEnrichmentCompetitor';
  /** Contrast-corrected for a dark background. */
  darkModePrimary?: Maybe<Scalars['String']['output']>;
  darkModeSecondary?: Maybe<Scalars['String']['output']>;
  displayLogo?: Maybe<Scalars['Boolean']['output']>;
  /** How the colours sit on the kit, e.g. solid, vertical_stripes. A string, not an enum: sports-data owns the vocabulary. Null where unknown, which is not the same as solid. */
  kitPattern?: Maybe<Scalars['String']['output']>;
  /** Contrast-corrected for a light background; the raw pair above always equals one of the theme pairs. */
  lightModePrimary?: Maybe<Scalars['String']['output']>;
  lightModeSecondary?: Maybe<Scalars['String']['output']>;
  /** Withheld (null) unless sports-data granted display rights (displayLogo == true). */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  recentForm?: Maybe<Array<Maybe<SportsFormEntry>>>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  standings?: Maybe<SportsStanding>;
  /** The sports-data team/entrant id. Join liveScore.homeTeamId / awayTeamId against this to tell which score belongs to which competitor — position in the list carries no home/away meaning. */
  teamId?: Maybe<Scalars['ID']['output']>;
};

/** The sports-data fixture anchoring a matchup: the specific game the two teams are (or will be) contesting. */
export type SportsFixture = {
  __typename?: 'SportsFixture';
  awayScore?: Maybe<Scalars['Int']['output']>;
  awayTeamId?: Maybe<Scalars['ID']['output']>;
  gameDate?: Maybe<Scalars['String']['output']>;
  homeScore?: Maybe<Scalars['Int']['output']>;
  homeTeamId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** One prior game in a team's recent-form window. */
export type SportsFormEntry = {
  __typename?: 'SportsFormEntry';
  gameDate?: Maybe<Scalars['String']['output']>;
  gameId?: Maybe<Scalars['ID']['output']>;
  opponentScore?: Maybe<Scalars['Int']['output']>;
  opponentTeamId?: Maybe<Scalars['ID']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  teamScore?: Maybe<Scalars['Int']['output']>;
};

/** Live score from sports-data's global live feed, keyed by the event's linked game id. All fields nullable — a resting/settled feed row may omit clock/period. */
export type SportsLiveScore = {
  __typename?: 'SportsLiveScore';
  awayScore?: Maybe<Scalars['Int']['output']>;
  awayTeamId?: Maybe<Scalars['ID']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  displayClock?: Maybe<Scalars['String']['output']>;
  homeScore?: Maybe<Scalars['Int']['output']>;
  homeTeamId?: Maybe<Scalars['ID']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** A team's league standing as of the matchup snapshot. */
export type SportsStanding = {
  __typename?: 'SportsStanding';
  gamesPlayed?: Maybe<Scalars['Int']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  losses?: Maybe<Scalars['Int']['output']>;
  parentGroupName?: Maybe<Scalars['String']['output']>;
  playoffSeed?: Maybe<Scalars['Int']['output']>;
  pointDifferential?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  streak?: Maybe<Scalars['String']['output']>;
  ties?: Maybe<Scalars['Int']['output']>;
  winPercent?: Maybe<Scalars['String']['output']>;
  wins?: Maybe<Scalars['Int']['output']>;
};

/** Bet item adjustment details specifically for stake offers */
export type StakeBetItemAdjustment = {
  __typename?: 'StakeBetItemAdjustment';
  adjustedBy: Scalars['String']['output'];
  adjustmentReason: Scalars['String']['output'];
  betItemId: Scalars['String']['output'];
  betSlipAdjustmentId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newAchievedMultiplier: Scalars['Int']['output'];
  newAchievedValue: Scalars['String']['output'];
  newWon: Scalars['Boolean']['output'];
  offerAdjustmentId: Scalars['String']['output'];
  oldAchievedMultiplier: Scalars['Int']['output'];
  oldAchievedValue: Scalars['String']['output'];
  oldWon: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Stake Offer details */
export type StakeOffer = {
  __typename?: 'StakeOffer';
  achievedMultiplier?: Maybe<Scalars['Int']['output']>;
  adjustments?: Maybe<Array<Maybe<StakeOfferAdjustment>>>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  fundingSource: Array<Maybe<Financials>>;
  id: Scalars['ID']['output'];
  maximumAllowedStake?: Maybe<Scalars['String']['output']>;
  maximumAllowedStakeForUser?: Maybe<Scalars['String']['output']>;
  maximumMultiplier: Scalars['Int']['output'];
  orders?: Maybe<Array<Maybe<StakeOrder>>>;
  productId: Scalars['String']['output'];
  productInfo: Product;
  productType: Scalars['String']['output'];
  reward?: Maybe<StakeOfferReward>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  /** Stake offer owner */
  user: User;
};

/** Stake offer adjustment details */
export type StakeOfferAdjustment = {
  __typename?: 'StakeOfferAdjustment';
  adjustedBy: Scalars['String']['output'];
  adjustmentReason: Scalars['String']['output'];
  betSlipAdjustmentId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newAchievedMultiplier: Scalars['Int']['output'];
  oldAchievedMultiplier: Scalars['Int']['output'];
  productAdjustments?: Maybe<Array<StakeBetItemAdjustment>>;
  updatedAt: Scalars['String']['output'];
};

/** Paginated response for available stakes */
export type StakeOfferPaginated = {
  __typename?: 'StakeOfferPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** Array of Stake offers */
  stakeOffers?: Maybe<Array<Maybe<StakeOffer>>>;
};

export type StakeOfferReward = {
  __typename?: 'StakeOfferReward';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rewards: Array<Maybe<Financials>>;
};

/** Stake order details */
export type StakeOrder = {
  __typename?: 'StakeOrder';
  achievedMultiplier?: Maybe<Scalars['Int']['output']>;
  adjustments?: Maybe<Array<Maybe<StakeOrderAdjustment>>>;
  createdAt: Scalars['String']['output'];
  fundingSource: Array<Maybe<Financials>>;
  id: Scalars['ID']['output'];
  offer?: Maybe<StakeOffer>;
  payout?: Maybe<StakeOrderPayout>;
  serviceFee: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};

/** Stake order adjustment details */
export type StakeOrderAdjustment = {
  __typename?: 'StakeOrderAdjustment';
  adjustedBy: Scalars['String']['output'];
  adjustmentReason: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<StakeOrderAdjustmentMetadata>;
  newAchievedMultiplier: Scalars['Int']['output'];
  newPayouts: Array<Financials>;
  offerAdjustmentId: Scalars['String']['output'];
  oldAchievedMultiplier: Scalars['Int']['output'];
  oldPayouts: Array<Financials>;
  updatedAt: Scalars['String']['output'];
};

export type StakeOrderAdjustmentMetadata = {
  __typename?: 'StakeOrderAdjustmentMetadata';
  outstandingAmounts?: Maybe<Array<Financials>>;
};

export enum StakeOrderFilter {
  /** Get all orders that are in a completed state */
  COMPLETE = 'COMPLETE',
  /** Get all orders that are in a pending state */
  PENDING = 'PENDING'
}

/** Paginated response for available stakes */
export type StakeOrderPaginated = {
  __typename?: 'StakeOrderPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** Array of Stake offers */
  stakeOrders?: Maybe<Array<Maybe<StakeOrder>>>;
};

export type StakeOrderPayout = {
  __typename?: 'StakeOrderPayout';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payouts: Array<Maybe<Financials>>;
};

/** Stake session */
export type StakeSession = {
  __typename?: 'StakeSession';
  offers: Array<Maybe<StakeOffer>>;
  user: User;
};

/** Paginated response for stake sessions */
export type StakeSessionsPaginated = {
  __typename?: 'StakeSessionsPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** Array of Stake sessions */
  stakeSessions?: Maybe<Array<Maybe<StakeSession>>>;
};

/** Response for user stats */
export type StakeUserGameStats = {
  __typename?: 'StakeUserGameStats';
  /** Array of user game stats */
  userGameInfo?: Maybe<Array<Maybe<UserGameInfo>>>;
  /** Array of user partnership game stats */
  userPartnershipGameInfo?: Maybe<Array<Maybe<UserPartnershipGameInfo>>>;
};

/** A status of a withdrawal request */
export type Status = {
  __typename?: 'Status';
  /** When the status was first created */
  createdAt: Scalars['String']['output'];
  /** The ID of the withdrawal */
  id: Scalars['ID']['output'];
  /** Payment status ID */
  paymentStatusId: Scalars['ID']['output'];
  /** The status of the withdrawal */
  status: WithdrawalStatus;
  /** What entity initiated the request (e.g, 'user') */
  trigger: Scalars['String']['output'];
  /** Trigger relationship reason */
  triggerReason: Scalars['String']['output'];
  /** Triggered by */
  triggeredBy: Scalars['String']['output'];
  /** When the status was last updated */
  updatedAt: Scalars['String']['output'];
};

export type StoredPaymentMethod = {
  __typename?: 'StoredPaymentMethod';
  /** The bank accound number (without separators) */
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** The location id of the bank. The field value is nil in most cases */
  bankLocationId?: Maybe<Scalars['String']['output']>;
  /** The brand of the card */
  brand?: Maybe<Scalars['String']['output']>;
  /** The month the card expires */
  expiryMonth?: Maybe<Scalars['String']['output']>;
  /** The last two digits of the year the card expires. For example, 22 for the year 2022 */
  expiryYear?: Maybe<Scalars['String']['output']>;
  /** The unique payment method code */
  holderName?: Maybe<Scalars['String']['output']>;
  /** The IBAN of the bank account */
  iban?: Maybe<Scalars['String']['output']>;
  /** A unique identifier of this stored payment method */
  id: Scalars['String']['output'];
  /** Flag to indicate whether this stored payment method is the last used payment method */
  isLastUsedPaymentMethod: Scalars['Boolean']['output'];
  /** The shopper's issuer account label */
  label?: Maybe<Scalars['String']['output']>;
  /** The last four digits of the PAN */
  lastFour?: Maybe<Scalars['String']['output']>;
  /** The display name of the stored payment method */
  name: Scalars['String']['output'];
  /** The name of the bank account holder */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** The shopper's email address */
  shopperEmail?: Maybe<Scalars['String']['output']>;
  /** The supported recurring processing models for this stored payment method */
  supportedRecurringProcessingModels?: Maybe<Array<Scalars['String']['output']>>;
  /** The supported shopper interactions for this stored payment method */
  supportedShopperInteractions?: Maybe<Array<Scalars['String']['output']>>;
  /** The type of payment method */
  type: Scalars['String']['output'];
};

/** Information collected when stream went live */
export type StreamInfo = {
  __typename?: 'StreamInfo';
  gameName?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  viewerCount?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionCondition = {
  __typename?: 'SubscriptionCondition';
  /** Subscription condition */
  broadcasterUserId?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionData = {
  __typename?: 'SubscriptionData';
  condition?: Maybe<SubscriptionCondition>;
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Subscription data */
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transport?: Maybe<SubscriptionTransport>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionTransport = {
  __typename?: 'SubscriptionTransport';
  callback?: Maybe<Scalars['String']['output']>;
  /** Subscription transport */
  method?: Maybe<Scalars['String']['output']>;
};

/** Represents a cod team entity. */
export type Team = Node & {
  __typename?: 'Team';
  betCategory: Scalars['String']['output'];
  gameMode?: Maybe<Scalars['String']['output']>;
  gameSlug: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The entity's creation timestmap. */
  insertedAt: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  lines: Array<BetLineItem>;
  matchMap: Scalars['String']['output'];
  owner: User;
  probabilitiesCalculated: Probabilities;
  serviceFee: Scalars['String']['output'];
  squadSize: Scalars['Int']['output'];
  teammateBetRestrictions: Array<TeammateBetRestriction>;
  teammates: Array<Maybe<Teammate>>;
  /** The entity's last update timestamp. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a cod team entity. */
export type TeamTeammateBetRestrictionsArgs = {
  associatedGameModes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A list of cod teams. */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  pageInfo: PageInfo;
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Team>;
};

export type TeamMutationOutput = Node & {
  __typename?: 'TeamMutationOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  result?: Maybe<Team>;
};

export type TeamfightTactics = {
  __typename?: 'TeamfightTactics';
  gameSlug: Scalars['String']['output'];
};

/** Represents a cod teammate entity. */
export type Teammate = Node & {
  __typename?: 'Teammate';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The entity's creation timestmap. */
  insertedAt: Scalars['DateTime']['output'];
  /** The platofrm that the user play's on. */
  lobbyPlatform: Scalars['String']['output'];
  team: Team;
  /** The entity's last update timestamp. */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type TeammateBetRestriction = {
  __typename?: 'TeammateBetRestriction';
  gameModeBetRestrictions: Array<GameModeBetRestriction>;
  userId: Scalars['String']['output'];
};

/** Terms bundle for a provider */
export type TermsBundle = {
  __typename?: 'TermsBundle';
  documents?: Maybe<Array<Maybe<TermsDocument>>>;
  totalVersion: Scalars['Int']['output'];
};

/** A terms document */
export type TermsDocument = {
  __typename?: 'TermsDocument';
  documentType: Scalars['String']['output'];
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** A session */
export type ThirdPartySession = {
  __typename?: 'ThirdPartySession';
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  expiresAt: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  thirdParty: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Tournament information */
export type Tournament = {
  __typename?: 'Tournament';
  bracketLockTime?: Maybe<Scalars['String']['output']>;
  /** All brackets in this tournament */
  brackets?: Maybe<Array<TournamentBracket>>;
  /** Tournament configuration */
  config?: Maybe<TournamentConfig>;
  createdAt: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  /** All entries across all brackets */
  entries?: Maybe<Array<TournamentEntry>>;
  /** Entry fee for this tournament (for instant tournaments) */
  entryFee?: Maybe<Scalars['String']['output']>;
  firstEntryAt?: Maybe<Scalars['String']['output']>;
  gameSlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The requesting user's entry in this tournament with game results. Populated on bet-slip tournament lookups when the user is authenticated. */
  myEntry?: Maybe<TournamentEntry>;
  /** Total prize pool amount (1% of all bet amounts) */
  prizePool: Scalars['String']['output'];
  /** Number of contributions to prize pool made by a specific user */
  prizePoolContributionCountForUser?: Maybe<Scalars['Int']['output']>;
  /** The requesting user's contributions to this tournament's prize pool. Present only when the endpoint was called with a userId. */
  prizePoolContributions?: Maybe<Array<PrizePoolContribution>>;
  startTime: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** Total number of brackets created */
  totalBrackets: Scalars['Int']['output'];
  /** Total number of entries across all brackets */
  totalEntries: Scalars['Int']['output'];
  /** Display name of the tournament */
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentType: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Tournament bracket */
export type TournamentBracket = {
  __typename?: 'TournamentBracket';
  bracketNumber: Scalars['Int']['output'];
  /** Equal share of total prize pool allocated to this bracket */
  bracketPrizePool?: Maybe<Scalars['String']['output']>;
  bracketType: Scalars['String']['output'];
  /** Tournament configuration */
  config?: Maybe<TournamentConfig>;
  currentSize: Scalars['Int']['output'];
  /** Top entries in this bracket */
  entries?: Maybe<Array<BracketEntry>>;
  formedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxSize: Scalars['Int']['output'];
  rankPayouts?: Maybe<Array<RankPayoutEntry>>;
  skillTier?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tournamentId: Scalars['ID']['output'];
};

/** Tournament configuration */
export type TournamentConfig = {
  __typename?: 'TournamentConfig';
  /** Whether tournament results are auto-approved */
  autoApprove?: Maybe<Scalars['Boolean']['output']>;
  betVolumeWeight: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dgfDelayMinutes: Scalars['Int']['output'];
  /** Action to take if minimum fill percentage is not met (for instant tournaments) */
  fillAction?: Maybe<FillAction>;
  /** Time allowed until tournament has to fill */
  fillDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  /** Scoring formulas per game mode */
  gameModeFormulas?: Maybe<Array<GameModeFormula>>;
  gameSlug: Scalars['String']['output'];
  generationConfig?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxGamesTracked: Scalars['Int']['output'];
  /** Maximum players allowed in tournament (for instant tournaments) */
  maxPlayers?: Maybe<Scalars['Int']['output']>;
  /** Metric direction mapping */
  metricDirections?: Maybe<Scalars['Json']['output']>;
  minBracketSize: Scalars['Int']['output'];
  /** Minimum fill percentage required to start tournament (for instant tournaments) */
  minFillPercentage?: Maybe<Scalars['String']['output']>;
  minimumGamesRequired: Scalars['Int']['output'];
  minimumSettledBetsForEntry: Scalars['Int']['output'];
  placesPaidPerBracket: Scalars['Int']['output'];
  primaryMetric: Scalars['String']['output'];
  primaryWeight: Scalars['String']['output'];
  prizeDistribution?: Maybe<Array<PrizeDistributionEntry>>;
  prizePoolCurrency: Scalars['String']['output'];
  prizePoolPercentage: Scalars['String']['output'];
  /** Qualification method */
  qualificationStyle?: Maybe<Scalars['String']['output']>;
  /** Detailed game mode specifications with squad size constraints */
  qualifyingGameModeDetails?: Maybe<Array<QualifyingGameModeDetail>>;
  qualifyingGameModes?: Maybe<Array<Scalars['String']['output']>>;
  /** Rake percentage */
  rakePercentage?: Maybe<Scalars['String']['output']>;
  scoringStrategy: Scalars['String']['output'];
  scoringStrategyConfig?: Maybe<Scalars['Json']['output']>;
  secondaryMetric?: Maybe<Scalars['String']['output']>;
  secondaryWeight: Scalars['String']['output'];
  supersessionStrategy: Scalars['String']['output'];
  targetBracketSize: Scalars['Int']['output'];
  tournamentName?: Maybe<Scalars['String']['output']>;
  tournamentType: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Tournament entry (user's participation in a tournament) */
export type TournamentEntry = {
  __typename?: 'TournamentEntry';
  bracketId?: Maybe<Scalars['ID']['output']>;
  entryTimestamp: Scalars['String']['output'];
  /** Game results recorded against this entry. Populated only when the caller asked for the current user's entry (e.g., my_entry on bet-slip queries). */
  gameResults?: Maybe<Array<GameResult>>;
  gamesPlayedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  meetsMinimumRequirement: Scalars['Boolean']['output'];
  minimumGamesRequired: Scalars['Int']['output'];
  /** The requesting user's contributions to this tournament's prize pool. Populated only when the endpoint was called with a userId. */
  prizePoolContributions?: Maybe<Array<PrizePoolContribution>>;
  projectedPrize?: Maybe<Scalars['String']['output']>;
  rankInBracket?: Maybe<Scalars['Int']['output']>;
  /** Aggregate score breakdown across included games */
  scoreBreakdown?: Maybe<EntryScoreBreakdown>;
  skillTier?: Maybe<Scalars['String']['output']>;
  totalScore: Scalars['String']['output'];
  tournamentId: Scalars['ID']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

/** Tournament entry status enumeration */
export enum TournamentEntryStatus {
  /** Tournaments available for entry */
  AVAILABLE = 'AVAILABLE',
  /** Tournaments that user have completed */
  COMPLETED = 'COMPLETED',
  /** Tournaments that user have qualified for but haven't completed */
  QUALIFIED = 'QUALIFIED'
}

/** List of tournaments with pagination */
export type TournamentList = {
  __typename?: 'TournamentList';
  pagination?: Maybe<PaginationMeta>;
  total: Scalars['Int']['output'];
  tournaments?: Maybe<Array<Tournament>>;
};

/** Tournament results with pagination */
export type TournamentListPaginated = {
  __typename?: 'TournamentListPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  tournaments?: Maybe<Array<Tournament>>;
};

/** Tournament type enumeration */
export enum TournamentType {
  /** Daily tournament */
  DAILY = 'DAILY',
  /** Weekly tournament */
  WEEKLY = 'WEEKLY'
}

/** The response for a paginated transaction history request */
export type TransactionHistoryResponse = {
  __typename?: 'TransactionHistoryResponse';
  /** Array of transaction history entities */
  data: Array<Maybe<WalletApiTransactionHistory>>;
  /** Pagination information */
  metadata: PaginationDetails;
};

/** A market with tournament context for the trending endpoint. */
export type TrendingMarket = {
  __typename?: 'TrendingMarket';
  categoryId?: Maybe<Scalars['ID']['output']>;
  categoryTitle?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMainLine?: Maybe<Scalars['Boolean']['output']>;
  lineGroup?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Array<Maybe<CatalogOutcome>>>;
  source: MarketSource;
  sourceDisplayName?: Maybe<Scalars['String']['output']>;
  status: MarketStatus;
  strike?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalFilled?: Maybe<Scalars['String']['output']>;
  tournamentId: Scalars['ID']['output'];
  tournamentTitle: Scalars['String']['output'];
};

/** Twitch Profile Information */
export type TwitchProfileInfo = {
  __typename?: 'TwitchProfileInfo';
  description?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  twitchCreatedAt?: Maybe<Scalars['String']['output']>;
};

export type TwitchSubscriptionDeletionResponse = {
  __typename?: 'TwitchSubscriptionDeletionResponse';
  /** The Twitch subscription deletion response */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TwitchUserSubscriptionDeletionResponse = {
  __typename?: 'TwitchUserSubscriptionDeletionResponse';
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /** The Twitch subscription deletion response */
  success?: Maybe<Scalars['Boolean']['output']>;
  twitchId?: Maybe<Scalars['String']['output']>;
};

export type TwitchUserSubscriptionResponse = {
  __typename?: 'TwitchUserSubscriptionResponse';
  data?: Maybe<Array<Maybe<SubscriptionData>>>;
  maxTotalCost?: Maybe<Scalars['Int']['output']>;
  /** The Twitch user subscription response */
  total?: Maybe<Scalars['Int']['output']>;
  totalCost?: Maybe<Scalars['Int']['output']>;
};

/** Twitch VODs */
export type TwitchVod = {
  __typename?: 'TwitchVod';
  twitchVodCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  twitchVodDuration?: Maybe<Scalars['String']['output']>;
  twitchVodId?: Maybe<Scalars['String']['output']>;
  twitchVodLink?: Maybe<Scalars['String']['output']>;
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Represents a cod user entity. */
export type User = Node & {
  __typename?: 'User';
  /** The type of account the user has, e.g. standard, partner, admin */
  accountType?: Maybe<Scalars['String']['output']>;
  /** The user's one and only current active team, if there is one */
  activeTeam?: Maybe<Team>;
  /** Verified residential addresses (one per KYC source). Admin-scoped — returns nil unless the caller presents the internal API key. */
  addresses?: Maybe<Array<Maybe<UserAddress>>>;
  ageVerified: Scalars['Boolean']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email?: Maybe<Scalars['String']['output']>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  /** The user's financial data */
  financials: Array<Financials>;
  firstName?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<UserFlags>;
  /** Weighted settled bet counts for game picker */
  gamePickerGamesOrdered?: Maybe<Array<SettledBetCountWeighted>>;
  /** platform status */
  gamePlatformStatus: Array<GamePlatformStatus>;
  gender?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  idVerificationDate?: Maybe<Scalars['DateTime']['output']>;
  idVerificationStatus?: Maybe<VerificationStatus>;
  /** The entity's creation timestmap. */
  insertedAt: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lockedStatus?: Maybe<LockedStatus>;
  /** PL internal username */
  loungeUsername?: Maybe<Scalars['String']['output']>;
  loungeUsernameLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  /** The notes for this user */
  notes?: Maybe<NoteConnection>;
  onfidoApplicantId?: Maybe<Scalars['String']['output']>;
  onfidoLatestTransactionId?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  /** The user's phone number */
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  plCoreUserId?: Maybe<Scalars['String']['output']>;
  /** Platform Identifiers */
  platformIdentifiers?: Maybe<Array<Maybe<PlatformIdentifier>>>;
  promoCode?: Maybe<Scalars['String']['output']>;
  /** Playthrough Requirements */
  ptrs?: Maybe<Array<Maybe<Ptr>>>;
  /** the users referral codes */
  referralCodes?: Maybe<Array<Maybe<ReferralCode>>>;
  /** Last four digits of the user's SSN. Admin-scoped — returns nil unless the caller presents the internal API key. */
  ssnLast4?: Maybe<Scalars['String']['output']>;
  stakingStats?: Maybe<StakeUserGameStats>;
  /** Where the user is upto in registering, step 3 is complete */
  stepRegister: Scalars['String']['output'];
  /** The teams this user is a member of */
  teams?: Maybe<TeamConnection>;
  underReview?: Maybe<Scalars['Boolean']['output']>;
  /** The entity's last update timestamp. */
  updatedAt: Scalars['DateTime']['output'];
  userBettingStatus: Array<UserBettingStatus>;
  /** the users referred users */
  userReferrals?: Maybe<Array<Maybe<UserReferral>>>;
  /** the users seen special rules */
  userSpecialRules?: Maybe<Array<Maybe<SpecialRuleUser>>>;
  userStakingStatus: Array<UserStakingOfferStatus>;
  verifiedDocument?: Maybe<Scalars['String']['output']>;
  walletStats?: Maybe<UserWalletStats>;
};


/** Represents a cod user entity. */
export type UserGamePlatformStatusArgs = {
  game?: InputMaybe<Games>;
};


/** Represents a cod user entity. */
export type UserNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a cod user entity. */
export type UserTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a cod user entity. */
export type UserUserBettingStatusArgs = {
  game?: InputMaybe<Games>;
};

/**
 * A verified residential address attached to a user. Fields are stored
 * encrypted at rest in pl-connect and only decrypted on egress through
 * admin-scoped GraphQL resolvers.
 */
export type UserAddress = {
  __typename?: 'UserAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The verification provider that produced this address (e.g. "frame"). */
  source: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the source verified this address. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserBettingStatus = {
  __typename?: 'UserBettingStatus';
  /** The game that this betting status is for */
  game: Games;
  /** The status for this betting status */
  status: UserBettingStatuses;
};

export enum UserBettingStatuses {
  /** User can bet */
  CAN_BET = 'CAN_BET',
  /** The user hasn't yet accepted the fair play terms */
  FAIR_PLAY_TERMS_NOT_ACCEPTED = 'FAIR_PLAY_TERMS_NOT_ACCEPTED',
  /** User locked by admin */
  LOCKED_BY_ADMIN = 'LOCKED_BY_ADMIN',
  /** Not enough matches stored for the given game(s) */
  NOT_ENOUGH_MATCHES_FOR_GAME = 'NOT_ENOUGH_MATCHES_FOR_GAME',
  /** Platform status for game not ready */
  PLATFORM_NOT_READY = 'PLATFORM_NOT_READY',
  /** System betting flag has been disabled */
  SYSTEM_BETTING_DISABLED = 'SYSTEM_BETTING_DISABLED',
  /** Linking of an account that differs from previous twitch account was linked */
  TWITCH_ALTERNATE_ACCOUNT = 'TWITCH_ALTERNATE_ACCOUNT',
  /** Currently linking twitch account */
  TWITCH_LINKING = 'TWITCH_LINKING',
  /** Twitch needs reauthorisation */
  TWITCH_NEED_REAUTH = 'TWITCH_NEED_REAUTH',
  /** Twitch is required but not linked */
  TWITCH_NOT_LINKED = 'TWITCH_NOT_LINKED',
  /** The user hasn't acknowledged muting settings */
  TWITCH_NOT_MUTED = 'TWITCH_NOT_MUTED',
  /** The user is not currently streaming on twitch */
  TWITCH_NOT_STREAMING = 'TWITCH_NOT_STREAMING',
  /** Failed to fetch the twitch token */
  TWITCH_TOKEN_FETCH_FAILED = 'TWITCH_TOKEN_FETCH_FAILED',
  /** Another user is already using this token */
  TWITCH_TOKEN_IN_USE = 'TWITCH_TOKEN_IN_USE',
  /** The user VOD settings could not be verified */
  TWITCH_VOD_NOT_ENABLED = 'TWITCH_VOD_NOT_ENABLED',
  /** Something went wrong checking validation. */
  UNEXPECTED_VALIDATION_ERROR = 'UNEXPECTED_VALIDATION_ERROR'
}

/** A user's flags */
export type UserFlags = {
  __typename?: 'UserFlags';
  codMatchCountBypass: Scalars['Boolean']['output'];
  comboBetsEnabled: Scalars['Boolean']['output'];
  disallowBets: Scalars['Boolean']['output'];
  disallowDeposits: Scalars['Boolean']['output'];
  disallowWithdrawals: Scalars['Boolean']['output'];
  mmpBetsEnabled?: Maybe<Scalars['Boolean']['output']>;
  stakingEnabled: Scalars['Boolean']['output'];
  stakingFairPlayTermsAccepted: Scalars['Boolean']['output'];
};

/** Represents a user game info */
export type UserGameInfo = {
  __typename?: 'UserGameInfo';
  createdAt?: Maybe<Scalars['String']['output']>;
  gameSlug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maximumStakeAmount?: Maybe<Scalars['Float']['output']>;
  maximumStakeMultiplier?: Maybe<Scalars['Float']['output']>;
  stakingOfferEnabled?: Maybe<Scalars['Boolean']['output']>;
  stakingOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  totalBetsStaked?: Maybe<Scalars['Int']['output']>;
  totalServiceFeeAmount?: Maybe<Scalars['Float']['output']>;
  totalStakedAmount?: Maybe<Array<Maybe<Financials>>>;
  totalWinnings?: Maybe<Array<Maybe<Financials>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserGameStatistics = {
  __typename?: 'UserGameStatistics';
  form?: Maybe<Array<Maybe<BetSlipForm>>>;
  lifetimeBetCount?: Maybe<Scalars['Int']['output']>;
  lifetimeStakes?: Maybe<Scalars['String']['output']>;
};

export type UserLimitUsage = {
  __typename?: 'UserLimitUsage';
  limit: Scalars['String']['output'];
  period: Scalars['String']['output'];
  remaining: Scalars['String']['output'];
  used: Scalars['String']['output'];
};

/** A user's deposit and withdrawal limits */
export type UserLimits = {
  __typename?: 'UserLimits';
  depositLimits?: Maybe<Array<UserLimitUsage>>;
  /** @deprecated Use depositLimits.limit for the entry with period "daily". */
  maxDailyDeposit: Scalars['String']['output'];
  /** @deprecated Use withdrawalLimits.limit for the entry with period "daily". */
  maxDailyWithdrawal: Scalars['String']['output'];
  /** @deprecated Use depositLimits.limit for the entry with period "weekly". */
  maxWeeklyDeposit: Scalars['String']['output'];
  /** @deprecated Use withdrawalLimits.limit for the entry with period "weekly". */
  maxWeeklyWithdrawal: Scalars['String']['output'];
  paypalWithdrawalEmail?: Maybe<Scalars['String']['output']>;
  withdrawalLimits?: Maybe<Array<UserLimitUsage>>;
};

export type UserMutationOutput = Node & {
  __typename?: 'UserMutationOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  result?: Maybe<User>;
};

export type UserOmniBalanceBetLevelResultInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  financials: Array<InputMaybe<FinancialsInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  level: Scalars['Int']['input'];
  mysteryBet?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
};

/** Paginated response for user parlays */
export type UserParlaysResponse = {
  __typename?: 'UserParlaysResponse';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** List of parlays */
  parlays: Array<ParlayProduct>;
};

/** Represents a user game info */
export type UserPartnershipGameInfo = {
  __typename?: 'UserPartnershipGameInfo';
  createdAt?: Maybe<Scalars['String']['output']>;
  gameSlug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maximumStakeAmount?: Maybe<Scalars['Float']['output']>;
  maximumStakeMultiplier?: Maybe<Scalars['Float']['output']>;
  stakedUserId?: Maybe<Scalars['String']['output']>;
  stakingOfferEnabled?: Maybe<Scalars['Boolean']['output']>;
  stakingOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  totalBetsStaked?: Maybe<Scalars['Int']['output']>;
  totalServiceFeeAmount?: Maybe<Scalars['Float']['output']>;
  totalStakedAmount?: Maybe<Array<Maybe<Financials>>>;
  totalWinnings?: Maybe<Array<Maybe<Financials>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserPaymentLimits = {
  __typename?: 'UserPaymentLimits';
  depositLimits?: Maybe<Array<UserLimitUsage>>;
  withdrawalLimits?: Maybe<Array<UserLimitUsage>>;
};

/** An object containing the id, platform and username of a user */
export type UserPlatform = {
  __typename?: 'UserPlatform';
  associatedPlatform: Platforms;
  associatedUsername: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Represents a user referral */
export type UserReferral = Node & {
  __typename?: 'UserReferral';
  firstDepositPlacedCompleted?: Maybe<Scalars['Boolean']['output']>;
  firstDepositPlacedCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  payouts?: Maybe<Array<Maybe<Payout>>>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referredUser: User;
  referredUserId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A login session (one per device/login). */
export type UserSession = {
  __typename?: 'UserSession';
  /** Anonymizer classification flags (hosting, cloud:*, tor, vpn, apple_private_relay, ...). Null until the geolocation service has reported. Admin only; null for the session owner. */
  anonymizerFlags?: Maybe<Array<Scalars['String']['output']>>;
  appType?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  /** Human-readable device label (device name, model + OS, or browser + OS). */
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Autonomous system number of the last IP seen on this session, from the geolocation service. Admin only; null for the session owner. */
  ipAsn?: Maybe<Scalars['Int']['output']>;
  /** Organisation that operates that network (e.g. AMAZON-02). Admin only; null for the session owner. */
  ipOrg?: Maybe<Scalars['String']['output']>;
  /** True when the last IP is a VPN, proxy, Tor exit or hosting/cloud address. Apple Private Relay alone does not count. Admin only; null for the session owner. */
  isAnonymizer?: Maybe<Scalars['Boolean']['output']>;
  /** True for the session that made this request. */
  isCurrent: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  lastIp?: Maybe<Scalars['String']['output']>;
  lastSeenAt: Scalars['DateTime']['output'];
  loginMethod: Scalars['String']['output'];
  osName?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
};

export type UserSetFlagsErrors = Node & {
  __typename?: 'UserSetFlagsErrors';
  code?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
};

export type UserSetFlagsMutationOutput = Node & {
  __typename?: 'UserSetFlagsMutationOutput';
  errors?: Maybe<UserSetFlagsErrors>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  result?: Maybe<User>;
};

export type UserStakingOfferStatus = {
  __typename?: 'UserStakingOfferStatus';
  /** The game that this staking offer status is for */
  game: Games;
  /** The status for this staking offer status */
  status: UserStakingOfferStatuses;
};

export enum UserStakingOfferStatuses {
  /** User can create stakes when placing a bet */
  CAN_CREATE_BET = 'CAN_CREATE_BET',
  /** Game isn't supported for staking */
  GAME_NOT_SUPPORTED = 'GAME_NOT_SUPPORTED',
  /** User hasn't played enough games to be able to create stakes */
  NOT_ENOUGH_COMPLETED_MATCHES_FOR_GAME = 'NOT_ENOUGH_COMPLETED_MATCHES_FOR_GAME',
  /** Twitch needs reauthorisation */
  TWITCH_NEED_REAUTH = 'TWITCH_NEED_REAUTH',
  /** Twitch is required but not linked */
  TWITCH_NOT_LINKED = 'TWITCH_NOT_LINKED',
  /** The user hasn't acknowledged muting settings */
  TWITCH_NOT_MUTED = 'TWITCH_NOT_MUTED',
  /** The user is not currently streaming on twitch */
  TWITCH_NOT_STREAMING = 'TWITCH_NOT_STREAMING',
  /** Failed to fetch the twitch token */
  TWITCH_TOKEN_FETCH_FAILED = 'TWITCH_TOKEN_FETCH_FAILED',
  /** The user VOD settings could not be verified */
  TWITCH_VOD_NOT_ENABLED = 'TWITCH_VOD_NOT_ENABLED'
}

/** User Wallet Stats */
export type UserWalletStats = {
  __typename?: 'UserWalletStats';
  averageAmountDeposited?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cumulativeProfit?: Maybe<Scalars['String']['output']>;
  cumulativeWinnings?: Maybe<Scalars['String']['output']>;
  depositCount?: Maybe<Scalars['String']['output']>;
  firstDepositAmount?: Maybe<Scalars['String']['output']>;
  firstDepositDate?: Maybe<Scalars['String']['output']>;
  firstDepositTransactionId?: Maybe<Scalars['ID']['output']>;
  highestDepositAmount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mostRecentDepositAmount?: Maybe<Scalars['String']['output']>;
  mostRecentDepositTimestamp?: Maybe<Scalars['String']['output']>;
  paymentLimits?: Maybe<UserPaymentLimits>;
  totalAmountDeposited?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Address subset for the standalone verification read. */
export type ValidateAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type Valorant = {
  __typename?: 'Valorant';
  ability1Casts?: Maybe<Scalars['String']['output']>;
  ability2Casts?: Maybe<Scalars['String']['output']>;
  character?: Maybe<ValorantCharacter>;
  characterId?: Maybe<Scalars['String']['output']>;
  competitiveTier?: Maybe<Scalars['String']['output']>;
  customGameName?: Maybe<Scalars['String']['output']>;
  gameMode?: Maybe<Scalars['String']['output']>;
  gameName?: Maybe<Scalars['String']['output']>;
  gameSlug: Scalars['String']['output'];
  gameVersion?: Maybe<Scalars['String']['output']>;
  gamerTag: Scalars['String']['output'];
  grenadesCast?: Maybe<Scalars['String']['output']>;
  isCompleted?: Maybe<Scalars['String']['output']>;
  isObserver?: Maybe<Scalars['String']['output']>;
  isRanked?: Maybe<Scalars['String']['output']>;
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  matchDuration?: Maybe<Scalars['String']['output']>;
  matchEndDate?: Maybe<Scalars['String']['output']>;
  matchId?: Maybe<Scalars['String']['output']>;
  matchRegion?: Maybe<Scalars['String']['output']>;
  matchStartDate?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  partyId?: Maybe<Scalars['String']['output']>;
  playerAssists?: Maybe<Scalars['String']['output']>;
  playerCard?: Maybe<Scalars['String']['output']>;
  playerDeaths?: Maybe<Scalars['String']['output']>;
  playerKills?: Maybe<Scalars['String']['output']>;
  playerRounds?: Maybe<Scalars['Json']['output']>;
  playerRoundsPlayed?: Maybe<Scalars['String']['output']>;
  playerScore?: Maybe<Scalars['String']['output']>;
  playerTitle?: Maybe<Scalars['String']['output']>;
  playtimeMillis?: Maybe<Scalars['String']['output']>;
  provisionFlowId?: Maybe<Scalars['String']['output']>;
  queueId?: Maybe<Scalars['String']['output']>;
  seasonId?: Maybe<Scalars['String']['output']>;
  tagLine?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  teamNumPoints?: Maybe<Scalars['String']['output']>;
  teamRoundsPlayed?: Maybe<Scalars['String']['output']>;
  teamRoundsWon?: Maybe<Scalars['String']['output']>;
  teamWon?: Maybe<Scalars['String']['output']>;
  ultimateCasts?: Maybe<Scalars['String']['output']>;
  userIdentifier: Scalars['String']['output'];
};

export type ValorantCharacter = {
  __typename?: 'ValorantCharacter';
  name?: Maybe<Scalars['String']['output']>;
};

export enum VerificationStatus {
  /** User has completed verification and verification is approved */
  APPROVED = 'APPROVED',
  /** User has not started verification */
  INACTIVE = 'INACTIVE',
  /** User has started verification and verification is pending */
  PENDING = 'PENDING',
  /** User's verification was rejected */
  REJECTED = 'REJECTED',
  /** User has started verification and needs manual review */
  REVIEW = 'REVIEW'
}

/** Response returned from verifying a device with Apple */
export type VerifyDeviceResponse = {
  __typename?: 'VerifyDeviceResponse';
  /** Boolean value to determine whether the verification was successful, and the user can sign up */
  success: Scalars['Boolean']['output'];
};

export type VerifyLoginCodeInput = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Twitch VOD information enriched on a bet item by the bets service */
export type VodInfo = {
  __typename?: 'VodInfo';
  /** ISO 8601 timestamp the twitch stream started at, used to derive offsets */
  twitchStreamStartedAt?: Maybe<Scalars['String']['output']>;
  /** Base twitch VOD url with the ?t= parameter stripped */
  twitchVodBaseUrl?: Maybe<Scalars['String']['output']>;
  /** Computed VOD-relative match end offset, formatted like 1h30m23s */
  twitchVodEndTime?: Maybe<Scalars['String']['output']>;
  /** Original twitch VOD link as supplied (may include a ?t= offset) */
  twitchVodLink?: Maybe<Scalars['String']['output']>;
  /** Computed VOD-relative match start offset, formatted like 1h15m23s */
  twitchVodStartTime?: Maybe<Scalars['String']['output']>;
  /** Twitch VOD ID, when known */
  vodId?: Maybe<Scalars['String']['output']>;
};

/** Represents a wallet entity. */
export type Wallet = Node & {
  __typename?: 'Wallet';
  /** Wallet Funds / Balance */
  funds: Scalars['Decimal']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
};

/** Represents a transaction history entity from the wallet api */
export type WalletApiTransactionHistory = {
  __typename?: 'WalletApiTransactionHistory';
  /** How much this transaction was for */
  amount: Scalars['String']['output'];
  /** The balance after the transaction was completed */
  balanceAfter: Scalars['String']['output'];
  /** The balance before the transaction was completed */
  balanceBefore: Scalars['String']['output'];
  /** A short context for the related balance update */
  context?: Maybe<Scalars['String']['output']>;
  /** When the transaction history entity was created */
  createdAt: Scalars['String']['output'];
  /** The user facing description */
  description: Scalars['String']['output'];
  /** ID of the transaction */
  id: Scalars['ID']['output'];
  /** Any additional metadata that was added to the balance update request */
  metadata?: Maybe<WalletApiTransactionMetadata>;
  /** The triggering event for this balance update transaction history entity */
  source: Scalars['String']['output'];
  /** The status for the related balance update */
  status?: Maybe<Scalars['String']['output']>;
  /** The currency type for this transaction */
  type: Scalars['String']['output'];
  /** When the transaction history entity was last updated */
  updatedAt: Scalars['String']['output'];
  /** The user_id for this transaction */
  userId: Scalars['String']['output'];
  /** The funding balance type for this transaction */
  wallet?: Maybe<WalletApiTransactionHistoryWallet>;
  /** The wallet ID that this transaction entity relates to */
  walletId: Scalars['Int']['output'];
};

export type WalletApiTransactionHistoryWallet = {
  __typename?: 'WalletApiTransactionHistoryWallet';
  balance?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<WalletApiTransactionHistoryWalletType>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type WalletApiTransactionHistoryWalletType = {
  __typename?: 'WalletApiTransactionHistoryWalletType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

/** Represents a transactions metadata */
export type WalletApiTransactionMetadata = {
  __typename?: 'WalletApiTransactionMetadata';
  /** The bet ID that this transaction relates to */
  betId?: Maybe<Scalars['ID']['output']>;
  /** The brand of a card */
  brand?: Maybe<Scalars['String']['output']>;
  /** The first six digits of a card */
  cardBin?: Maybe<Scalars['String']['output']>;
  /** The last four digits of a card */
  cardSummary?: Maybe<Scalars['String']['output']>;
  /** The cashtag used for a deposit or withdrawal */
  cashtag?: Maybe<Scalars['String']['output']>;
  /** The email that was used for said transaction history entry */
  email?: Maybe<Scalars['String']['output']>;
  /** Expected withdrawal due date */
  expectedDueDate?: Maybe<Scalars['String']['output']>;
  /** Withdrawal expedite tier */
  expediteTier?: Maybe<Scalars['String']['output']>;
  /** The funding source type for a card */
  fundingSource?: Maybe<Scalars['String']['output']>;
  /** message */
  message?: Maybe<Scalars['String']['output']>;
  /** Staking offer id */
  offerId?: Maybe<Scalars['String']['output']>;
  /** Staking order id */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Parlay id */
  parlayId?: Maybe<Scalars['String']['output']>;
  /** The paypal payer id */
  payerId?: Maybe<Scalars['String']['output']>;
  /** The withdrawal id */
  paymentStatusId?: Maybe<Scalars['String']['output']>;
  /** The paypal email used */
  paypalEmail?: Maybe<Scalars['String']['output']>;
  /** The provider that was used for a deposit or withdrawal */
  provider?: Maybe<Scalars['String']['output']>;
  /** The requested withdrawal amount */
  requestedWithdrawalAmount?: Maybe<Scalars['String']['output']>;
  /** Service fee applied to the bet */
  serviceFee?: Maybe<Scalars['String']['output']>;
  /** The tournament ID that this transaction relates to */
  tournamentId?: Maybe<Scalars['ID']['output']>;
};

export type Wardogs = {
  __typename?: 'Wardogs';
  gameSlug: Scalars['String']['output'];
};

/** Metadata related to the deposit refund information */
export type WithdrawalAmendmentDepositAmount = {
  __typename?: 'WithdrawalAmendmentDepositAmount';
  /** The amount refunded for this deposit in cents */
  depositAmountRefunded: Scalars['String']['output'];
  /** The ID of the deposit payment status */
  depositPaymentStatusId: Scalars['ID']['output'];
};

/** Metadata related to the deposit refund information */
export type WithdrawalAmendmentInfoMetadata = {
  __typename?: 'WithdrawalAmendmentInfoMetadata';
  /** The original withdrawal amount in cents */
  originalWithdrawalAmount: Scalars['String']['output'];
  /** The total amount refunded for deposits related to this withdrawal amendment in cents */
  totalDepositAmountRefunded: Scalars['String']['output'];
  /** The total difference between the deposit and withdrawal amounts in cents */
  totalDifferenceBetweenDepositAndWithdrawal: Scalars['String']['output'];
  /** A list of deposit amounts related to the withdrawal amendment */
  withdrawalAmendmentDepositAmounts?: Maybe<Array<WithdrawalAmendmentDepositAmount>>;
};

/** The information returned for all withdrawal operations */
export type WithdrawalResponse = {
  __typename?: 'WithdrawalResponse';
  /** The amount (in cents) of the withdrawal request */
  amount: Scalars['Int']['output'];
  associatedRefundedDeposits?: Maybe<Array<Maybe<DepositResponse>>>;
  /** Payment creation date time */
  createdAt: Scalars['String']['output'];
  /** The urgency/speed at which the user would like the withdrawl to occur ('free', 'standard', or 'expedite) */
  expediteTier: ExpediteTierEnum;
  /** Fee charged for withdrawal */
  expediteTierFee: Scalars['String']['output'];
  /** The ID of the withdrawal */
  id: Scalars['ID']['output'];
  /** Latest due date */
  latestDueDate: Scalars['String']['output'];
  /** Metadata related to the payment status */
  metadata?: Maybe<PaymentStatusMetadata>;
  /** The latest status of the withdrawal request */
  mostRecentStatus: Status;
  /** The platform for this request (currently only 'paypal' is supported) */
  provider: ProviderEnum;
  /** Payment provider details */
  providerDetails: PaymentProviderDetails;
  /** Payments API user details */
  user?: Maybe<PaymentUserDetails>;
};

export enum WithdrawalStatus {
  /** Deposit or Withdrawal has been approved */
  APPROVED = 'APPROVED',
  /** Deposit or Withdrawal has been cancelled */
  CANCELLED = 'CANCELLED',
  /** Deposit or Withdrawal has been completed */
  COMPLETED = 'COMPLETED',
  /** Deposit or Withdrawal has been declined */
  DECLINED = 'DECLINED',
  /** Deposit or Withdrawal has failed */
  FAILED = 'FAILED',
  /** Deposit or Withdrawal is in review with an admin */
  IN_REVIEW = 'IN_REVIEW',
  /** Something went wrong during the processing of this Deposit or Withdrawal. Manual admin intervention is required */
  MANUAL_INTERVENTION_REQUIRED = 'MANUAL_INTERVENTION_REQUIRED',
  /** Deposit or Withdrawal has not been reviewed yet */
  PENDING = 'PENDING',
  /** User is required to complete additional actions before payment can be processed */
  PENDING_USER_ACTION = 'PENDING_USER_ACTION',
  /** Deposit or Withdrawal is being processed */
  PROCESSING = 'PROCESSING',
  /** Deposit or Withdrawal has been refunded */
  REFUNDED = 'REFUNDED',
  /** Deposit or Withdrawal has been rejected */
  REJECTED = 'REJECTED'
}

export type BetItemSingleGameParlayFragment = { __typename?: 'Parlay', id: string, legTypesTaken: Array<string | null>, numberOfLegs: number, won?: boolean | null };

export type BetItemSingleGameBountyFragment = { __typename?: 'Bounty', ranges: Array<{ __typename?: 'BetItemRange', bountyIncrement: string, bountyTimesAchievable: string, payoutMultiplier?: string | null, bountyRange: Array<{ __typename?: 'BetItemBountyRange', linesValue: string, type: string } | null> } | null> };

export type BetItemMultiGameParlayItemFragment = { __typename?: 'MultiGameParlay', failuresAllowed: number, successesRequired: number, legs: Array<{ __typename?: 'MultiGameParlayLeg', updatedAt: string, insertedAt: string, id: string, matchId?: string | null, order: number, status: MultiGameParlayStatusEnum, achievedValue: Array<{ __typename?: 'AchievedValue', metBetObjective: boolean, type: string, value: string }> }>, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> };

export type ApexStatsFragment = { __typename?: 'Apex', legendUsed?: string | null, matchEndDate?: string | null, playerKills?: string | null, playerRankScoreChange?: string | null, playerTimesPlacedTopThree?: string | null };

export type SpecialRulesFragment = { __typename?: 'SpecialRules', id: string, systemId: string, ruleDisplay: Array<string> };

export type BetItemFragment = { __typename?: 'BetItem', achievedMultiplier?: string | null, achievedValue?: string | null, percentageOfBet?: string | null, betAmount?: string | null, betType?: BetTypeEnum | null, currencyType?: string | null, matches?: any | null, gameSlug?: string | null, id: string, insertedAt?: string | null, level?: number | null, linesValue?: string | null, matchId?: string | null, payout?: string | null, payoutMultiplier?: string | null, refundCurrencyType?: string | null, refundReason?: string | null, refunded?: boolean | null, resolutionMethod?: string | null, resolved?: boolean | null, title?: string | null, type?: string | null, updatedAt?: string | null, won?: boolean | null, events?: Array<{ __typename?: 'BetItemEvent', event?: string | null, insertedAt?: string | null, updatedAt?: string | null } | null> | null, gameData?: { __typename?: 'GameData', apexLegend?: string | null, gameMode?: string | null, map?: string | null, squadSize?: number | null } | null, metadata: { __typename?: 'BetItemMetadata', specialRulesApplied?: Array<string | null> | null, singleGameParlay?: { __typename?: 'Parlay', id: string, legTypesTaken: Array<string | null>, numberOfLegs: number, won?: boolean | null } | null, singleGameBounty?: { __typename?: 'Bounty', ranges: Array<{ __typename?: 'BetItemRange', bountyIncrement: string, bountyTimesAchievable: string, payoutMultiplier?: string | null, bountyRange: Array<{ __typename?: 'BetItemBountyRange', linesValue: string, type: string } | null> } | null> } | null, multiGameParlay?: { __typename?: 'MultiGameParlay', failuresAllowed: number, successesRequired: number, legs: Array<{ __typename?: 'MultiGameParlayLeg', updatedAt: string, insertedAt: string, id: string, matchId?: string | null, order: number, status: MultiGameParlayStatusEnum, achievedValue: Array<{ __typename?: 'AchievedValue', metBetObjective: boolean, type: string, value: string }> }>, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> } | null, specialRules?: Array<{ __typename?: 'SpecialRules', id: string, systemId: string, ruleDisplay: Array<string> } | null> | null }, fundingSources?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, matchStats?: Array<
    | { __typename: 'Apex', legendUsed?: string | null, matchEndDate?: string | null, playerKills?: string | null, playerRankScoreChange?: string | null, playerTimesPlacedTopThree?: string | null }
    | { __typename: 'ArcRaiders' }
    | { __typename: 'Battlefield6' }
    | { __typename: 'Cfb25' }
    | { __typename: 'Chess' }
    | { __typename: 'ClashRoyale' }
    | { __typename: 'Codbo1' }
    | { __typename: 'Codbo2' }
    | { __typename: 'Codbo6' }
    | { __typename: 'Codbo7' }
    | { __typename: 'Codmw3' }
    | { __typename: 'Codmw4' }
    | { __typename: 'Codwz2' }
    | { __typename: 'Cs2' }
    | { __typename: 'Dota2' }
    | { __typename: 'Eafc25' }
    | { __typename: 'Eafc26' }
    | { __typename: 'Eafc27' }
    | { __typename: 'Fortnite' }
    | { __typename: 'Game2xko' }
    | { __typename: 'Gta5' }
    | { __typename: 'Gta6' }
    | { __typename: 'Gwent' }
    | { __typename: 'Hearthstone' }
    | { __typename: 'LeagueOfLegends' }
    | { __typename: 'Madden25' }
    | { __typename: 'Madden26' }
    | { __typename: 'Madden27' }
    | { __typename: 'MarvelRivals' }
    | { __typename: 'MarvelTokon' }
    | { __typename: 'Nba2k25' }
    | { __typename: 'Nba2k26' }
    | { __typename: 'Nba2k27' }
    | { __typename: 'R6Siege' }
    | { __typename: 'RocketLeague' }
    | { __typename: 'TeamfightTactics' }
    | { __typename: 'Valorant' }
    | { __typename: 'Wardogs' }
   | null> | null };

export type SingleGameOptionsFragment = { __typename: 'SingleGameTeamOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, title: string, titleDisplayStrategy: BetDisplayOptions };

export type SingleGameBountyOptionsFragment = { __typename: 'SingleGameTeamBountyOption', id?: string | null, level: string, payout: string, selected: boolean, win: string, titleDisplayStrategy: BetDisplayOptions, ranges: Array<{ __typename?: 'BountyRange', bountyIncrement: string, bountyTimesAchievable: string, payout: string, payoutMultiplier: string, bountyRange: Array<{ __typename?: 'Range', title: string, type: string } | null> } | null> };

export type ParlayBetItemFragment = { __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions };

export type SingleGameTeamParlayOptionsFragment = { __typename: 'SingleGameTeamParlayOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> };

export type MultiGameTeamPayoutsFragment = { __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> };

export type MultiGameTeamParlayOptionsFragment = { __typename: 'MultiGameTeamParlayOption', id?: string | null, level: string, selected: boolean, failuresAllowed: number, successesRequired: number, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> };

export type BetSlipFragment = { __typename?: 'BetSlip', id: string, updatedAt: string, resolvedAt?: string | null, status: string, refundReason?: string | null, insertedAt: string, groupBetId?: string | null, betTotalAmount: string, payout?: string | null, serviceFee: string, user: { __typename?: 'User', id: string }, stakeOffer?: { __typename?: 'StakeOffer', id: string, status: string, maximumMultiplier: number, reward?: { __typename?: 'StakeOfferReward', id: string, rewards: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, orders?: Array<{ __typename?: 'StakeOrder', id: string, createdAt: string, payout?: { __typename?: 'StakeOrderPayout', payouts: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, user: { __typename?: 'User', loungeUsername?: string | null, id: string, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', id?: string | null, gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', id?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null, twitchStreamInfo?: { __typename?: 'StreamInfo', thumbnailUrl?: string | null } | null } | null } | null> | null }, fundingSource: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null> | null } | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, team?: { __typename?: 'Team', gameSlug: string } | null, betItems: Array<{ __typename?: 'BetItem', achievedMultiplier?: string | null, achievedValue?: string | null, percentageOfBet?: string | null, betAmount?: string | null, betType?: BetTypeEnum | null, currencyType?: string | null, matches?: any | null, gameSlug?: string | null, id: string, insertedAt?: string | null, level?: number | null, linesValue?: string | null, matchId?: string | null, payout?: string | null, payoutMultiplier?: string | null, refundCurrencyType?: string | null, refundReason?: string | null, refunded?: boolean | null, resolutionMethod?: string | null, resolved?: boolean | null, title?: string | null, type?: string | null, updatedAt?: string | null, won?: boolean | null, events?: Array<{ __typename?: 'BetItemEvent', event?: string | null, insertedAt?: string | null, updatedAt?: string | null } | null> | null, gameData?: { __typename?: 'GameData', apexLegend?: string | null, gameMode?: string | null, map?: string | null, squadSize?: number | null } | null, metadata: { __typename?: 'BetItemMetadata', specialRulesApplied?: Array<string | null> | null, singleGameParlay?: { __typename?: 'Parlay', id: string, legTypesTaken: Array<string | null>, numberOfLegs: number, won?: boolean | null } | null, singleGameBounty?: { __typename?: 'Bounty', ranges: Array<{ __typename?: 'BetItemRange', bountyIncrement: string, bountyTimesAchievable: string, payoutMultiplier?: string | null, bountyRange: Array<{ __typename?: 'BetItemBountyRange', linesValue: string, type: string } | null> } | null> } | null, multiGameParlay?: { __typename?: 'MultiGameParlay', failuresAllowed: number, successesRequired: number, legs: Array<{ __typename?: 'MultiGameParlayLeg', updatedAt: string, insertedAt: string, id: string, matchId?: string | null, order: number, status: MultiGameParlayStatusEnum, achievedValue: Array<{ __typename?: 'AchievedValue', metBetObjective: boolean, type: string, value: string }> }>, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> } | null, specialRules?: Array<{ __typename?: 'SpecialRules', id: string, systemId: string, ruleDisplay: Array<string> } | null> | null }, fundingSources?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, matchStats?: Array<
      | { __typename: 'Apex', legendUsed?: string | null, matchEndDate?: string | null, playerKills?: string | null, playerRankScoreChange?: string | null, playerTimesPlacedTopThree?: string | null }
      | { __typename: 'ArcRaiders' }
      | { __typename: 'Battlefield6' }
      | { __typename: 'Cfb25' }
      | { __typename: 'Chess' }
      | { __typename: 'ClashRoyale' }
      | { __typename: 'Codbo1' }
      | { __typename: 'Codbo2' }
      | { __typename: 'Codbo6' }
      | { __typename: 'Codbo7' }
      | { __typename: 'Codmw3' }
      | { __typename: 'Codmw4' }
      | { __typename: 'Codwz2' }
      | { __typename: 'Cs2' }
      | { __typename: 'Dota2' }
      | { __typename: 'Eafc25' }
      | { __typename: 'Eafc26' }
      | { __typename: 'Eafc27' }
      | { __typename: 'Fortnite' }
      | { __typename: 'Game2xko' }
      | { __typename: 'Gta5' }
      | { __typename: 'Gta6' }
      | { __typename: 'Gwent' }
      | { __typename: 'Hearthstone' }
      | { __typename: 'LeagueOfLegends' }
      | { __typename: 'Madden25' }
      | { __typename: 'Madden26' }
      | { __typename: 'Madden27' }
      | { __typename: 'MarvelRivals' }
      | { __typename: 'MarvelTokon' }
      | { __typename: 'Nba2k25' }
      | { __typename: 'Nba2k26' }
      | { __typename: 'Nba2k27' }
      | { __typename: 'R6Siege' }
      | { __typename: 'RocketLeague' }
      | { __typename: 'TeamfightTactics' }
      | { __typename: 'Valorant' }
      | { __typename: 'Wardogs' }
     | null> | null } | null> };

export type SettledBetDenominationCountsFragment = { __typename?: 'SettledBetDenominationCounts', one?: number | null, three?: number | null, five?: number | null, ten?: number | null, twentyfive?: number | null, fifty?: number | null, onehundred?: number | null };

export type GamePlatformStatusFragment = { __typename?: 'GamePlatformStatus', game: Games, platform: Platforms, status: PlatformBettingStatus, userIdentifier?: string | null, metadata: { __typename?: 'GamePlatformStatusMetadata', character?: string | null, killsBanner?: boolean | null, lastUpdatedAt?: string | null, topThreeBanner?: boolean | null, totalMatchesBanner?: boolean | null, lastUserFetch?: string | null, storedMatchCount?: string | null, betsPlaced?: number | null, betsSettled?: number | null, betsRefunded?: number | null, twitchRequired?: boolean | null, twitchAudioMuted?: boolean | null, fetchFailReason?: string | null, initialFetchState?: string | null, settledBetDenominationCounts?: { __typename?: 'SettledBetDenominationCounts', one?: number | null, three?: number | null, five?: number | null, ten?: number | null, twentyfive?: number | null, fifty?: number | null, onehundred?: number | null } | null } };

export type PaginationDetailsFragment = { __typename?: 'PaginationDetails', page?: number | null, take?: number | null, pageCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null };

export type StakeOrderFragment = { __typename?: 'StakeOrder', id: string, createdAt: string, payout?: { __typename?: 'StakeOrderPayout', payouts: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, user: { __typename?: 'User', loungeUsername?: string | null, id: string, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', id?: string | null, gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', id?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null, twitchStreamInfo?: { __typename?: 'StreamInfo', thumbnailUrl?: string | null } | null } | null } | null> | null }, fundingSource: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> };

export type BetLineItemFragment = { __typename?: 'BetLineItem', betType: BetType, category: string, cost: string, title: string, lineType: string, required: boolean, options: Array<
    | { __typename: 'MultiGameTeamParlayOption', id?: string | null, level: string, selected: boolean, failuresAllowed: number, successesRequired: number, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
    | { __typename: 'SingleGameTeamBountyOption', id?: string | null, level: string, payout: string, selected: boolean, win: string, titleDisplayStrategy: BetDisplayOptions, ranges: Array<{ __typename?: 'BountyRange', bountyIncrement: string, bountyTimesAchievable: string, payout: string, payoutMultiplier: string, bountyRange: Array<{ __typename?: 'Range', title: string, type: string } | null> } | null> }
    | { __typename: 'SingleGameTeamOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, title: string, titleDisplayStrategy: BetDisplayOptions }
    | { __typename: 'SingleGameTeamParlayOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
  > };

export type TeammateBetRestrictionFragment = { __typename?: 'TeammateBetRestriction', userId: string, gameModeBetRestrictions: Array<{ __typename?: 'GameModeBetRestriction', gameMode: string, betRestrictions: Array<{ __typename?: 'BetRestriction', lockState: LockState, valueId: string }> }> };

export type TeamFragment = { __typename?: 'Team', id: string, updatedAt: any, matchMap: string, squadSize: number, serviceFee: string, gameSlug: string, betCategory: string, gameMode?: string | null, lines: Array<{ __typename?: 'BetLineItem', betType: BetType, category: string, cost: string, title: string, lineType: string, required: boolean, options: Array<
      | { __typename: 'MultiGameTeamParlayOption', id?: string | null, level: string, selected: boolean, failuresAllowed: number, successesRequired: number, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
      | { __typename: 'SingleGameTeamBountyOption', id?: string | null, level: string, payout: string, selected: boolean, win: string, titleDisplayStrategy: BetDisplayOptions, ranges: Array<{ __typename?: 'BountyRange', bountyIncrement: string, bountyTimesAchievable: string, payout: string, payoutMultiplier: string, bountyRange: Array<{ __typename?: 'Range', title: string, type: string } | null> } | null> }
      | { __typename: 'SingleGameTeamOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, title: string, titleDisplayStrategy: BetDisplayOptions }
      | { __typename: 'SingleGameTeamParlayOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
    > }>, teammateBetRestrictions: Array<{ __typename?: 'TeammateBetRestriction', userId: string, gameModeBetRestrictions: Array<{ __typename?: 'GameModeBetRestriction', gameMode: string, betRestrictions: Array<{ __typename?: 'BetRestriction', lockState: LockState, valueId: string }> }> }> };

export type UserBettingStatusFragment = { __typename?: 'UserBettingStatus', game: Games, status: UserBettingStatuses };

export type PlatformIdentifiersFragment = { __typename?: 'PlatformIdentifier', gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', twitchVodEnabled?: boolean | null, streamBitrate?: string | null, streamHeight?: number | null, streamQuality?: string | null, streamQualityUpdatedAt?: any | null, twitchStreamLiveStatus?: boolean | null, twitchOnboardingComplete?: boolean | null, twitchStreamLink?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null } | null };

export type UserFragment = { __typename?: 'User', id: string, loungeUsername?: string | null, loungeUsernameLastUpdatedAt?: any | null, activeTeam?: { __typename?: 'Team', id: string, updatedAt: any, matchMap: string, squadSize: number, serviceFee: string, gameSlug: string, betCategory: string, gameMode?: string | null, lines: Array<{ __typename?: 'BetLineItem', betType: BetType, category: string, cost: string, title: string, lineType: string, required: boolean, options: Array<
        | { __typename: 'MultiGameTeamParlayOption', id?: string | null, level: string, selected: boolean, failuresAllowed: number, successesRequired: number, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
        | { __typename: 'SingleGameTeamBountyOption', id?: string | null, level: string, payout: string, selected: boolean, win: string, titleDisplayStrategy: BetDisplayOptions, ranges: Array<{ __typename?: 'BountyRange', bountyIncrement: string, bountyTimesAchievable: string, payout: string, payoutMultiplier: string, bountyRange: Array<{ __typename?: 'Range', title: string, type: string } | null> } | null> }
        | { __typename: 'SingleGameTeamOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, title: string, titleDisplayStrategy: BetDisplayOptions }
        | { __typename: 'SingleGameTeamParlayOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
      > }>, teammateBetRestrictions: Array<{ __typename?: 'TeammateBetRestriction', userId: string, gameModeBetRestrictions: Array<{ __typename?: 'GameModeBetRestriction', gameMode: string, betRestrictions: Array<{ __typename?: 'BetRestriction', lockState: LockState, valueId: string }> }> }> } | null, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', twitchVodEnabled?: boolean | null, streamBitrate?: string | null, streamHeight?: number | null, streamQuality?: string | null, streamQualityUpdatedAt?: any | null, twitchStreamLiveStatus?: boolean | null, twitchOnboardingComplete?: boolean | null, twitchStreamLink?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null } | null } | null> | null, gamePlatformStatus: Array<{ __typename?: 'GamePlatformStatus', game: Games, platform: Platforms, status: PlatformBettingStatus, userIdentifier?: string | null, metadata: { __typename?: 'GamePlatformStatusMetadata', character?: string | null, killsBanner?: boolean | null, lastUpdatedAt?: string | null, topThreeBanner?: boolean | null, totalMatchesBanner?: boolean | null, lastUserFetch?: string | null, storedMatchCount?: string | null, betsPlaced?: number | null, betsSettled?: number | null, betsRefunded?: number | null, twitchRequired?: boolean | null, twitchAudioMuted?: boolean | null, fetchFailReason?: string | null, initialFetchState?: string | null, settledBetDenominationCounts?: { __typename?: 'SettledBetDenominationCounts', one?: number | null, three?: number | null, five?: number | null, ten?: number | null, twentyfive?: number | null, fifty?: number | null, onehundred?: number | null } | null } }>, userBettingStatus: Array<{ __typename?: 'UserBettingStatus', game: Games, status: UserBettingStatuses }>, referralCodes?: Array<{ __typename?: 'ReferralCode', active?: boolean | null, code?: string | null } | null> | null };

export type GetBetSlipByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBetSlipByIdQuery = { __typename?: 'RootQueryType', getBetSlip?: { __typename?: 'BetSlip', id: string, updatedAt: string, resolvedAt?: string | null, status: string, refundReason?: string | null, insertedAt: string, groupBetId?: string | null, betTotalAmount: string, payout?: string | null, serviceFee: string, user: { __typename?: 'User', id: string }, stakeOffer?: { __typename?: 'StakeOffer', id: string, status: string, maximumMultiplier: number, reward?: { __typename?: 'StakeOfferReward', id: string, rewards: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, orders?: Array<{ __typename?: 'StakeOrder', id: string, createdAt: string, payout?: { __typename?: 'StakeOrderPayout', payouts: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, user: { __typename?: 'User', loungeUsername?: string | null, id: string, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', id?: string | null, gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', id?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null, twitchStreamInfo?: { __typename?: 'StreamInfo', thumbnailUrl?: string | null } | null } | null } | null> | null }, fundingSource: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null> | null } | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, team?: { __typename?: 'Team', gameSlug: string } | null, betItems: Array<{ __typename?: 'BetItem', achievedMultiplier?: string | null, achievedValue?: string | null, percentageOfBet?: string | null, betAmount?: string | null, betType?: BetTypeEnum | null, currencyType?: string | null, matches?: any | null, gameSlug?: string | null, id: string, insertedAt?: string | null, level?: number | null, linesValue?: string | null, matchId?: string | null, payout?: string | null, payoutMultiplier?: string | null, refundCurrencyType?: string | null, refundReason?: string | null, refunded?: boolean | null, resolutionMethod?: string | null, resolved?: boolean | null, title?: string | null, type?: string | null, updatedAt?: string | null, won?: boolean | null, events?: Array<{ __typename?: 'BetItemEvent', event?: string | null, insertedAt?: string | null, updatedAt?: string | null } | null> | null, gameData?: { __typename?: 'GameData', apexLegend?: string | null, gameMode?: string | null, map?: string | null, squadSize?: number | null } | null, metadata: { __typename?: 'BetItemMetadata', specialRulesApplied?: Array<string | null> | null, singleGameParlay?: { __typename?: 'Parlay', id: string, legTypesTaken: Array<string | null>, numberOfLegs: number, won?: boolean | null } | null, singleGameBounty?: { __typename?: 'Bounty', ranges: Array<{ __typename?: 'BetItemRange', bountyIncrement: string, bountyTimesAchievable: string, payoutMultiplier?: string | null, bountyRange: Array<{ __typename?: 'BetItemBountyRange', linesValue: string, type: string } | null> } | null> } | null, multiGameParlay?: { __typename?: 'MultiGameParlay', failuresAllowed: number, successesRequired: number, legs: Array<{ __typename?: 'MultiGameParlayLeg', updatedAt: string, insertedAt: string, id: string, matchId?: string | null, order: number, status: MultiGameParlayStatusEnum, achievedValue: Array<{ __typename?: 'AchievedValue', metBetObjective: boolean, type: string, value: string }> }>, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> } | null, specialRules?: Array<{ __typename?: 'SpecialRules', id: string, systemId: string, ruleDisplay: Array<string> } | null> | null }, fundingSources?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, matchStats?: Array<
        | { __typename: 'Apex', legendUsed?: string | null, matchEndDate?: string | null, playerKills?: string | null, playerRankScoreChange?: string | null, playerTimesPlacedTopThree?: string | null }
        | { __typename: 'ArcRaiders' }
        | { __typename: 'Battlefield6' }
        | { __typename: 'Cfb25' }
        | { __typename: 'Chess' }
        | { __typename: 'ClashRoyale' }
        | { __typename: 'Codbo1' }
        | { __typename: 'Codbo2' }
        | { __typename: 'Codbo6' }
        | { __typename: 'Codbo7' }
        | { __typename: 'Codmw3' }
        | { __typename: 'Codmw4' }
        | { __typename: 'Codwz2' }
        | { __typename: 'Cs2' }
        | { __typename: 'Dota2' }
        | { __typename: 'Eafc25' }
        | { __typename: 'Eafc26' }
        | { __typename: 'Eafc27' }
        | { __typename: 'Fortnite' }
        | { __typename: 'Game2xko' }
        | { __typename: 'Gta5' }
        | { __typename: 'Gta6' }
        | { __typename: 'Gwent' }
        | { __typename: 'Hearthstone' }
        | { __typename: 'LeagueOfLegends' }
        | { __typename: 'Madden25' }
        | { __typename: 'Madden26' }
        | { __typename: 'Madden27' }
        | { __typename: 'MarvelRivals' }
        | { __typename: 'MarvelTokon' }
        | { __typename: 'Nba2k25' }
        | { __typename: 'Nba2k26' }
        | { __typename: 'Nba2k27' }
        | { __typename: 'R6Siege' }
        | { __typename: 'RocketLeague' }
        | { __typename: 'TeamfightTactics' }
        | { __typename: 'Valorant' }
        | { __typename: 'Wardogs' }
       | null> | null } | null> } | null };

export type InitialLoadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
}>;


export type InitialLoadQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, loungeUsername?: string | null, loungeUsernameLastUpdatedAt?: any | null, activeTeam?: { __typename?: 'Team', id: string, updatedAt: any, matchMap: string, squadSize: number, serviceFee: string, gameSlug: string, betCategory: string, gameMode?: string | null, lines: Array<{ __typename?: 'BetLineItem', betType: BetType, category: string, cost: string, title: string, lineType: string, required: boolean, options: Array<
          | { __typename: 'MultiGameTeamParlayOption', id?: string | null, level: string, selected: boolean, failuresAllowed: number, successesRequired: number, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
          | { __typename: 'SingleGameTeamBountyOption', id?: string | null, level: string, payout: string, selected: boolean, win: string, titleDisplayStrategy: BetDisplayOptions, ranges: Array<{ __typename?: 'BountyRange', bountyIncrement: string, bountyTimesAchievable: string, payout: string, payoutMultiplier: string, bountyRange: Array<{ __typename?: 'Range', title: string, type: string } | null> } | null> }
          | { __typename: 'SingleGameTeamOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, title: string, titleDisplayStrategy: BetDisplayOptions }
          | { __typename: 'SingleGameTeamParlayOption', id?: string | null, level: string, payout: string, payoutMultiplier: string, selected: boolean, win: string, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> }
        > }>, teammateBetRestrictions: Array<{ __typename?: 'TeammateBetRestriction', userId: string, gameModeBetRestrictions: Array<{ __typename?: 'GameModeBetRestriction', gameMode: string, betRestrictions: Array<{ __typename?: 'BetRestriction', lockState: LockState, valueId: string }> }> }> } | null, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', twitchVodEnabled?: boolean | null, streamBitrate?: string | null, streamHeight?: number | null, streamQuality?: string | null, streamQualityUpdatedAt?: any | null, twitchStreamLiveStatus?: boolean | null, twitchOnboardingComplete?: boolean | null, twitchStreamLink?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null } | null } | null> | null, gamePlatformStatus: Array<{ __typename?: 'GamePlatformStatus', game: Games, platform: Platforms, status: PlatformBettingStatus, userIdentifier?: string | null, metadata: { __typename?: 'GamePlatformStatusMetadata', character?: string | null, killsBanner?: boolean | null, lastUpdatedAt?: string | null, topThreeBanner?: boolean | null, totalMatchesBanner?: boolean | null, lastUserFetch?: string | null, storedMatchCount?: string | null, betsPlaced?: number | null, betsSettled?: number | null, betsRefunded?: number | null, twitchRequired?: boolean | null, twitchAudioMuted?: boolean | null, fetchFailReason?: string | null, initialFetchState?: string | null, settledBetDenominationCounts?: { __typename?: 'SettledBetDenominationCounts', one?: number | null, three?: number | null, five?: number | null, ten?: number | null, twentyfive?: number | null, fifty?: number | null, onehundred?: number | null } | null } }>, userBettingStatus: Array<{ __typename?: 'UserBettingStatus', game: Games, status: UserBettingStatuses }>, referralCodes?: Array<{ __typename?: 'ReferralCode', active?: boolean | null, code?: string | null } | null> | null }, getBetHistory?: { __typename?: 'BetHistoryResponse', betSlips?: Array<{ __typename?: 'BetSlip', id: string, updatedAt: string, resolvedAt?: string | null, status: string, refundReason?: string | null, insertedAt: string, groupBetId?: string | null, betTotalAmount: string, payout?: string | null, serviceFee: string, user: { __typename?: 'User', id: string }, stakeOffer?: { __typename?: 'StakeOffer', id: string, status: string, maximumMultiplier: number, reward?: { __typename?: 'StakeOfferReward', id: string, rewards: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, orders?: Array<{ __typename?: 'StakeOrder', id: string, createdAt: string, payout?: { __typename?: 'StakeOrderPayout', payouts: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, user: { __typename?: 'User', loungeUsername?: string | null, id: string, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', id?: string | null, gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', id?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null, twitchStreamInfo?: { __typename?: 'StreamInfo', thumbnailUrl?: string | null } | null } | null } | null> | null }, fundingSource: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null> | null } | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, team?: { __typename?: 'Team', gameSlug: string } | null, betItems: Array<{ __typename?: 'BetItem', achievedMultiplier?: string | null, achievedValue?: string | null, percentageOfBet?: string | null, betAmount?: string | null, betType?: BetTypeEnum | null, currencyType?: string | null, matches?: any | null, gameSlug?: string | null, id: string, insertedAt?: string | null, level?: number | null, linesValue?: string | null, matchId?: string | null, payout?: string | null, payoutMultiplier?: string | null, refundCurrencyType?: string | null, refundReason?: string | null, refunded?: boolean | null, resolutionMethod?: string | null, resolved?: boolean | null, title?: string | null, type?: string | null, updatedAt?: string | null, won?: boolean | null, events?: Array<{ __typename?: 'BetItemEvent', event?: string | null, insertedAt?: string | null, updatedAt?: string | null } | null> | null, gameData?: { __typename?: 'GameData', apexLegend?: string | null, gameMode?: string | null, map?: string | null, squadSize?: number | null } | null, metadata: { __typename?: 'BetItemMetadata', specialRulesApplied?: Array<string | null> | null, singleGameParlay?: { __typename?: 'Parlay', id: string, legTypesTaken: Array<string | null>, numberOfLegs: number, won?: boolean | null } | null, singleGameBounty?: { __typename?: 'Bounty', ranges: Array<{ __typename?: 'BetItemRange', bountyIncrement: string, bountyTimesAchievable: string, payoutMultiplier?: string | null, bountyRange: Array<{ __typename?: 'BetItemBountyRange', linesValue: string, type: string } | null> } | null> } | null, multiGameParlay?: { __typename?: 'MultiGameParlay', failuresAllowed: number, successesRequired: number, legs: Array<{ __typename?: 'MultiGameParlayLeg', updatedAt: string, insertedAt: string, id: string, matchId?: string | null, order: number, status: MultiGameParlayStatusEnum, achievedValue: Array<{ __typename?: 'AchievedValue', metBetObjective: boolean, type: string, value: string }> }>, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> } | null, specialRules?: Array<{ __typename?: 'SpecialRules', id: string, systemId: string, ruleDisplay: Array<string> } | null> | null }, fundingSources?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, matchStats?: Array<
          | { __typename: 'Apex', legendUsed?: string | null, matchEndDate?: string | null, playerKills?: string | null, playerRankScoreChange?: string | null, playerTimesPlacedTopThree?: string | null }
          | { __typename: 'ArcRaiders' }
          | { __typename: 'Battlefield6' }
          | { __typename: 'Cfb25' }
          | { __typename: 'Chess' }
          | { __typename: 'ClashRoyale' }
          | { __typename: 'Codbo1' }
          | { __typename: 'Codbo2' }
          | { __typename: 'Codbo6' }
          | { __typename: 'Codbo7' }
          | { __typename: 'Codmw3' }
          | { __typename: 'Codmw4' }
          | { __typename: 'Codwz2' }
          | { __typename: 'Cs2' }
          | { __typename: 'Dota2' }
          | { __typename: 'Eafc25' }
          | { __typename: 'Eafc26' }
          | { __typename: 'Eafc27' }
          | { __typename: 'Fortnite' }
          | { __typename: 'Game2xko' }
          | { __typename: 'Gta5' }
          | { __typename: 'Gta6' }
          | { __typename: 'Gwent' }
          | { __typename: 'Hearthstone' }
          | { __typename: 'LeagueOfLegends' }
          | { __typename: 'Madden25' }
          | { __typename: 'Madden26' }
          | { __typename: 'Madden27' }
          | { __typename: 'MarvelRivals' }
          | { __typename: 'MarvelTokon' }
          | { __typename: 'Nba2k25' }
          | { __typename: 'Nba2k26' }
          | { __typename: 'Nba2k27' }
          | { __typename: 'R6Siege' }
          | { __typename: 'RocketLeague' }
          | { __typename: 'TeamfightTactics' }
          | { __typename: 'Valorant' }
          | { __typename: 'Wardogs' }
         | null> | null } | null> } | null> | null, metaData: { __typename?: 'PaginationDetails', page?: number | null, take?: number | null, pageCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null, pendingBets?: { __typename?: 'BetHistoryResponse', betSlips?: Array<{ __typename?: 'BetSlip', id: string, updatedAt: string, resolvedAt?: string | null, status: string, refundReason?: string | null, insertedAt: string, groupBetId?: string | null, betTotalAmount: string, payout?: string | null, serviceFee: string, user: { __typename?: 'User', id: string }, stakeOffer?: { __typename?: 'StakeOffer', id: string, status: string, maximumMultiplier: number, reward?: { __typename?: 'StakeOfferReward', id: string, rewards: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, orders?: Array<{ __typename?: 'StakeOrder', id: string, createdAt: string, payout?: { __typename?: 'StakeOrderPayout', payouts: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null, user: { __typename?: 'User', loungeUsername?: string | null, id: string, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', id?: string | null, gamerTag?: string | null, platform?: Platforms | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', id?: string | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null, twitchStreamInfo?: { __typename?: 'StreamInfo', thumbnailUrl?: string | null } | null } | null } | null> | null }, fundingSource: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> } | null> | null } | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, team?: { __typename?: 'Team', gameSlug: string } | null, betItems: Array<{ __typename?: 'BetItem', achievedMultiplier?: string | null, achievedValue?: string | null, percentageOfBet?: string | null, betAmount?: string | null, betType?: BetTypeEnum | null, currencyType?: string | null, matches?: any | null, gameSlug?: string | null, id: string, insertedAt?: string | null, level?: number | null, linesValue?: string | null, matchId?: string | null, payout?: string | null, payoutMultiplier?: string | null, refundCurrencyType?: string | null, refundReason?: string | null, refunded?: boolean | null, resolutionMethod?: string | null, resolved?: boolean | null, title?: string | null, type?: string | null, updatedAt?: string | null, won?: boolean | null, events?: Array<{ __typename?: 'BetItemEvent', event?: string | null, insertedAt?: string | null, updatedAt?: string | null } | null> | null, gameData?: { __typename?: 'GameData', apexLegend?: string | null, gameMode?: string | null, map?: string | null, squadSize?: number | null } | null, metadata: { __typename?: 'BetItemMetadata', specialRulesApplied?: Array<string | null> | null, singleGameParlay?: { __typename?: 'Parlay', id: string, legTypesTaken: Array<string | null>, numberOfLegs: number, won?: boolean | null } | null, singleGameBounty?: { __typename?: 'Bounty', ranges: Array<{ __typename?: 'BetItemRange', bountyIncrement: string, bountyTimesAchievable: string, payoutMultiplier?: string | null, bountyRange: Array<{ __typename?: 'BetItemBountyRange', linesValue: string, type: string } | null> } | null> } | null, multiGameParlay?: { __typename?: 'MultiGameParlay', failuresAllowed: number, successesRequired: number, legs: Array<{ __typename?: 'MultiGameParlayLeg', updatedAt: string, insertedAt: string, id: string, matchId?: string | null, order: number, status: MultiGameParlayStatusEnum, achievedValue: Array<{ __typename?: 'AchievedValue', metBetObjective: boolean, type: string, value: string }> }>, payouts: Array<{ __typename?: 'MultiGameTeamPayout', payout: string, payoutMultiplier: string, win: string, requirements: Array<{ __typename?: 'MultiGameTeamPayoutRequirements', goal: number, requirement: string }> }>, requirements: Array<{ __typename?: 'ParlayBetItem', lineType: string, title: string, titleDisplayStrategy: BetDisplayOptions }> } | null, specialRules?: Array<{ __typename?: 'SpecialRules', id: string, systemId: string, ruleDisplay: Array<string> } | null> | null }, fundingSources?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, payoutAmounts?: Array<{ __typename?: 'Financials', amount: any, wallet: BalanceType } | null> | null, matchStats?: Array<
          | { __typename: 'Apex', legendUsed?: string | null, matchEndDate?: string | null, playerKills?: string | null, playerRankScoreChange?: string | null, playerTimesPlacedTopThree?: string | null }
          | { __typename: 'ArcRaiders' }
          | { __typename: 'Battlefield6' }
          | { __typename: 'Cfb25' }
          | { __typename: 'Chess' }
          | { __typename: 'ClashRoyale' }
          | { __typename: 'Codbo1' }
          | { __typename: 'Codbo2' }
          | { __typename: 'Codbo6' }
          | { __typename: 'Codbo7' }
          | { __typename: 'Codmw3' }
          | { __typename: 'Codmw4' }
          | { __typename: 'Codwz2' }
          | { __typename: 'Cs2' }
          | { __typename: 'Dota2' }
          | { __typename: 'Eafc25' }
          | { __typename: 'Eafc26' }
          | { __typename: 'Eafc27' }
          | { __typename: 'Fortnite' }
          | { __typename: 'Game2xko' }
          | { __typename: 'Gta5' }
          | { __typename: 'Gta6' }
          | { __typename: 'Gwent' }
          | { __typename: 'Hearthstone' }
          | { __typename: 'LeagueOfLegends' }
          | { __typename: 'Madden25' }
          | { __typename: 'Madden26' }
          | { __typename: 'Madden27' }
          | { __typename: 'MarvelRivals' }
          | { __typename: 'MarvelTokon' }
          | { __typename: 'Nba2k25' }
          | { __typename: 'Nba2k26' }
          | { __typename: 'Nba2k27' }
          | { __typename: 'R6Siege' }
          | { __typename: 'RocketLeague' }
          | { __typename: 'TeamfightTactics' }
          | { __typename: 'Valorant' }
          | { __typename: 'Wardogs' }
         | null> | null } | null> } | null> | null } | null };

export type LookupUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LookupUserQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, loungeUsername?: string | null, platformIdentifiers?: Array<{ __typename?: 'PlatformIdentifier', platform?: Platforms | null, gamerTag?: string | null, metadata?: { __typename?: 'PlatformIdentifierMetadata', twitchStreamLink?: string | null, twitchStreamLiveStatus?: boolean | null, twitchProfile?: { __typename?: 'TwitchProfileInfo', profileImageUrl?: string | null } | null } | null } | null> | null } };
